!(function (e, t) {
  "use strict";
  "object" == typeof module && "object" == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document)
              throw new Error("jQuery requires a window with a document");
            return t(e);
          })
    : t(e);
})("undefined" != typeof window ? window : this, function (x, e) {
  "use strict";
  function g(e) {
    return "function" == typeof e && "number" != typeof e.nodeType;
  }
  function v(e) {
    return null != e && e === e.window;
  }
  var t = [],
    T = x.document,
    i = Object.getPrototypeOf,
    a = t.slice,
    m = t.concat,
    l = t.push,
    o = t.indexOf,
    n = {},
    r = n.toString,
    y = n.hasOwnProperty,
    s = y.toString,
    c = s.call(Object),
    w = {},
    d = { type: !0, src: !0, noModule: !0 };
  function b(e, t, i) {
    var n,
      o = (t = t || T).createElement("script");
    if (((o.text = e), i)) for (n in d) i[n] && (o[n] = i[n]);
    t.head.appendChild(o).parentNode.removeChild(o);
  }
  function h(e) {
    return null == e
      ? e + ""
      : "object" == typeof e || "function" == typeof e
      ? n[r.call(e)] || "object"
      : typeof e;
  }
  var C = function (e, t) {
      return new C.fn.init(e, t);
    },
    u = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  function p(e) {
    var t = !!e && "length" in e && e.length,
      i = h(e);
    return (
      !g(e) &&
      !v(e) &&
      ("array" === i ||
        0 === t ||
        ("number" == typeof t && 0 < t && t - 1 in e))
    );
  }
  (C.fn = C.prototype =
    {
      jquery: "3.3.1",
      constructor: C,
      length: 0,
      toArray: function () {
        return a.call(this);
      },
      get: function (e) {
        return null == e
          ? a.call(this)
          : e < 0
          ? this[e + this.length]
          : this[e];
      },
      pushStack: function (e) {
        e = C.merge(this.constructor(), e);
        return (e.prevObject = this), e;
      },
      each: function (e) {
        return C.each(this, e);
      },
      map: function (i) {
        return this.pushStack(
          C.map(this, function (e, t) {
            return i.call(e, t, e);
          })
        );
      },
      slice: function () {
        return this.pushStack(a.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      eq: function (e) {
        var t = this.length,
          e = +e + (e < 0 ? t : 0);
        return this.pushStack(0 <= e && e < t ? [this[e]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: l,
      sort: t.sort,
      splice: t.splice,
    }),
    (C.extend = C.fn.extend =
      function () {
        var e,
          t,
          i,
          n,
          o,
          r = arguments[0] || {},
          s = 1,
          a = arguments.length,
          l = !1;
        for (
          "boolean" == typeof r && ((l = r), (r = arguments[s] || {}), s++),
            "object" == typeof r || g(r) || (r = {}),
            s === a && ((r = this), s--);
          s < a;
          s++
        )
          if (null != (e = arguments[s]))
            for (t in e)
              (o = r[t]),
                r !== (i = e[t]) &&
                  (l && i && (C.isPlainObject(i) || (n = Array.isArray(i)))
                    ? ((o = n
                        ? ((n = !1), o && Array.isArray(o) ? o : [])
                        : o && C.isPlainObject(o)
                        ? o
                        : {}),
                      (r[t] = C.extend(l, o, i)))
                    : void 0 !== i && (r[t] = i));
        return r;
      }),
    C.extend({
      expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        return !(
          !e ||
          "[object Object]" !== r.call(e) ||
          ((e = i(e)) &&
            ("function" !=
              typeof (e = y.call(e, "constructor") && e.constructor) ||
              s.call(e) !== c))
        );
      },
      isEmptyObject: function (e) {
        for (var t in e) return !1;
        return !0;
      },
      globalEval: function (e) {
        b(e);
      },
      each: function (e, t) {
        var i,
          n = 0;
        if (p(e))
          for (i = e.length; n < i && !1 !== t.call(e[n], n, e[n]); n++);
        else for (n in e) if (!1 === t.call(e[n], n, e[n])) break;
        return e;
      },
      trim: function (e) {
        return null == e ? "" : (e + "").replace(u, "");
      },
      makeArray: function (e, t) {
        t = t || [];
        return (
          null != e &&
            (p(Object(e))
              ? C.merge(t, "string" == typeof e ? [e] : e)
              : l.call(t, e)),
          t
        );
      },
      inArray: function (e, t, i) {
        return null == t ? -1 : o.call(t, e, i);
      },
      merge: function (e, t) {
        for (var i = +t.length, n = 0, o = e.length; n < i; n++) e[o++] = t[n];
        return (e.length = o), e;
      },
      grep: function (e, t, i) {
        for (var n = [], o = 0, r = e.length, s = !i; o < r; o++)
          !t(e[o], o) != s && n.push(e[o]);
        return n;
      },
      map: function (e, t, i) {
        var n,
          o,
          r = 0,
          s = [];
        if (p(e))
          for (n = e.length; r < n; r++)
            null != (o = t(e[r], r, i)) && s.push(o);
        else for (r in e) null != (o = t(e[r], r, i)) && s.push(o);
        return m.apply([], s);
      },
      guid: 1,
      support: w,
    }),
    "function" == typeof Symbol && (C.fn[Symbol.iterator] = t[Symbol.iterator]),
    C.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (e, t) {
        n["[object " + t + "]"] = t.toLowerCase();
      }
    );
  var f = (function (i) {
    function u(e, t, i) {
      var n = "0x" + t - 65536;
      return n != n || i
        ? t
        : n < 0
        ? String.fromCharCode(65536 + n)
        : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320);
    }
    function f(e, t) {
      return t
        ? "\0" === e
          ? "�"
          : e.slice(0, -1) +
            "\\" +
            e.charCodeAt(e.length - 1).toString(16) +
            " "
        : "\\" + e;
    }
    function n() {
      x();
    }
    var e,
      h,
      b,
      r,
      o,
      g,
      p,
      v,
      k,
      l,
      c,
      x,
      T,
      s,
      C,
      m,
      a,
      d,
      y,
      S = "sizzle" + +new Date(),
      w = i.document,
      A = 0,
      E = 0,
      $ = se(),
      z = se(),
      D = se(),
      L = function (e, t) {
        return e === t && (c = !0), 0;
      },
      N = {}.hasOwnProperty,
      t = [],
      j = t.pop,
      H = t.push,
      O = t.push,
      P = t.slice,
      M = function (e, t) {
        for (var i = 0, n = e.length; i < n; i++) if (e[i] === t) return i;
        return -1;
      },
      q =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      W = "[\\x20\\t\\r\\n\\f]",
      I = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
      _ =
        "\\[" +
        W +
        "*(" +
        I +
        ")(?:" +
        W +
        "*([*^$|!~]?=)" +
        W +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        I +
        "))|)" +
        W +
        "*\\]",
      F =
        ":(" +
        I +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        _ +
        ")*)|.*)\\)|)",
      R = new RegExp(W + "+", "g"),
      B = new RegExp("^" + W + "+|((?:^|[^\\\\])(?:\\\\.)*)" + W + "+$", "g"),
      U = new RegExp("^" + W + "*," + W + "*"),
      X = new RegExp("^" + W + "*([>+~]|" + W + ")" + W + "*"),
      Y = new RegExp("=" + W + "*([^\\]'\"]*?)" + W + "*\\]", "g"),
      Q = new RegExp(F),
      V = new RegExp("^" + I + "$"),
      G = {
        ID: new RegExp("^#(" + I + ")"),
        CLASS: new RegExp("^\\.(" + I + ")"),
        TAG: new RegExp("^(" + I + "|[*])"),
        ATTR: new RegExp("^" + _),
        PSEUDO: new RegExp("^" + F),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            W +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            W +
            "*(?:([+-]|)" +
            W +
            "*(\\d+)|))" +
            W +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + q + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            W +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            W +
            "*((?:-\\d)?\\d*)" +
            W +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      },
      J = /^(?:input|select|textarea|button)$/i,
      K = /^h\d$/i,
      Z = /^[^{]+\{\s*\[native \w/,
      ee = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      te = /[+~]/,
      ie = new RegExp("\\\\([\\da-f]{1,6}" + W + "?|(" + W + ")|.)", "ig"),
      ne = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      oe = ve(
        function (e) {
          return !0 === e.disabled && ("form" in e || "label" in e);
        },
        { dir: "parentNode", next: "legend" }
      );
    try {
      O.apply((t = P.call(w.childNodes)), w.childNodes),
        t[w.childNodes.length].nodeType;
    } catch (i) {
      O = {
        apply: t.length
          ? function (e, t) {
              H.apply(e, P.call(t));
            }
          : function (e, t) {
              for (var i = e.length, n = 0; (e[i++] = t[n++]); );
              e.length = i - 1;
            },
      };
    }
    function re(e, t, i, n) {
      var o,
        r,
        s,
        a,
        l,
        c,
        d,
        u = t && t.ownerDocument,
        p = t ? t.nodeType : 9;
      if (
        ((i = i || []),
        "string" != typeof e || !e || (1 !== p && 9 !== p && 11 !== p))
      )
        return i;
      if (
        !n &&
        ((t ? t.ownerDocument || t : w) !== T && x(t), (t = t || T), C)
      ) {
        if (11 !== p && (l = ee.exec(e)))
          if ((o = l[1])) {
            if (9 === p) {
              if (!(s = t.getElementById(o))) return i;
              if (s.id === o) return i.push(s), i;
            } else if (u && (s = u.getElementById(o)) && y(t, s) && s.id === o)
              return i.push(s), i;
          } else {
            if (l[2]) return O.apply(i, t.getElementsByTagName(e)), i;
            if (
              (o = l[3]) &&
              h.getElementsByClassName &&
              t.getElementsByClassName
            )
              return O.apply(i, t.getElementsByClassName(o)), i;
          }
        if (h.qsa && !D[e + " "] && (!m || !m.test(e))) {
          if (1 !== p) (u = t), (d = e);
          else if ("object" !== t.nodeName.toLowerCase()) {
            for (
              (a = t.getAttribute("id"))
                ? (a = a.replace(ne, f))
                : t.setAttribute("id", (a = S)),
                r = (c = g(e)).length;
              r--;

            )
              c[r] = "#" + a + " " + ge(c[r]);
            (d = c.join(",")), (u = (te.test(e) && fe(t.parentNode)) || t);
          }
          if (d)
            try {
              return O.apply(i, u.querySelectorAll(d)), i;
            } catch (e) {
            } finally {
              a === S && t.removeAttribute("id");
            }
        }
      }
      return v(e.replace(B, "$1"), t, i, n);
    }
    function se() {
      var i = [];
      function n(e, t) {
        return (
          i.push(e + " ") > b.cacheLength && delete n[i.shift()],
          (n[e + " "] = t)
        );
      }
      return n;
    }
    function ae(e) {
      return (e[S] = !0), e;
    }
    function le(e) {
      var t = T.createElement("fieldset");
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t);
      }
    }
    function ce(e, t) {
      for (var i = e.split("|"), n = i.length; n--; ) b.attrHandle[i[n]] = t;
    }
    function de(e, t) {
      var i = t && e,
        n =
          i &&
          1 === e.nodeType &&
          1 === t.nodeType &&
          e.sourceIndex - t.sourceIndex;
      if (n) return n;
      if (i) for (; (i = i.nextSibling); ) if (i === t) return -1;
      return e ? 1 : -1;
    }
    function ue(t) {
      return function (e) {
        return "form" in e
          ? e.parentNode && !1 === e.disabled
            ? "label" in e
              ? "label" in e.parentNode
                ? e.parentNode.disabled === t
                : e.disabled === t
              : e.isDisabled === t || (e.isDisabled !== !t && oe(e) === t)
            : e.disabled === t
          : "label" in e && e.disabled === t;
      };
    }
    function pe(s) {
      return ae(function (r) {
        return (
          (r = +r),
          ae(function (e, t) {
            for (var i, n = s([], e.length, r), o = n.length; o--; )
              e[(i = n[o])] && (e[i] = !(t[i] = e[i]));
          })
        );
      });
    }
    function fe(e) {
      return e && void 0 !== e.getElementsByTagName && e;
    }
    for (e in ((h = re.support = {}),
    (o = re.isXML =
      function (e) {
        e = e && (e.ownerDocument || e).documentElement;
        return !!e && "HTML" !== e.nodeName;
      }),
    (x = re.setDocument =
      function (e) {
        var t,
          e = e ? e.ownerDocument || e : w;
        return (
          e !== T &&
            9 === e.nodeType &&
            e.documentElement &&
            ((s = (T = e).documentElement),
            (C = !o(T)),
            w !== T &&
              (t = T.defaultView) &&
              t.top !== t &&
              (t.addEventListener
                ? t.addEventListener("unload", n, !1)
                : t.attachEvent && t.attachEvent("onunload", n)),
            (h.attributes = le(function (e) {
              return (e.className = "i"), !e.getAttribute("className");
            })),
            (h.getElementsByTagName = le(function (e) {
              return (
                e.appendChild(T.createComment("")),
                !e.getElementsByTagName("*").length
              );
            })),
            (h.getElementsByClassName = Z.test(T.getElementsByClassName)),
            (h.getById = le(function (e) {
              return (
                (s.appendChild(e).id = S),
                !T.getElementsByName || !T.getElementsByName(S).length
              );
            })),
            h.getById
              ? ((b.filter.ID = function (e) {
                  var t = e.replace(ie, u);
                  return function (e) {
                    return e.getAttribute("id") === t;
                  };
                }),
                (b.find.ID = function (e, t) {
                  if (void 0 !== t.getElementById && C) {
                    e = t.getElementById(e);
                    return e ? [e] : [];
                  }
                }))
              : ((b.filter.ID = function (e) {
                  var t = e.replace(ie, u);
                  return function (e) {
                    e =
                      void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                    return e && e.value === t;
                  };
                }),
                (b.find.ID = function (e, t) {
                  if (void 0 !== t.getElementById && C) {
                    var i,
                      n,
                      o,
                      r = t.getElementById(e);
                    if (r) {
                      if ((i = r.getAttributeNode("id")) && i.value === e)
                        return [r];
                      for (o = t.getElementsByName(e), n = 0; (r = o[n++]); )
                        if ((i = r.getAttributeNode("id")) && i.value === e)
                          return [r];
                    }
                    return [];
                  }
                })),
            (b.find.TAG = h.getElementsByTagName
              ? function (e, t) {
                  return void 0 !== t.getElementsByTagName
                    ? t.getElementsByTagName(e)
                    : h.qsa
                    ? t.querySelectorAll(e)
                    : void 0;
                }
              : function (e, t) {
                  var i,
                    n = [],
                    o = 0,
                    r = t.getElementsByTagName(e);
                  if ("*" !== e) return r;
                  for (; (i = r[o++]); ) 1 === i.nodeType && n.push(i);
                  return n;
                }),
            (b.find.CLASS =
              h.getElementsByClassName &&
              function (e, t) {
                if (void 0 !== t.getElementsByClassName && C)
                  return t.getElementsByClassName(e);
              }),
            (a = []),
            (m = []),
            (h.qsa = Z.test(T.querySelectorAll)) &&
              (le(function (e) {
                (s.appendChild(e).innerHTML =
                  "<a id='" +
                  S +
                  "'></a><select id='" +
                  S +
                  "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                  e.querySelectorAll("[msallowcapture^='']").length &&
                    m.push("[*^$]=" + W + "*(?:''|\"\")"),
                  e.querySelectorAll("[selected]").length ||
                    m.push("\\[" + W + "*(?:value|" + q + ")"),
                  e.querySelectorAll("[id~=" + S + "-]").length || m.push("~="),
                  e.querySelectorAll(":checked").length || m.push(":checked"),
                  e.querySelectorAll("a#" + S + "+*").length ||
                    m.push(".#.+[+~]");
              }),
              le(function (e) {
                e.innerHTML =
                  "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = T.createElement("input");
                t.setAttribute("type", "hidden"),
                  e.appendChild(t).setAttribute("name", "D"),
                  e.querySelectorAll("[name=d]").length &&
                    m.push("name" + W + "*[*^$|!~]?="),
                  2 !== e.querySelectorAll(":enabled").length &&
                    m.push(":enabled", ":disabled"),
                  (s.appendChild(e).disabled = !0),
                  2 !== e.querySelectorAll(":disabled").length &&
                    m.push(":enabled", ":disabled"),
                  e.querySelectorAll("*,:x"),
                  m.push(",.*:");
              })),
            (h.matchesSelector = Z.test(
              (d =
                s.matches ||
                s.webkitMatchesSelector ||
                s.mozMatchesSelector ||
                s.oMatchesSelector ||
                s.msMatchesSelector)
            )) &&
              le(function (e) {
                (h.disconnectedMatch = d.call(e, "*")),
                  d.call(e, "[s!='']:x"),
                  a.push("!=", F);
              }),
            (m = m.length && new RegExp(m.join("|"))),
            (a = a.length && new RegExp(a.join("|"))),
            (t = Z.test(s.compareDocumentPosition)),
            (y =
              t || Z.test(s.contains)
                ? function (e, t) {
                    var i = 9 === e.nodeType ? e.documentElement : e,
                      t = t && t.parentNode;
                    return (
                      e === t ||
                      !(
                        !t ||
                        1 !== t.nodeType ||
                        !(i.contains
                          ? i.contains(t)
                          : e.compareDocumentPosition &&
                            16 & e.compareDocumentPosition(t))
                      )
                    );
                  }
                : function (e, t) {
                    if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                    return !1;
                  }),
            (L = t
              ? function (e, t) {
                  return e === t
                    ? ((c = !0), 0)
                    : (i =
                        !e.compareDocumentPosition -
                        !t.compareDocumentPosition) ||
                        (1 &
                          (i =
                            (e.ownerDocument || e) === (t.ownerDocument || t)
                              ? e.compareDocumentPosition(t)
                              : 1) ||
                        (!h.sortDetached && t.compareDocumentPosition(e) === i)
                          ? e === T || (e.ownerDocument === w && y(w, e))
                            ? -1
                            : t === T || (t.ownerDocument === w && y(w, t))
                            ? 1
                            : l
                            ? M(l, e) - M(l, t)
                            : 0
                          : 4 & i
                          ? -1
                          : 1);
                  var i;
                }
              : function (e, t) {
                  if (e === t) return (c = !0), 0;
                  var i,
                    n = 0,
                    o = e.parentNode,
                    r = t.parentNode,
                    s = [e],
                    a = [t];
                  if (!o || !r)
                    return e === T
                      ? -1
                      : t === T
                      ? 1
                      : o
                      ? -1
                      : r
                      ? 1
                      : l
                      ? M(l, e) - M(l, t)
                      : 0;
                  if (o === r) return de(e, t);
                  for (i = e; (i = i.parentNode); ) s.unshift(i);
                  for (i = t; (i = i.parentNode); ) a.unshift(i);
                  for (; s[n] === a[n]; ) n++;
                  return n
                    ? de(s[n], a[n])
                    : s[n] === w
                    ? -1
                    : a[n] === w
                    ? 1
                    : 0;
                })),
          T
        );
      }),
    (re.matches = function (e, t) {
      return re(e, null, null, t);
    }),
    (re.matchesSelector = function (e, t) {
      if (
        ((e.ownerDocument || e) !== T && x(e),
        (t = t.replace(Y, "='$1']")),
        h.matchesSelector &&
          C &&
          !D[t + " "] &&
          (!a || !a.test(t)) &&
          (!m || !m.test(t)))
      )
        try {
          var i = d.call(e, t);
          if (
            i ||
            h.disconnectedMatch ||
            (e.document && 11 !== e.document.nodeType)
          )
            return i;
        } catch (e) {}
      return 0 < re(t, T, null, [e]).length;
    }),
    (re.contains = function (e, t) {
      return (e.ownerDocument || e) !== T && x(e), y(e, t);
    }),
    (re.attr = function (e, t) {
      (e.ownerDocument || e) !== T && x(e);
      var i = b.attrHandle[t.toLowerCase()],
        i = i && N.call(b.attrHandle, t.toLowerCase()) ? i(e, t, !C) : void 0;
      return void 0 !== i
        ? i
        : h.attributes || !C
        ? e.getAttribute(t)
        : (i = e.getAttributeNode(t)) && i.specified
        ? i.value
        : null;
    }),
    (re.escape = function (e) {
      return (e + "").replace(ne, f);
    }),
    (re.error = function (e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }),
    (re.uniqueSort = function (e) {
      var t,
        i = [],
        n = 0,
        o = 0;
      if (
        ((c = !h.detectDuplicates),
        (l = !h.sortStable && e.slice(0)),
        e.sort(L),
        c)
      ) {
        for (; (t = e[o++]); ) t === e[o] && (n = i.push(o));
        for (; n--; ) e.splice(i[n], 1);
      }
      return (l = null), e;
    }),
    (r = re.getText =
      function (e) {
        var t,
          i = "",
          n = 0,
          o = e.nodeType;
        if (o) {
          if (1 === o || 9 === o || 11 === o) {
            if ("string" == typeof e.textContent) return e.textContent;
            for (e = e.firstChild; e; e = e.nextSibling) i += r(e);
          } else if (3 === o || 4 === o) return e.nodeValue;
        } else for (; (t = e[n++]); ) i += r(t);
        return i;
      }),
    ((b = re.selectors =
      {
        cacheLength: 50,
        createPseudo: ae,
        match: G,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" },
        },
        preFilter: {
          ATTR: function (e) {
            return (
              (e[1] = e[1].replace(ie, u)),
              (e[3] = (e[3] || e[4] || e[5] || "").replace(ie, u)),
              "~=" === e[2] && (e[3] = " " + e[3] + " "),
              e.slice(0, 4)
            );
          },
          CHILD: function (e) {
            return (
              (e[1] = e[1].toLowerCase()),
              "nth" === e[1].slice(0, 3)
                ? (e[3] || re.error(e[0]),
                  (e[4] = +(e[4]
                    ? e[5] + (e[6] || 1)
                    : 2 * ("even" === e[3] || "odd" === e[3]))),
                  (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                : e[3] && re.error(e[0]),
              e
            );
          },
          PSEUDO: function (e) {
            var t,
              i = !e[6] && e[2];
            return G.CHILD.test(e[0])
              ? null
              : (e[3]
                  ? (e[2] = e[4] || e[5] || "")
                  : i &&
                    Q.test(i) &&
                    (t = g(i, !0)) &&
                    (t = i.indexOf(")", i.length - t) - i.length) &&
                    ((e[0] = e[0].slice(0, t)), (e[2] = i.slice(0, t))),
                e.slice(0, 3));
          },
        },
        filter: {
          TAG: function (e) {
            var t = e.replace(ie, u).toLowerCase();
            return "*" === e
              ? function () {
                  return !0;
                }
              : function (e) {
                  return e.nodeName && e.nodeName.toLowerCase() === t;
                };
          },
          CLASS: function (e) {
            var t = $[e + " "];
            return (
              t ||
              ((t = new RegExp("(^|" + W + ")" + e + "(" + W + "|$)")) &&
                $(e, function (e) {
                  return t.test(
                    ("string" == typeof e.className && e.className) ||
                      (void 0 !== e.getAttribute && e.getAttribute("class")) ||
                      ""
                  );
                }))
            );
          },
          ATTR: function (t, i, n) {
            return function (e) {
              e = re.attr(e, t);
              return null == e
                ? "!=" === i
                : !i ||
                    ((e += ""),
                    "=" === i
                      ? e === n
                      : "!=" === i
                      ? e !== n
                      : "^=" === i
                      ? n && 0 === e.indexOf(n)
                      : "*=" === i
                      ? n && -1 < e.indexOf(n)
                      : "$=" === i
                      ? n && e.slice(-n.length) === n
                      : "~=" === i
                      ? -1 < (" " + e.replace(R, " ") + " ").indexOf(n)
                      : "|=" === i &&
                        (e === n || e.slice(0, n.length + 1) === n + "-"));
            };
          },
          CHILD: function (h, e, t, g, v) {
            var m = "nth" !== h.slice(0, 3),
              y = "last" !== h.slice(-4),
              w = "of-type" === e;
            return 1 === g && 0 === v
              ? function (e) {
                  return !!e.parentNode;
                }
              : function (e, t, i) {
                  var n,
                    o,
                    r,
                    s,
                    a,
                    l,
                    c = m != y ? "nextSibling" : "previousSibling",
                    d = e.parentNode,
                    u = w && e.nodeName.toLowerCase(),
                    p = !i && !w,
                    f = !1;
                  if (d) {
                    if (m) {
                      for (; c; ) {
                        for (s = e; (s = s[c]); )
                          if (
                            w
                              ? s.nodeName.toLowerCase() === u
                              : 1 === s.nodeType
                          )
                            return !1;
                        l = c = "only" === h && !l && "nextSibling";
                      }
                      return !0;
                    }
                    if (((l = [y ? d.firstChild : d.lastChild]), y && p)) {
                      for (
                        f =
                          (a =
                            (n =
                              (o =
                                (r = (s = d)[S] || (s[S] = {}))[s.uniqueID] ||
                                (r[s.uniqueID] = {}))[h] || [])[0] === A &&
                            n[1]) && n[2],
                          s = a && d.childNodes[a];
                        (s = (++a && s && s[c]) || (f = a = 0) || l.pop());

                      )
                        if (1 === s.nodeType && ++f && s === e) {
                          o[h] = [A, a, f];
                          break;
                        }
                    } else if (
                      !1 ===
                      (f = p
                        ? (a =
                            (n =
                              (o =
                                (r = (s = e)[S] || (s[S] = {}))[s.uniqueID] ||
                                (r[s.uniqueID] = {}))[h] || [])[0] === A &&
                            n[1])
                        : f)
                    )
                      for (
                        ;
                        (s = (++a && s && s[c]) || (f = a = 0) || l.pop()) &&
                        ((w
                          ? s.nodeName.toLowerCase() !== u
                          : 1 !== s.nodeType) ||
                          !++f ||
                          (p &&
                            ((o =
                              (r = s[S] || (s[S] = {}))[s.uniqueID] ||
                              (r[s.uniqueID] = {}))[h] = [A, f]),
                          s !== e));

                      );
                    return (f -= v) === g || (f % g == 0 && 0 <= f / g);
                  }
                };
          },
          PSEUDO: function (e, r) {
            var t,
              s =
                b.pseudos[e] ||
                b.setFilters[e.toLowerCase()] ||
                re.error("unsupported pseudo: " + e);
            return s[S]
              ? s(r)
              : 1 < s.length
              ? ((t = [e, e, "", r]),
                b.setFilters.hasOwnProperty(e.toLowerCase())
                  ? ae(function (e, t) {
                      for (var i, n = s(e, r), o = n.length; o--; )
                        e[(i = M(e, n[o]))] = !(t[i] = n[o]);
                    })
                  : function (e) {
                      return s(e, 0, t);
                    })
              : s;
          },
        },
        pseudos: {
          not: ae(function (e) {
            var n = [],
              o = [],
              a = p(e.replace(B, "$1"));
            return a[S]
              ? ae(function (e, t, i, n) {
                  for (var o, r = a(e, null, n, []), s = e.length; s--; )
                    (o = r[s]) && (e[s] = !(t[s] = o));
                })
              : function (e, t, i) {
                  return (n[0] = e), a(n, null, i, o), (n[0] = null), !o.pop();
                };
          }),
          has: ae(function (t) {
            return function (e) {
              return 0 < re(t, e).length;
            };
          }),
          contains: ae(function (t) {
            return (
              (t = t.replace(ie, u)),
              function (e) {
                return -1 < (e.textContent || e.innerText || r(e)).indexOf(t);
              }
            );
          }),
          lang: ae(function (i) {
            return (
              V.test(i || "") || re.error("unsupported lang: " + i),
              (i = i.replace(ie, u).toLowerCase()),
              function (e) {
                var t;
                do {
                  if (
                    (t = C
                      ? e.lang
                      : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                  )
                    return (
                      (t = t.toLowerCase()) === i || 0 === t.indexOf(i + "-")
                    );
                } while ((e = e.parentNode) && 1 === e.nodeType);
                return !1;
              }
            );
          }),
          target: function (e) {
            var t = i.location && i.location.hash;
            return t && t.slice(1) === e.id;
          },
          root: function (e) {
            return e === s;
          },
          focus: function (e) {
            return (
              e === T.activeElement &&
              (!T.hasFocus || T.hasFocus()) &&
              !!(e.type || e.href || ~e.tabIndex)
            );
          },
          enabled: ue(!1),
          disabled: ue(!0),
          checked: function (e) {
            var t = e.nodeName.toLowerCase();
            return (
              ("input" === t && !!e.checked) || ("option" === t && !!e.selected)
            );
          },
          selected: function (e) {
            return (
              e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
            );
          },
          empty: function (e) {
            for (e = e.firstChild; e; e = e.nextSibling)
              if (e.nodeType < 6) return !1;
            return !0;
          },
          parent: function (e) {
            return !b.pseudos.empty(e);
          },
          header: function (e) {
            return K.test(e.nodeName);
          },
          input: function (e) {
            return J.test(e.nodeName);
          },
          button: function (e) {
            var t = e.nodeName.toLowerCase();
            return ("input" === t && "button" === e.type) || "button" === t;
          },
          text: function (e) {
            return (
              "input" === e.nodeName.toLowerCase() &&
              "text" === e.type &&
              (null == (e = e.getAttribute("type")) ||
                "text" === e.toLowerCase())
            );
          },
          first: pe(function () {
            return [0];
          }),
          last: pe(function (e, t) {
            return [t - 1];
          }),
          eq: pe(function (e, t, i) {
            return [i < 0 ? i + t : i];
          }),
          even: pe(function (e, t) {
            for (var i = 0; i < t; i += 2) e.push(i);
            return e;
          }),
          odd: pe(function (e, t) {
            for (var i = 1; i < t; i += 2) e.push(i);
            return e;
          }),
          lt: pe(function (e, t, i) {
            for (var n = i < 0 ? i + t : i; 0 <= --n; ) e.push(n);
            return e;
          }),
          gt: pe(function (e, t, i) {
            for (var n = i < 0 ? i + t : i; ++n < t; ) e.push(n);
            return e;
          }),
        },
      }).pseudos.nth = b.pseudos.eq),
    { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
      b.pseudos[e] = (function (t) {
        return function (e) {
          return "input" === e.nodeName.toLowerCase() && e.type === t;
        };
      })(e);
    for (e in { submit: !0, reset: !0 })
      b.pseudos[e] = (function (i) {
        return function (e) {
          var t = e.nodeName.toLowerCase();
          return ("input" === t || "button" === t) && e.type === i;
        };
      })(e);
    function he() {}
    function ge(e) {
      for (var t = 0, i = e.length, n = ""; t < i; t++) n += e[t].value;
      return n;
    }
    function ve(s, e, t) {
      var a = e.dir,
        l = e.next,
        c = l || a,
        d = t && "parentNode" === c,
        u = E++;
      return e.first
        ? function (e, t, i) {
            for (; (e = e[a]); ) if (1 === e.nodeType || d) return s(e, t, i);
            return !1;
          }
        : function (e, t, i) {
            var n,
              o,
              r = [A, u];
            if (i) {
              for (; (e = e[a]); )
                if ((1 === e.nodeType || d) && s(e, t, i)) return !0;
            } else
              for (; (e = e[a]); )
                if (1 === e.nodeType || d)
                  if (
                    ((n =
                      (o = e[S] || (e[S] = {}))[e.uniqueID] ||
                      (o[e.uniqueID] = {})),
                    l && l === e.nodeName.toLowerCase())
                  )
                    e = e[a] || e;
                  else {
                    if ((o = n[c]) && o[0] === A && o[1] === u)
                      return (r[2] = o[2]);
                    if (((n[c] = r)[2] = s(e, t, i))) return !0;
                  }
            return !1;
          };
    }
    function me(o) {
      return 1 < o.length
        ? function (e, t, i) {
            for (var n = o.length; n--; ) if (!o[n](e, t, i)) return !1;
            return !0;
          }
        : o[0];
    }
    function ye(e, t, i, n, o) {
      for (var r, s = [], a = 0, l = e.length, c = null != t; a < l; a++)
        (r = e[a]) && ((i && !i(r, n, o)) || (s.push(r), c && t.push(a)));
      return s;
    }
    function we(f, h, g, v, m, e) {
      return (
        v && !v[S] && (v = we(v)),
        m && !m[S] && (m = we(m, e)),
        ae(function (e, t, i, n) {
          var o,
            r,
            s,
            a = [],
            l = [],
            c = t.length,
            d =
              e ||
              (function (e, t, i) {
                for (var n = 0, o = t.length; n < o; n++) re(e, t[n], i);
                return i;
              })(h || "*", i.nodeType ? [i] : i, []),
            u = !f || (!e && h) ? d : ye(d, a, f, i, n),
            p = g ? (m || (e ? f : c || v) ? [] : t) : u;
          if ((g && g(u, p, i, n), v))
            for (o = ye(p, l), v(o, [], i, n), r = o.length; r--; )
              (s = o[r]) && (p[l[r]] = !(u[l[r]] = s));
          if (e) {
            if (m || f) {
              if (m) {
                for (o = [], r = p.length; r--; )
                  (s = p[r]) && o.push((u[r] = s));
                m(null, (p = []), o, n);
              }
              for (r = p.length; r--; )
                (s = p[r]) &&
                  -1 < (o = m ? M(e, s) : a[r]) &&
                  (e[o] = !(t[o] = s));
            }
          } else (p = ye(p === t ? p.splice(c, p.length) : p)), m ? m(null, t, p, n) : O.apply(t, p);
        })
      );
    }
    function be(v, m) {
      function e(e, t, i, n, o) {
        var r,
          s,
          a,
          l = 0,
          c = "0",
          d = e && [],
          u = [],
          p = k,
          f = e || (w && b.find.TAG("*", o)),
          h = (A += null == p ? 1 : Math.random() || 0.1),
          g = f.length;
        for (o && (k = t === T || t || o); c !== g && null != (r = f[c]); c++) {
          if (w && r) {
            for (
              s = 0, t || r.ownerDocument === T || (x(r), (i = !C));
              (a = v[s++]);

            )
              if (a(r, t || T, i)) {
                n.push(r);
                break;
              }
            o && (A = h);
          }
          y && ((r = !a && r) && l--, e && d.push(r));
        }
        if (((l += c), y && c !== l)) {
          for (s = 0; (a = m[s++]); ) a(d, u, t, i);
          if (e) {
            if (0 < l) for (; c--; ) d[c] || u[c] || (u[c] = j.call(n));
            u = ye(u);
          }
          O.apply(n, u),
            o && !e && 0 < u.length && 1 < l + m.length && re.uniqueSort(n);
        }
        return o && ((A = h), (k = p)), d;
      }
      var y = 0 < m.length,
        w = 0 < v.length;
      return y ? ae(e) : e;
    }
    return (
      (he.prototype = b.filters = b.pseudos),
      (b.setFilters = new he()),
      (g = re.tokenize =
        function (e, t) {
          var i,
            n,
            o,
            r,
            s,
            a,
            l,
            c = z[e + " "];
          if (c) return t ? 0 : c.slice(0);
          for (s = e, a = [], l = b.preFilter; s; ) {
            for (r in ((i && !(n = U.exec(s))) ||
              (n && (s = s.slice(n[0].length) || s), a.push((o = []))),
            (i = !1),
            (n = X.exec(s)) &&
              ((i = n.shift()),
              o.push({ value: i, type: n[0].replace(B, " ") }),
              (s = s.slice(i.length))),
            b.filter))
              !(n = G[r].exec(s)) ||
                (l[r] && !(n = l[r](n))) ||
                ((i = n.shift()),
                o.push({ value: i, type: r, matches: n }),
                (s = s.slice(i.length)));
            if (!i) break;
          }
          return t ? s.length : s ? re.error(e) : z(e, a).slice(0);
        }),
      (p = re.compile =
        function (e, t) {
          var i,
            n = [],
            o = [],
            r = D[e + " "];
          if (!r) {
            for (i = (t = t || g(e)).length; i--; )
              ((r = (function e(t) {
                for (
                  var n,
                    i,
                    o,
                    r = t.length,
                    s = b.relative[t[0].type],
                    a = s || b.relative[" "],
                    l = s ? 1 : 0,
                    c = ve(
                      function (e) {
                        return e === n;
                      },
                      a,
                      !0
                    ),
                    d = ve(
                      function (e) {
                        return -1 < M(n, e);
                      },
                      a,
                      !0
                    ),
                    u = [
                      function (e, t, i) {
                        return (
                          (i =
                            (!s && (i || t !== k)) ||
                            ((n = t).nodeType ? c : d)(e, t, i)),
                          (n = null),
                          i
                        );
                      },
                    ];
                  l < r;
                  l++
                )
                  if ((i = b.relative[t[l].type])) u = [ve(me(u), i)];
                  else {
                    if (
                      (i = b.filter[t[l].type].apply(null, t[l].matches))[S]
                    ) {
                      for (o = ++l; o < r && !b.relative[t[o].type]; o++);
                      return we(
                        1 < l && me(u),
                        1 < l &&
                          ge(
                            t
                              .slice(0, l - 1)
                              .concat({
                                value: " " === t[l - 2].type ? "*" : "",
                              })
                          ).replace(B, "$1"),
                        i,
                        l < o && e(t.slice(l, o)),
                        o < r && e((t = t.slice(o))),
                        o < r && ge(t)
                      );
                    }
                    u.push(i);
                  }
                return me(u);
              })(t[i]))[S]
                ? n
                : o
              ).push(r);
            (r = D(e, be(o, n))).selector = e;
          }
          return r;
        }),
      (v = re.select =
        function (e, t, i, n) {
          var o,
            r,
            s,
            a,
            l,
            c = "function" == typeof e && e,
            d = !n && g((e = c.selector || e));
          if (((i = i || []), 1 === d.length)) {
            if (
              2 < (r = d[0] = d[0].slice(0)).length &&
              "ID" === (s = r[0]).type &&
              9 === t.nodeType &&
              C &&
              b.relative[r[1].type]
            ) {
              if (!(t = (b.find.ID(s.matches[0].replace(ie, u), t) || [])[0]))
                return i;
              c && (t = t.parentNode), (e = e.slice(r.shift().value.length));
            }
            for (
              o = G.needsContext.test(e) ? 0 : r.length;
              o-- && ((s = r[o]), !b.relative[(a = s.type)]);

            )
              if (
                (l = b.find[a]) &&
                (n = l(
                  s.matches[0].replace(ie, u),
                  (te.test(r[0].type) && fe(t.parentNode)) || t
                ))
              ) {
                if ((r.splice(o, 1), !(e = n.length && ge(r))))
                  return O.apply(i, n), i;
                break;
              }
          }
          return (
            (c || p(e, d))(
              n,
              t,
              !C,
              i,
              !t || (te.test(e) && fe(t.parentNode)) || t
            ),
            i
          );
        }),
      (h.sortStable = S.split("").sort(L).join("") === S),
      (h.detectDuplicates = !!c),
      x(),
      (h.sortDetached = le(function (e) {
        return 1 & e.compareDocumentPosition(T.createElement("fieldset"));
      })),
      le(function (e) {
        return (
          (e.innerHTML = "<a href='#'></a>"),
          "#" === e.firstChild.getAttribute("href")
        );
      }) ||
        ce("type|href|height|width", function (e, t, i) {
          if (!i) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }),
      (h.attributes &&
        le(function (e) {
          return (
            (e.innerHTML = "<input/>"),
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
          );
        })) ||
        ce("value", function (e, t, i) {
          if (!i && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }),
      le(function (e) {
        return null == e.getAttribute("disabled");
      }) ||
        ce(q, function (e, t, i) {
          if (!i)
            return !0 === e[t]
              ? t.toLowerCase()
              : (t = e.getAttributeNode(t)) && t.specified
              ? t.value
              : null;
        }),
      re
    );
  })(x);
  (C.find = f),
    (C.expr = f.selectors),
    (C.expr[":"] = C.expr.pseudos),
    (C.uniqueSort = C.unique = f.uniqueSort),
    (C.text = f.getText),
    (C.isXMLDoc = f.isXML),
    (C.contains = f.contains),
    (C.escapeSelector = f.escape);
  function k(e, t, i) {
    for (var n = [], o = void 0 !== i; (e = e[t]) && 9 !== e.nodeType; )
      if (1 === e.nodeType) {
        if (o && C(e).is(i)) break;
        n.push(e);
      }
    return n;
  }
  function S(e, t) {
    for (var i = []; e; e = e.nextSibling)
      1 === e.nodeType && e !== t && i.push(e);
    return i;
  }
  var A = C.expr.match.needsContext;
  function E(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  var $ = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function z(e, i, n) {
    return g(i)
      ? C.grep(e, function (e, t) {
          return !!i.call(e, t, e) !== n;
        })
      : i.nodeType
      ? C.grep(e, function (e) {
          return (e === i) !== n;
        })
      : "string" != typeof i
      ? C.grep(e, function (e) {
          return -1 < o.call(i, e) !== n;
        })
      : C.filter(i, e, n);
  }
  (C.filter = function (e, t, i) {
    var n = t[0];
    return (
      i && (e = ":not(" + e + ")"),
      1 === t.length && 1 === n.nodeType
        ? C.find.matchesSelector(n, e)
          ? [n]
          : []
        : C.find.matches(
            e,
            C.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    C.fn.extend({
      find: function (e) {
        var t,
          i,
          n = this.length,
          o = this;
        if ("string" != typeof e)
          return this.pushStack(
            C(e).filter(function () {
              for (t = 0; t < n; t++) if (C.contains(o[t], this)) return !0;
            })
          );
        for (i = this.pushStack([]), t = 0; t < n; t++) C.find(e, o[t], i);
        return 1 < n ? C.uniqueSort(i) : i;
      },
      filter: function (e) {
        return this.pushStack(z(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(z(this, e || [], !0));
      },
      is: function (e) {
        return !!z(this, "string" == typeof e && A.test(e) ? C(e) : e || [], !1)
          .length;
      },
    });
  var D = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  (C.fn.init = function (e, t, i) {
    if (!e) return this;
    if (((i = i || L), "string" != typeof e))
      return e.nodeType
        ? ((this[0] = e), (this.length = 1), this)
        : g(e)
        ? void 0 !== i.ready
          ? i.ready(e)
          : e(C)
        : C.makeArray(e, this);
    if (
      !(n =
        "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length
          ? [null, e, null]
          : D.exec(e)) ||
      (!n[1] && t)
    )
      return (!t || t.jquery ? t || i : this.constructor(t)).find(e);
    if (n[1]) {
      if (
        ((t = t instanceof C ? t[0] : t),
        C.merge(
          this,
          C.parseHTML(n[1], t && t.nodeType ? t.ownerDocument || t : T, !0)
        ),
        $.test(n[1]) && C.isPlainObject(t))
      )
        for (var n in t) g(this[n]) ? this[n](t[n]) : this.attr(n, t[n]);
      return this;
    }
    return (
      (e = T.getElementById(n[2])) && ((this[0] = e), (this.length = 1)), this
    );
  }).prototype = C.fn;
  var L = C(T),
    N = /^(?:parents|prev(?:Until|All))/,
    j = { children: !0, contents: !0, next: !0, prev: !0 };
  function H(e, t) {
    for (; (e = e[t]) && 1 !== e.nodeType; );
    return e;
  }
  C.fn.extend({
    has: function (e) {
      var t = C(e, this),
        i = t.length;
      return this.filter(function () {
        for (var e = 0; e < i; e++) if (C.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var i,
        n = 0,
        o = this.length,
        r = [],
        s = "string" != typeof e && C(e);
      if (!A.test(e))
        for (; n < o; n++)
          for (i = this[n]; i && i !== t; i = i.parentNode)
            if (
              i.nodeType < 11 &&
              (s
                ? -1 < s.index(i)
                : 1 === i.nodeType && C.find.matchesSelector(i, e))
            ) {
              r.push(i);
              break;
            }
      return this.pushStack(1 < r.length ? C.uniqueSort(r) : r);
    },
    index: function (e) {
      return e
        ? "string" == typeof e
          ? o.call(C(e), this[0])
          : o.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(C.uniqueSort(C.merge(this.get(), C(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    },
  }),
    C.each(
      {
        parent: function (e) {
          e = e.parentNode;
          return e && 11 !== e.nodeType ? e : null;
        },
        parents: function (e) {
          return k(e, "parentNode");
        },
        parentsUntil: function (e, t, i) {
          return k(e, "parentNode", i);
        },
        next: function (e) {
          return H(e, "nextSibling");
        },
        prev: function (e) {
          return H(e, "previousSibling");
        },
        nextAll: function (e) {
          return k(e, "nextSibling");
        },
        prevAll: function (e) {
          return k(e, "previousSibling");
        },
        nextUntil: function (e, t, i) {
          return k(e, "nextSibling", i);
        },
        prevUntil: function (e, t, i) {
          return k(e, "previousSibling", i);
        },
        siblings: function (e) {
          return S((e.parentNode || {}).firstChild, e);
        },
        children: function (e) {
          return S(e.firstChild);
        },
        contents: function (e) {
          return E(e, "iframe")
            ? e.contentDocument
            : (E(e, "template") && (e = e.content || e),
              C.merge([], e.childNodes));
        },
      },
      function (n, o) {
        C.fn[n] = function (e, t) {
          var i = C.map(this, o, e);
          return (
            (t = "Until" !== n.slice(-5) ? e : t) &&
              "string" == typeof t &&
              (i = C.filter(t, i)),
            1 < this.length &&
              (j[n] || C.uniqueSort(i), N.test(n) && i.reverse()),
            this.pushStack(i)
          );
        };
      }
    );
  var O = /[^\x20\t\r\n\f]+/g;
  function P(e) {
    return e;
  }
  function M(e) {
    throw e;
  }
  function q(e, t, i, n) {
    var o;
    try {
      e && g((o = e.promise))
        ? o.call(e).done(t).fail(i)
        : e && g((o = e.then))
        ? o.call(e, t, i)
        : t.apply(void 0, [e].slice(n));
    } catch (e) {
      i.apply(void 0, [e]);
    }
  }
  (C.Callbacks = function (n) {
    var e, i;
    n =
      "string" == typeof n
        ? ((e = n),
          (i = {}),
          C.each(e.match(O) || [], function (e, t) {
            i[t] = !0;
          }),
          i)
        : C.extend({}, n);
    function o() {
      for (a = a || n.once, s = r = !0; c.length; d = -1)
        for (t = c.shift(); ++d < l.length; )
          !1 === l[d].apply(t[0], t[1]) &&
            n.stopOnFalse &&
            ((d = l.length), (t = !1));
      n.memory || (t = !1), (r = !1), a && (l = t ? [] : "");
    }
    var r,
      t,
      s,
      a,
      l = [],
      c = [],
      d = -1,
      u = {
        add: function () {
          return (
            l &&
              (t && !r && ((d = l.length - 1), c.push(t)),
              (function i(e) {
                C.each(e, function (e, t) {
                  g(t)
                    ? (n.unique && u.has(t)) || l.push(t)
                    : t && t.length && "string" !== h(t) && i(t);
                });
              })(arguments),
              t && !r && o()),
            this
          );
        },
        remove: function () {
          return (
            C.each(arguments, function (e, t) {
              for (var i; -1 < (i = C.inArray(t, l, i)); )
                l.splice(i, 1), i <= d && d--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? -1 < C.inArray(e, l) : 0 < l.length;
        },
        empty: function () {
          return (l = l && []), this;
        },
        disable: function () {
          return (a = c = []), (l = t = ""), this;
        },
        disabled: function () {
          return !l;
        },
        lock: function () {
          return (a = c = []), t || r || (l = t = ""), this;
        },
        locked: function () {
          return !!a;
        },
        fireWith: function (e, t) {
          return (
            a ||
              ((t = [e, (t = t || []).slice ? t.slice() : t]),
              c.push(t),
              r || o()),
            this
          );
        },
        fire: function () {
          return u.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!s;
        },
      };
    return u;
  }),
    C.extend({
      Deferred: function (e) {
        var r = [
            [
              "notify",
              "progress",
              C.Callbacks("memory"),
              C.Callbacks("memory"),
              2,
            ],
            [
              "resolve",
              "done",
              C.Callbacks("once memory"),
              C.Callbacks("once memory"),
              0,
              "resolved",
            ],
            [
              "reject",
              "fail",
              C.Callbacks("once memory"),
              C.Callbacks("once memory"),
              1,
              "rejected",
            ],
          ],
          o = "pending",
          s = {
            state: function () {
              return o;
            },
            always: function () {
              return a.done(arguments).fail(arguments), this;
            },
            catch: function (e) {
              return s.then(null, e);
            },
            pipe: function () {
              var o = arguments;
              return C.Deferred(function (n) {
                C.each(r, function (e, t) {
                  var i = g(o[t[4]]) && o[t[4]];
                  a[t[1]](function () {
                    var e = i && i.apply(this, arguments);
                    e && g(e.promise)
                      ? e
                          .promise()
                          .progress(n.notify)
                          .done(n.resolve)
                          .fail(n.reject)
                      : n[t[0] + "With"](this, i ? [e] : arguments);
                  });
                }),
                  (o = null);
              }).promise();
            },
            then: function (t, i, n) {
              var l = 0;
              function c(o, r, s, a) {
                return function () {
                  function e() {
                    var e, t;
                    if (!(o < l)) {
                      if ((e = s.apply(i, n)) === r.promise())
                        throw new TypeError("Thenable self-resolution");
                      (t =
                        e &&
                        ("object" == typeof e || "function" == typeof e) &&
                        e.then),
                        g(t)
                          ? a
                            ? t.call(e, c(l, r, P, a), c(l, r, M, a))
                            : (l++,
                              t.call(
                                e,
                                c(l, r, P, a),
                                c(l, r, M, a),
                                c(l, r, P, r.notifyWith)
                              ))
                          : (s !== P && ((i = void 0), (n = [e])),
                            (a || r.resolveWith)(i, n));
                    }
                  }
                  var i = this,
                    n = arguments,
                    t = a
                      ? e
                      : function () {
                          try {
                            e();
                          } catch (e) {
                            C.Deferred.exceptionHook &&
                              C.Deferred.exceptionHook(e, t.stackTrace),
                              l <= o + 1 &&
                                (s !== M && ((i = void 0), (n = [e])),
                                r.rejectWith(i, n));
                          }
                        };
                  o
                    ? t()
                    : (C.Deferred.getStackHook &&
                        (t.stackTrace = C.Deferred.getStackHook()),
                      x.setTimeout(t));
                };
              }
              return C.Deferred(function (e) {
                r[0][3].add(c(0, e, g(n) ? n : P, e.notifyWith)),
                  r[1][3].add(c(0, e, g(t) ? t : P)),
                  r[2][3].add(c(0, e, g(i) ? i : M));
              }).promise();
            },
            promise: function (e) {
              return null != e ? C.extend(e, s) : s;
            },
          },
          a = {};
        return (
          C.each(r, function (e, t) {
            var i = t[2],
              n = t[5];
            (s[t[1]] = i.add),
              n &&
                i.add(
                  function () {
                    o = n;
                  },
                  r[3 - e][2].disable,
                  r[3 - e][3].disable,
                  r[0][2].lock,
                  r[0][3].lock
                ),
              i.add(t[3].fire),
              (a[t[0]] = function () {
                return (
                  a[t[0] + "With"](this === a ? void 0 : this, arguments), this
                );
              }),
              (a[t[0] + "With"] = i.fireWith);
          }),
          s.promise(a),
          e && e.call(a, a),
          a
        );
      },
      when: function (e) {
        function t(t) {
          return function (e) {
            (o[t] = this),
              (r[t] = 1 < arguments.length ? a.call(arguments) : e),
              --i || s.resolveWith(o, r);
          };
        }
        var i = arguments.length,
          n = i,
          o = Array(n),
          r = a.call(arguments),
          s = C.Deferred();
        if (
          i <= 1 &&
          (q(e, s.done(t(n)).resolve, s.reject, !i),
          "pending" === s.state() || g(r[n] && r[n].then))
        )
          return s.then();
        for (; n--; ) q(r[n], t(n), s.reject);
        return s.promise();
      },
    });
  var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (C.Deferred.exceptionHook = function (e, t) {
    x.console &&
      x.console.warn &&
      e &&
      W.test(e.name) &&
      x.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
  }),
    (C.readyException = function (e) {
      x.setTimeout(function () {
        throw e;
      });
    });
  var I = C.Deferred();
  function _() {
    T.removeEventListener("DOMContentLoaded", _),
      x.removeEventListener("load", _),
      C.ready();
  }
  (C.fn.ready = function (e) {
    return (
      I.then(e).catch(function (e) {
        C.readyException(e);
      }),
      this
    );
  }),
    C.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --C.readyWait : C.isReady) ||
          ((C.isReady = !0) !== e && 0 < --C.readyWait) ||
          I.resolveWith(T, [C]);
      },
    }),
    (C.ready.then = I.then),
    "complete" === T.readyState ||
    ("loading" !== T.readyState && !T.documentElement.doScroll)
      ? x.setTimeout(C.ready)
      : (T.addEventListener("DOMContentLoaded", _),
        x.addEventListener("load", _));
  function F(e, t, i, n, o, r, s) {
    var a = 0,
      l = e.length,
      c = null == i;
    if ("object" === h(i)) for (a in ((o = !0), i)) F(e, t, a, i[a], !0, r, s);
    else if (
      void 0 !== n &&
      ((o = !0),
      g(n) || (s = !0),
      (t = c
        ? s
          ? (t.call(e, n), null)
          : ((c = t),
            function (e, t, i) {
              return c.call(C(e), i);
            })
        : t))
    )
      for (; a < l; a++) t(e[a], i, s ? n : n.call(e[a], a, t(e[a], i)));
    return o ? e : c ? t.call(e) : l ? t(e[0], i) : r;
  }
  var R = /^-ms-/,
    B = /-([a-z])/g;
  function U(e, t) {
    return t.toUpperCase();
  }
  function X(e) {
    return e.replace(R, "ms-").replace(B, U);
  }
  function Y(e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  }
  function Q() {
    this.expando = C.expando + Q.uid++;
  }
  (Q.uid = 1),
    (Q.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            Y(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0,
                  }))),
          t
        );
      },
      set: function (e, t, i) {
        var n,
          o = this.cache(e);
        if ("string" == typeof t) o[X(t)] = i;
        else for (n in t) o[X(n)] = t[n];
        return o;
      },
      get: function (e, t) {
        return void 0 === t
          ? this.cache(e)
          : e[this.expando] && e[this.expando][X(t)];
      },
      access: function (e, t, i) {
        return void 0 === t || (t && "string" == typeof t && void 0 === i)
          ? this.get(e, t)
          : (this.set(e, t, i), void 0 !== i ? i : t);
      },
      remove: function (e, t) {
        var i,
          n = e[this.expando];
        if (void 0 !== n) {
          if (void 0 !== t) {
            i = (t = Array.isArray(t)
              ? t.map(X)
              : (t = X(t)) in n
              ? [t]
              : t.match(O) || []).length;
            for (; i--; ) delete n[t[i]];
          }
          (void 0 !== t && !C.isEmptyObject(n)) ||
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        e = e[this.expando];
        return void 0 !== e && !C.isEmptyObject(e);
      },
    });
  var V = new Q(),
    G = new Q(),
    J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    K = /[A-Z]/g;
  function Z(e, t, i) {
    var n, o;
    if (void 0 === i && 1 === e.nodeType)
      if (
        ((n = "data-" + t.replace(K, "-$&").toLowerCase()),
        "string" == typeof (i = e.getAttribute(n)))
      ) {
        try {
          i =
            "true" === (o = i) ||
            ("false" !== o &&
              ("null" === o
                ? null
                : o === +o + ""
                ? +o
                : J.test(o)
                ? JSON.parse(o)
                : o));
        } catch (e) {}
        G.set(e, t, i);
      } else i = void 0;
    return i;
  }
  C.extend({
    hasData: function (e) {
      return G.hasData(e) || V.hasData(e);
    },
    data: function (e, t, i) {
      return G.access(e, t, i);
    },
    removeData: function (e, t) {
      G.remove(e, t);
    },
    _data: function (e, t, i) {
      return V.access(e, t, i);
    },
    _removeData: function (e, t) {
      V.remove(e, t);
    },
  }),
    C.fn.extend({
      data: function (i, e) {
        var t,
          n,
          o,
          r = this[0],
          s = r && r.attributes;
        if (void 0 !== i)
          return "object" == typeof i
            ? this.each(function () {
                G.set(this, i);
              })
            : F(
                this,
                function (e) {
                  var t;
                  return r && void 0 === e
                    ? void 0 !== (t = G.get(r, i)) || void 0 !== (t = Z(r, i))
                      ? t
                      : void 0
                    : void this.each(function () {
                        G.set(this, i, e);
                      });
                },
                null,
                e,
                1 < arguments.length,
                null,
                !0
              );
        if (
          this.length &&
          ((o = G.get(r)), 1 === r.nodeType && !V.get(r, "hasDataAttrs"))
        ) {
          for (t = s.length; t--; )
            s[t] &&
              0 === (n = s[t].name).indexOf("data-") &&
              ((n = X(n.slice(5))), Z(r, n, o[n]));
          V.set(r, "hasDataAttrs", !0);
        }
        return o;
      },
      removeData: function (e) {
        return this.each(function () {
          G.remove(this, e);
        });
      },
    }),
    C.extend({
      queue: function (e, t, i) {
        var n;
        if (e)
          return (
            (n = V.get(e, (t = (t || "fx") + "queue"))),
            i &&
              (!n || Array.isArray(i)
                ? (n = V.access(e, t, C.makeArray(i)))
                : n.push(i)),
            n || []
          );
      },
      dequeue: function (e, t) {
        t = t || "fx";
        var i = C.queue(e, t),
          n = i.length,
          o = i.shift(),
          r = C._queueHooks(e, t);
        "inprogress" === o && ((o = i.shift()), n--),
          o &&
            ("fx" === t && i.unshift("inprogress"),
            delete r.stop,
            o.call(
              e,
              function () {
                C.dequeue(e, t);
              },
              r
            )),
          !n && r && r.empty.fire();
      },
      _queueHooks: function (e, t) {
        var i = t + "queueHooks";
        return (
          V.get(e, i) ||
          V.access(e, i, {
            empty: C.Callbacks("once memory").add(function () {
              V.remove(e, [t + "queue", i]);
            }),
          })
        );
      },
    }),
    C.fn.extend({
      queue: function (t, i) {
        var e = 2;
        return (
          "string" != typeof t && ((i = t), (t = "fx"), e--),
          arguments.length < e
            ? C.queue(this[0], t)
            : void 0 === i
            ? this
            : this.each(function () {
                var e = C.queue(this, t, i);
                C._queueHooks(this, t),
                  "fx" === t && "inprogress" !== e[0] && C.dequeue(this, t);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          C.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || "fx", []);
      },
      promise: function (e, t) {
        function i() {
          --o || r.resolveWith(s, [s]);
        }
        var n,
          o = 1,
          r = C.Deferred(),
          s = this,
          a = this.length;
        for (
          "string" != typeof e && ((t = e), (e = void 0)), e = e || "fx";
          a--;

        )
          (n = V.get(s[a], e + "queueHooks")) &&
            n.empty &&
            (o++, n.empty.add(i));
        return i(), r.promise(t);
      },
    });
  function ee(e, t) {
    return (
      "none" === (e = t || e).style.display ||
      ("" === e.style.display &&
        C.contains(e.ownerDocument, e) &&
        "none" === C.css(e, "display"))
    );
  }
  function te(e, t, i, n) {
    var o,
      r = {};
    for (o in t) (r[o] = e.style[o]), (e.style[o] = t[o]);
    for (o in ((n = i.apply(e, n || [])), t)) e.style[o] = r[o];
    return n;
  }
  var ie = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    ne = new RegExp("^(?:([+-])=|)(" + ie + ")([a-z%]*)$", "i"),
    oe = ["Top", "Right", "Bottom", "Left"];
  function re(e, t, i, n) {
    var o,
      r,
      s = 20,
      a = n
        ? function () {
            return n.cur();
          }
        : function () {
            return C.css(e, t, "");
          },
      l = a(),
      c = (i && i[3]) || (C.cssNumber[t] ? "" : "px"),
      d = (C.cssNumber[t] || ("px" !== c && +l)) && ne.exec(C.css(e, t));
    if (d && d[3] !== c) {
      for (c = c || d[3], d = +(l /= 2) || 1; s--; )
        C.style(e, t, d + c),
          (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (s = 0),
          (d /= r);
      C.style(e, t, (d *= 2) + c), (i = i || []);
    }
    return (
      i &&
        ((d = +d || +l || 0),
        (o = i[1] ? d + (i[1] + 1) * i[2] : +i[2]),
        n && ((n.unit = c), (n.start = d), (n.end = o))),
      o
    );
  }
  var se = {};
  function ae(e, t) {
    for (var i, n, o, r, s, a = [], l = 0, c = e.length; l < c; l++)
      (n = e[l]).style &&
        ((i = n.style.display),
        t
          ? ("none" === i &&
              ((a[l] = V.get(n, "display") || null),
              a[l] || (n.style.display = "")),
            "" === n.style.display &&
              ee(n) &&
              (a[l] =
                ((s = r = void 0),
                (r = (o = n).ownerDocument),
                (s = o.nodeName),
                (o = se[s]) ||
                  ((r = r.body.appendChild(r.createElement(s))),
                  (o = C.css(r, "display")),
                  r.parentNode.removeChild(r),
                  (se[s] = o = "none" === o ? "block" : o)))))
          : "none" !== i && ((a[l] = "none"), V.set(n, "display", i)));
    for (l = 0; l < c; l++) null != a[l] && (e[l].style.display = a[l]);
    return e;
  }
  C.fn.extend({
    show: function () {
      return ae(this, !0);
    },
    hide: function () {
      return ae(this);
    },
    toggle: function (e) {
      return "boolean" == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            ee(this) ? C(this).show() : C(this).hide();
          });
    },
  });
  var le = /^(?:checkbox|radio)$/i,
    ce = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
    de = /^$|^module$|\/(?:java|ecma)script/i,
    ue = {
      option: [1, "<select multiple='multiple'>", "</select>"],
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""],
    };
  function pe(e, t) {
    var i =
      void 0 !== e.getElementsByTagName
        ? e.getElementsByTagName(t || "*")
        : void 0 !== e.querySelectorAll
        ? e.querySelectorAll(t || "*")
        : [];
    return void 0 === t || (t && E(e, t)) ? C.merge([e], i) : i;
  }
  function fe(e, t) {
    for (var i = 0, n = e.length; i < n; i++)
      V.set(e[i], "globalEval", !t || V.get(t[i], "globalEval"));
  }
  (ue.optgroup = ue.option),
    (ue.tbody = ue.tfoot = ue.colgroup = ue.caption = ue.thead),
    (ue.th = ue.td);
  var he = /<|&#?\w+;/;
  function ge(e, t, i, n, o) {
    for (
      var r,
        s,
        a,
        l,
        c,
        d = t.createDocumentFragment(),
        u = [],
        p = 0,
        f = e.length;
      p < f;
      p++
    )
      if ((r = e[p]) || 0 === r)
        if ("object" === h(r)) C.merge(u, r.nodeType ? [r] : r);
        else if (he.test(r)) {
          for (
            s = s || d.appendChild(t.createElement("div")),
              a = (ce.exec(r) || ["", ""])[1].toLowerCase(),
              a = ue[a] || ue._default,
              s.innerHTML = a[1] + C.htmlPrefilter(r) + a[2],
              c = a[0];
            c--;

          )
            s = s.lastChild;
          C.merge(u, s.childNodes), ((s = d.firstChild).textContent = "");
        } else u.push(t.createTextNode(r));
    for (d.textContent = "", p = 0; (r = u[p++]); )
      if (n && -1 < C.inArray(r, n)) o && o.push(r);
      else if (
        ((l = C.contains(r.ownerDocument, r)),
        (s = pe(d.appendChild(r), "script")),
        l && fe(s),
        i)
      )
        for (c = 0; (r = s[c++]); ) de.test(r.type || "") && i.push(r);
    return d;
  }
  (t = T.createDocumentFragment().appendChild(T.createElement("div"))),
    (f = T.createElement("input")).setAttribute("type", "radio"),
    f.setAttribute("checked", "checked"),
    f.setAttribute("name", "t"),
    t.appendChild(f),
    (w.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked),
    (t.innerHTML = "<textarea>x</textarea>"),
    (w.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue);
  var ve = T.documentElement,
    me = /^key/,
    ye = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    we = /^([^.]*)(?:\.(.+)|)/;
  function be() {
    return !0;
  }
  function ke() {
    return !1;
  }
  function xe() {
    try {
      return T.activeElement;
    } catch (e) {}
  }
  function Te(e, t, i, n, o, r) {
    var s, a;
    if ("object" == typeof t) {
      for (a in ("string" != typeof i && ((n = n || i), (i = void 0)), t))
        Te(e, a, i, n, t[a], r);
      return e;
    }
    if (
      (null == n && null == o
        ? ((o = i), (n = i = void 0))
        : null == o &&
          ("string" == typeof i
            ? ((o = n), (n = void 0))
            : ((o = n), (n = i), (i = void 0))),
      !1 === o)
    )
      o = ke;
    else if (!o) return e;
    return (
      1 === r &&
        ((s = o),
        ((o = function (e) {
          return C().off(e), s.apply(this, arguments);
        }).guid = s.guid || (s.guid = C.guid++))),
      e.each(function () {
        C.event.add(this, t, o, n, i);
      })
    );
  }
  (C.event = {
    global: {},
    add: function (t, e, i, n, o) {
      var r,
        s,
        a,
        l,
        c,
        d,
        u,
        p,
        f,
        h = V.get(t);
      if (h)
        for (
          i.handler && ((i = (r = i).handler), (o = r.selector)),
            o && C.find.matchesSelector(ve, o),
            i.guid || (i.guid = C.guid++),
            (a = h.events) || (a = h.events = {}),
            (s = h.handle) ||
              (s = h.handle =
                function (e) {
                  return void 0 !== C && C.event.triggered !== e.type
                    ? C.event.dispatch.apply(t, arguments)
                    : void 0;
                }),
            l = (e = (e || "").match(O) || [""]).length;
          l--;

        )
          (u = f = (c = we.exec(e[l]) || [])[1]),
            (p = (c[2] || "").split(".").sort()),
            u &&
              ((d = C.event.special[u] || {}),
              (u = (o ? d.delegateType : d.bindType) || u),
              (d = C.event.special[u] || {}),
              (c = C.extend(
                {
                  type: u,
                  origType: f,
                  data: n,
                  handler: i,
                  guid: i.guid,
                  selector: o,
                  needsContext: o && C.expr.match.needsContext.test(o),
                  namespace: p.join("."),
                },
                r
              )),
              (f = a[u]) ||
                (((f = a[u] = []).delegateCount = 0),
                (d.setup && !1 !== d.setup.call(t, n, p, s)) ||
                  (t.addEventListener && t.addEventListener(u, s))),
              d.add &&
                (d.add.call(t, c), c.handler.guid || (c.handler.guid = i.guid)),
              o ? f.splice(f.delegateCount++, 0, c) : f.push(c),
              (C.event.global[u] = !0));
    },
    remove: function (e, t, i, n, o) {
      var r,
        s,
        a,
        l,
        c,
        d,
        u,
        p,
        f,
        h,
        g,
        v = V.hasData(e) && V.get(e);
      if (v && (l = v.events)) {
        for (c = (t = (t || "").match(O) || [""]).length; c--; )
          if (
            ((f = g = (a = we.exec(t[c]) || [])[1]),
            (h = (a[2] || "").split(".").sort()),
            f)
          ) {
            for (
              u = C.event.special[f] || {},
                p = l[(f = (n ? u.delegateType : u.bindType) || f)] || [],
                a =
                  a[2] &&
                  new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                s = r = p.length;
              r--;

            )
              (d = p[r]),
                (!o && g !== d.origType) ||
                  (i && i.guid !== d.guid) ||
                  (a && !a.test(d.namespace)) ||
                  (n && n !== d.selector && ("**" !== n || !d.selector)) ||
                  (p.splice(r, 1),
                  d.selector && p.delegateCount--,
                  u.remove && u.remove.call(e, d));
            s &&
              !p.length &&
              ((u.teardown && !1 !== u.teardown.call(e, h, v.handle)) ||
                C.removeEvent(e, f, v.handle),
              delete l[f]);
          } else for (f in l) C.event.remove(e, f + t[c], i, n, !0);
        C.isEmptyObject(l) && V.remove(e, "handle events");
      }
    },
    dispatch: function (e) {
      var t,
        i,
        n,
        o,
        r,
        s = C.event.fix(e),
        a = new Array(arguments.length),
        l = (V.get(this, "events") || {})[s.type] || [],
        e = C.event.special[s.type] || {};
      for (a[0] = s, t = 1; t < arguments.length; t++) a[t] = arguments[t];
      if (
        ((s.delegateTarget = this),
        !e.preDispatch || !1 !== e.preDispatch.call(this, s))
      ) {
        for (
          r = C.event.handlers.call(this, s, l), t = 0;
          (n = r[t++]) && !s.isPropagationStopped();

        )
          for (
            s.currentTarget = n.elem, i = 0;
            (o = n.handlers[i++]) && !s.isImmediatePropagationStopped();

          )
            (s.rnamespace && !s.rnamespace.test(o.namespace)) ||
              ((s.handleObj = o),
              (s.data = o.data),
              void 0 !==
                (o = (
                  (C.event.special[o.origType] || {}).handle || o.handler
                ).apply(n.elem, a)) &&
                !1 === (s.result = o) &&
                (s.preventDefault(), s.stopPropagation()));
        return e.postDispatch && e.postDispatch.call(this, s), s.result;
      }
    },
    handlers: function (e, t) {
      var i,
        n,
        o,
        r,
        s,
        a = [],
        l = t.delegateCount,
        c = e.target;
      if (l && c.nodeType && !("click" === e.type && 1 <= e.button))
        for (; c !== this; c = c.parentNode || this)
          if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
            for (r = [], s = {}, i = 0; i < l; i++)
              void 0 === s[(o = (n = t[i]).selector + " ")] &&
                (s[o] = n.needsContext
                  ? -1 < C(o, this).index(c)
                  : C.find(o, this, null, [c]).length),
                s[o] && r.push(n);
            r.length && a.push({ elem: c, handlers: r });
          }
      return (
        (c = this), l < t.length && a.push({ elem: c, handlers: t.slice(l) }), a
      );
    },
    addProp: function (t, e) {
      Object.defineProperty(C.Event.prototype, t, {
        enumerable: !0,
        configurable: !0,
        get: g(e)
          ? function () {
              if (this.originalEvent) return e(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[t];
            },
        set: function (e) {
          Object.defineProperty(this, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e,
          });
        },
      });
    },
    fix: function (e) {
      return e[C.expando] ? e : new C.Event(e);
    },
    special: {
      load: { noBubble: !0 },
      focus: {
        trigger: function () {
          if (this !== xe() && this.focus) return this.focus(), !1;
        },
        delegateType: "focusin",
      },
      blur: {
        trigger: function () {
          if (this === xe() && this.blur) return this.blur(), !1;
        },
        delegateType: "focusout",
      },
      click: {
        trigger: function () {
          if ("checkbox" === this.type && this.click && E(this, "input"))
            return this.click(), !1;
        },
        _default: function (e) {
          return E(e.target, "a");
        },
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result &&
            e.originalEvent &&
            (e.originalEvent.returnValue = e.result);
        },
      },
    },
  }),
    (C.removeEvent = function (e, t, i) {
      e.removeEventListener && e.removeEventListener(t, i);
    }),
    (C.Event = function (e, t) {
      if (!(this instanceof C.Event)) return new C.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented ||
            (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? be
              : ke),
          (this.target =
            e.target && 3 === e.target.nodeType
              ? e.target.parentNode
              : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && C.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[C.expando] = !0);
    }),
    (C.Event.prototype = {
      constructor: C.Event,
      isDefaultPrevented: ke,
      isPropagationStopped: ke,
      isImmediatePropagationStopped: ke,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = be),
          e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = be),
          e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = be),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    C.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function (e) {
          var t = e.button;
          return null == e.which && me.test(e.type)
            ? null != e.charCode
              ? e.charCode
              : e.keyCode
            : !e.which && void 0 !== t && ye.test(e.type)
            ? 1 & t
              ? 1
              : 2 & t
              ? 3
              : 4 & t
              ? 2
              : 0
            : e.which;
        },
      },
      C.event.addProp
    ),
    C.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (e, o) {
        C.event.special[e] = {
          delegateType: o,
          bindType: o,
          handle: function (e) {
            var t,
              i = e.relatedTarget,
              n = e.handleObj;
            return (
              (i && (i === this || C.contains(this, i))) ||
                ((e.type = n.origType),
                (t = n.handler.apply(this, arguments)),
                (e.type = o)),
              t
            );
          },
        };
      }
    ),
    C.fn.extend({
      on: function (e, t, i, n) {
        return Te(this, e, t, i, n);
      },
      one: function (e, t, i, n) {
        return Te(this, e, t, i, n, 1);
      },
      off: function (e, t, i) {
        var n, o;
        if (e && e.preventDefault && e.handleObj)
          return (
            (n = e.handleObj),
            C(e.delegateTarget).off(
              n.namespace ? n.origType + "." + n.namespace : n.origType,
              n.selector,
              n.handler
            ),
            this
          );
        if ("object" != typeof e)
          return (
            (!1 !== t && "function" != typeof t) || ((i = t), (t = void 0)),
            !1 === i && (i = ke),
            this.each(function () {
              C.event.remove(this, e, i, t);
            })
          );
        for (o in e) this.off(o, t, e[o]);
        return this;
      },
    });
  var Ce =
      /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
    Se = /<script|<style|<link/i,
    Ae = /checked\s*(?:[^=]|=\s*.checked.)/i,
    Ee = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function $e(e, t) {
    return (
      (E(e, "table") &&
        E(11 !== t.nodeType ? t : t.firstChild, "tr") &&
        C(e).children("tbody")[0]) ||
      e
    );
  }
  function ze(e) {
    return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
  }
  function De(e) {
    return (
      "true/" === (e.type || "").slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute("type"),
      e
    );
  }
  function Le(e, t) {
    var i, n, o, r, s, a;
    if (1 === t.nodeType) {
      if (
        V.hasData(e) &&
        ((r = V.access(e)), (s = V.set(t, r)), (a = r.events))
      )
        for (o in (delete s.handle, (s.events = {}), a))
          for (i = 0, n = a[o].length; i < n; i++) C.event.add(t, o, a[o][i]);
      G.hasData(e) && ((e = G.access(e)), (e = C.extend({}, e)), G.set(t, e));
    }
  }
  function Ne(i, n, o, r) {
    n = m.apply([], n);
    var e,
      t,
      s,
      a,
      l,
      c,
      d = 0,
      u = i.length,
      p = u - 1,
      f = n[0],
      h = g(f);
    if (h || (1 < u && "string" == typeof f && !w.checkClone && Ae.test(f)))
      return i.each(function (e) {
        var t = i.eq(e);
        h && (n[0] = f.call(this, e, t.html())), Ne(t, n, o, r);
      });
    if (
      u &&
      ((t = (e = ge(n, i[0].ownerDocument, !1, i, r)).firstChild),
      1 === e.childNodes.length && (e = t),
      t || r)
    ) {
      for (a = (s = C.map(pe(e, "script"), ze)).length; d < u; d++)
        (l = e),
          d !== p &&
            ((l = C.clone(l, !0, !0)), a && C.merge(s, pe(l, "script"))),
          o.call(i[d], l, d);
      if (a)
        for (c = s[s.length - 1].ownerDocument, C.map(s, De), d = 0; d < a; d++)
          (l = s[d]),
            de.test(l.type || "") &&
              !V.access(l, "globalEval") &&
              C.contains(c, l) &&
              (l.src && "module" !== (l.type || "").toLowerCase()
                ? C._evalUrl && C._evalUrl(l.src)
                : b(l.textContent.replace(Ee, ""), c, l));
    }
    return i;
  }
  function je(e, t, i) {
    for (var n, o = t ? C.filter(t, e) : e, r = 0; null != (n = o[r]); r++)
      i || 1 !== n.nodeType || C.cleanData(pe(n)),
        n.parentNode &&
          (i && C.contains(n.ownerDocument, n) && fe(pe(n, "script")),
          n.parentNode.removeChild(n));
    return e;
  }
  C.extend({
    htmlPrefilter: function (e) {
      return e.replace(Ce, "<$1></$2>");
    },
    clone: function (e, t, i) {
      var n,
        o,
        r,
        s,
        a,
        l,
        c,
        d = e.cloneNode(!0),
        u = C.contains(e.ownerDocument, e);
      if (
        !(
          w.noCloneChecked ||
          (1 !== e.nodeType && 11 !== e.nodeType) ||
          C.isXMLDoc(e)
        )
      )
        for (s = pe(d), n = 0, o = (r = pe(e)).length; n < o; n++)
          (a = r[n]),
            (l = s[n]),
            (c = void 0),
            "input" === (c = l.nodeName.toLowerCase()) && le.test(a.type)
              ? (l.checked = a.checked)
              : ("input" !== c && "textarea" !== c) ||
                (l.defaultValue = a.defaultValue);
      if (t)
        if (i)
          for (r = r || pe(e), s = s || pe(d), n = 0, o = r.length; n < o; n++)
            Le(r[n], s[n]);
        else Le(e, d);
      return (
        0 < (s = pe(d, "script")).length && fe(s, !u && pe(e, "script")), d
      );
    },
    cleanData: function (e) {
      for (var t, i, n, o = C.event.special, r = 0; void 0 !== (i = e[r]); r++)
        if (Y(i)) {
          if ((t = i[V.expando])) {
            if (t.events)
              for (n in t.events)
                o[n] ? C.event.remove(i, n) : C.removeEvent(i, n, t.handle);
            i[V.expando] = void 0;
          }
          i[G.expando] && (i[G.expando] = void 0);
        }
    },
  }),
    C.fn.extend({
      detach: function (e) {
        return je(this, e, !0);
      },
      remove: function (e) {
        return je(this, e);
      },
      text: function (e) {
        return F(
          this,
          function (e) {
            return void 0 === e
              ? C.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return Ne(this, arguments, function (e) {
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            $e(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return Ne(this, arguments, function (e) {
          var t;
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            (t = $e(this, e)).insertBefore(e, t.firstChild);
        });
      },
      before: function () {
        return Ne(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return Ne(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (C.cleanData(pe(e, !1)), (e.textContent = ""));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return C.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return F(
          this,
          function (e) {
            var t = this[0] || {},
              i = 0,
              n = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              "string" == typeof e &&
              !Se.test(e) &&
              !ue[(ce.exec(e) || ["", ""])[1].toLowerCase()]
            ) {
              e = C.htmlPrefilter(e);
              try {
                for (; i < n; i++)
                  1 === (t = this[i] || {}).nodeType &&
                    (C.cleanData(pe(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var i = [];
        return Ne(
          this,
          arguments,
          function (e) {
            var t = this.parentNode;
            C.inArray(this, i) < 0 &&
              (C.cleanData(pe(this)), t && t.replaceChild(e, this));
          },
          i
        );
      },
    }),
    C.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (e, s) {
        C.fn[e] = function (e) {
          for (var t, i = [], n = C(e), o = n.length - 1, r = 0; r <= o; r++)
            (t = r === o ? this : this.clone(!0)),
              C(n[r])[s](t),
              l.apply(i, t.get());
          return this.pushStack(i);
        };
      }
    );
  function He(e) {
    var t = e.ownerDocument.defaultView;
    return (t = !t || !t.opener ? x : t).getComputedStyle(e);
  }
  var Oe,
    Pe,
    Me,
    qe,
    We,
    Ie,
    _e,
    Fe = new RegExp("^(" + ie + ")(?!px)[a-z%]+$", "i"),
    Re = new RegExp(oe.join("|"), "i");
  function Be() {
    var e;
    _e &&
      ((Ie.style.cssText =
        "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
      (_e.style.cssText =
        "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
      ve.appendChild(Ie).appendChild(_e),
      (e = x.getComputedStyle(_e)),
      (Oe = "1%" !== e.top),
      (We = 12 === Ue(e.marginLeft)),
      (_e.style.right = "60%"),
      (qe = 36 === Ue(e.right)),
      (Pe = 36 === Ue(e.width)),
      (_e.style.position = "absolute"),
      (Me = 36 === _e.offsetWidth || "absolute"),
      ve.removeChild(Ie),
      (_e = null));
  }
  function Ue(e) {
    return Math.round(parseFloat(e));
  }
  function Xe(e, t, i) {
    var n,
      o,
      r = e.style;
    return (
      (i = i || He(e)) &&
        ("" !== (o = i.getPropertyValue(t) || i[t]) ||
          C.contains(e.ownerDocument, e) ||
          (o = C.style(e, t)),
        !w.pixelBoxStyles() &&
          Fe.test(o) &&
          Re.test(t) &&
          ((n = r.width),
          (e = r.minWidth),
          (t = r.maxWidth),
          (r.minWidth = r.maxWidth = r.width = o),
          (o = i.width),
          (r.width = n),
          (r.minWidth = e),
          (r.maxWidth = t))),
      void 0 !== o ? o + "" : o
    );
  }
  function Ye(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      },
    };
  }
  (Ie = T.createElement("div")),
    (_e = T.createElement("div")).style &&
      ((_e.style.backgroundClip = "content-box"),
      (_e.cloneNode(!0).style.backgroundClip = ""),
      (w.clearCloneStyle = "content-box" === _e.style.backgroundClip),
      C.extend(w, {
        boxSizingReliable: function () {
          return Be(), Pe;
        },
        pixelBoxStyles: function () {
          return Be(), qe;
        },
        pixelPosition: function () {
          return Be(), Oe;
        },
        reliableMarginLeft: function () {
          return Be(), We;
        },
        scrollboxSize: function () {
          return Be(), Me;
        },
      }));
  var Qe = /^(none|table(?!-c[ea]).+)/,
    Ve = /^--/,
    Ge = { position: "absolute", visibility: "hidden", display: "block" },
    Je = { letterSpacing: "0", fontWeight: "400" },
    Ke = ["Webkit", "Moz", "ms"],
    Ze = T.createElement("div").style;
  function et(e) {
    return (
      C.cssProps[e] ||
      (C.cssProps[e] =
        (function (e) {
          if (e in Ze) return e;
          for (var t = e[0].toUpperCase() + e.slice(1), i = Ke.length; i--; )
            if ((e = Ke[i] + t) in Ze) return e;
        })(e) || e)
    );
  }
  function tt(e, t, i) {
    var n = ne.exec(t);
    return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : t;
  }
  function it(e, t, i, n, o, r) {
    var s = "width" === t ? 1 : 0,
      a = 0,
      l = 0;
    if (i === (n ? "border" : "content")) return 0;
    for (; s < 4; s += 2)
      "margin" === i && (l += C.css(e, i + oe[s], !0, o)),
        n
          ? ("content" === i && (l -= C.css(e, "padding" + oe[s], !0, o)),
            "margin" !== i &&
              (l -= C.css(e, "border" + oe[s] + "Width", !0, o)))
          : ((l += C.css(e, "padding" + oe[s], !0, o)),
            "padding" !== i
              ? (l += C.css(e, "border" + oe[s] + "Width", !0, o))
              : (a += C.css(e, "border" + oe[s] + "Width", !0, o)));
    return (
      !n &&
        0 <= r &&
        (l += Math.max(
          0,
          Math.ceil(
            e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - a - 0.5
          )
        )),
      l
    );
  }
  function nt(e, t, i) {
    var n = He(e),
      o = Xe(e, t, n),
      r = "border-box" === C.css(e, "boxSizing", !1, n),
      s = r;
    if (Fe.test(o)) {
      if (!i) return o;
      o = "auto";
    }
    return (
      (s = s && (w.boxSizingReliable() || o === e.style[t])),
      ("auto" !== o &&
        (parseFloat(o) || "inline" !== C.css(e, "display", !1, n))) ||
        ((o = e["offset" + t[0].toUpperCase() + t.slice(1)]), (s = !0)),
      (o = parseFloat(o) || 0) +
        it(e, t, i || (r ? "border" : "content"), s, n, o) +
        "px"
    );
  }
  function ot(e, t, i, n, o) {
    return new ot.prototype.init(e, t, i, n, o);
  }
  C.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            e = Xe(e, "opacity");
            return "" === e ? "1" : e;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: {},
    style: function (e, t, i, n) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var o,
          r,
          s,
          a = X(t),
          l = Ve.test(t),
          c = e.style;
        if (
          (l || (t = et(a)), (s = C.cssHooks[t] || C.cssHooks[a]), void 0 === i)
        )
          return s && "get" in s && void 0 !== (o = s.get(e, !1, n)) ? o : c[t];
        "string" == (r = typeof i) &&
          (o = ne.exec(i)) &&
          o[1] &&
          ((i = re(e, t, o)), (r = "number")),
          null != i &&
            i == i &&
            ("number" === r &&
              (i += (o && o[3]) || (C.cssNumber[a] ? "" : "px")),
            w.clearCloneStyle ||
              "" !== i ||
              0 !== t.indexOf("background") ||
              (c[t] = "inherit"),
            (s && "set" in s && void 0 === (i = s.set(e, i, n))) ||
              (l ? c.setProperty(t, i) : (c[t] = i)));
      }
    },
    css: function (e, t, i, n) {
      var o,
        r = X(t);
      return (
        Ve.test(t) || (t = et(r)),
        "normal" ===
          (o =
            void 0 ===
            (o =
              (r = C.cssHooks[t] || C.cssHooks[r]) && "get" in r
                ? r.get(e, !0, i)
                : o)
              ? Xe(e, t, n)
              : o) &&
          t in Je &&
          (o = Je[t]),
        "" === i || i
          ? ((t = parseFloat(o)), !0 === i || isFinite(t) ? t || 0 : o)
          : o
      );
    },
  }),
    C.each(["height", "width"], function (e, s) {
      C.cssHooks[s] = {
        get: function (e, t, i) {
          if (t)
            return !Qe.test(C.css(e, "display")) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? nt(e, s, i)
              : te(e, Ge, function () {
                  return nt(e, s, i);
                });
        },
        set: function (e, t, i) {
          var n,
            o = He(e),
            r = "border-box" === C.css(e, "boxSizing", !1, o),
            i = i && it(e, s, i, r, o);
          return (
            r &&
              w.scrollboxSize() === o.position &&
              (i -= Math.ceil(
                e["offset" + s[0].toUpperCase() + s.slice(1)] -
                  parseFloat(o[s]) -
                  it(e, s, "border", !1, o) -
                  0.5
              )),
            i &&
              (n = ne.exec(t)) &&
              "px" !== (n[3] || "px") &&
              ((e.style[s] = t), (t = C.css(e, s))),
            tt(0, t, i)
          );
        },
      };
    }),
    (C.cssHooks.marginLeft = Ye(w.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(Xe(e, "marginLeft")) ||
            e.getBoundingClientRect().left -
              te(e, { marginLeft: 0 }, function () {
                return e.getBoundingClientRect().left;
              })) + "px"
        );
    })),
    C.each({ margin: "", padding: "", border: "Width" }, function (o, r) {
      (C.cssHooks[o + r] = {
        expand: function (e) {
          for (
            var t = 0, i = {}, n = "string" == typeof e ? e.split(" ") : [e];
            t < 4;
            t++
          )
            i[o + oe[t] + r] = n[t] || n[t - 2] || n[0];
          return i;
        },
      }),
        "margin" !== o && (C.cssHooks[o + r].set = tt);
    }),
    C.fn.extend({
      css: function (e, t) {
        return F(
          this,
          function (e, t, i) {
            var n,
              o,
              r = {},
              s = 0;
            if (Array.isArray(t)) {
              for (n = He(e), o = t.length; s < o; s++)
                r[t[s]] = C.css(e, t[s], !1, n);
              return r;
            }
            return void 0 !== i ? C.style(e, t, i) : C.css(e, t);
          },
          e,
          t,
          1 < arguments.length
        );
      },
    }),
    (((C.Tween = ot).prototype = {
      constructor: ot,
      init: function (e, t, i, n, o, r) {
        (this.elem = e),
          (this.prop = i),
          (this.easing = o || C.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = n),
          (this.unit = r || (C.cssNumber[i] ? "" : "px"));
      },
      cur: function () {
        var e = ot.propHooks[this.prop];
        return (e && e.get ? e : ot.propHooks._default).get(this);
      },
      run: function (e) {
        var t,
          i = ot.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t =
                C.easing[this.easing](
                  e,
                  this.options.duration * e,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          (i && i.set ? i : ot.propHooks._default).set(this),
          this
        );
      },
    }).init.prototype = ot.prototype),
    ((ot.propHooks = {
      _default: {
        get: function (e) {
          return 1 !== e.elem.nodeType ||
            (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (e = C.css(e.elem, e.prop, "")) && "auto" !== e
            ? e
            : 0;
        },
        set: function (e) {
          C.fx.step[e.prop]
            ? C.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (null == e.elem.style[C.cssProps[e.prop]] && !C.cssHooks[e.prop])
            ? (e.elem[e.prop] = e.now)
            : C.style(e.elem, e.prop, e.now + e.unit);
        },
      },
    }).scrollTop = ot.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        },
      }),
    (C.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (C.fx = ot.prototype.init),
    (C.fx.step = {});
  var rt,
    st,
    at = /^(?:toggle|show|hide)$/,
    lt = /queueHooks$/;
  function ct() {
    st &&
      (!1 === T.hidden && x.requestAnimationFrame
        ? x.requestAnimationFrame(ct)
        : x.setTimeout(ct, C.fx.interval),
      C.fx.tick());
  }
  function dt() {
    return (
      x.setTimeout(function () {
        rt = void 0;
      }),
      (rt = Date.now())
    );
  }
  function ut(e, t) {
    var i,
      n = 0,
      o = { height: e };
    for (t = t ? 1 : 0; n < 4; n += 2 - t)
      o["margin" + (i = oe[n])] = o["padding" + i] = e;
    return t && (o.opacity = o.width = e), o;
  }
  function pt(e, t, i) {
    for (
      var n,
        o = (ft.tweeners[t] || []).concat(ft.tweeners["*"]),
        r = 0,
        s = o.length;
      r < s;
      r++
    )
      if ((n = o[r].call(i, t, e))) return n;
  }
  function ft(o, e, t) {
    var i,
      r,
      n = 0,
      s = ft.prefilters.length,
      a = C.Deferred().always(function () {
        delete l.elem;
      }),
      l = function () {
        if (r) return !1;
        for (
          var e = rt || dt(),
            e = Math.max(0, c.startTime + c.duration - e),
            t = 1 - (e / c.duration || 0),
            i = 0,
            n = c.tweens.length;
          i < n;
          i++
        )
          c.tweens[i].run(t);
        return (
          a.notifyWith(o, [c, t, e]),
          t < 1 && n
            ? e
            : (n || a.notifyWith(o, [c, 1, 0]), a.resolveWith(o, [c]), !1)
        );
      },
      c = a.promise({
        elem: o,
        props: C.extend({}, e),
        opts: C.extend(!0, { specialEasing: {}, easing: C.easing._default }, t),
        originalProperties: e,
        originalOptions: t,
        startTime: rt || dt(),
        duration: t.duration,
        tweens: [],
        createTween: function (e, t) {
          e = C.Tween(
            o,
            c.opts,
            e,
            t,
            c.opts.specialEasing[e] || c.opts.easing
          );
          return c.tweens.push(e), e;
        },
        stop: function (e) {
          var t = 0,
            i = e ? c.tweens.length : 0;
          if (r) return this;
          for (r = !0; t < i; t++) c.tweens[t].run(1);
          return (
            e
              ? (a.notifyWith(o, [c, 1, 0]), a.resolveWith(o, [c, e]))
              : a.rejectWith(o, [c, e]),
            this
          );
        },
      }),
      d = c.props;
    for (
      (function (e, t) {
        var i, n, o, r, s;
        for (i in e)
          if (
            ((n = X(i)),
            (o = t[n]),
            (r = e[i]),
            Array.isArray(r) && ((o = r[1]), (r = e[i] = r[0])),
            i !== n && ((e[n] = r), delete e[i]),
            (s = C.cssHooks[n]) && ("expand" in s))
          )
            for (i in ((r = s.expand(r)), delete e[n], r))
              (i in e) || ((e[i] = r[i]), (t[i] = o));
          else t[n] = o;
      })(d, c.opts.specialEasing);
      n < s;
      n++
    )
      if ((i = ft.prefilters[n].call(c, o, d, c.opts)))
        return (
          g(i.stop) &&
            (C._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)),
          i
        );
    return (
      C.map(d, pt, c),
      g(c.opts.start) && c.opts.start.call(o, c),
      c
        .progress(c.opts.progress)
        .done(c.opts.done, c.opts.complete)
        .fail(c.opts.fail)
        .always(c.opts.always),
      C.fx.timer(C.extend(l, { elem: o, anim: c, queue: c.opts.queue })),
      c
    );
  }
  (C.Animation = C.extend(ft, {
    tweeners: {
      "*": [
        function (e, t) {
          var i = this.createTween(e, t);
          return re(i.elem, e, ne.exec(t), i), i;
        },
      ],
    },
    tweener: function (e, t) {
      for (
        var i, n = 0, o = (e = g(e) ? ((t = e), ["*"]) : e.match(O)).length;
        n < o;
        n++
      )
        (i = e[n]),
          (ft.tweeners[i] = ft.tweeners[i] || []),
          ft.tweeners[i].unshift(t);
    },
    prefilters: [
      function (e, t, i) {
        var n,
          o,
          r,
          s,
          a,
          l,
          c,
          d = "width" in t || "height" in t,
          u = this,
          p = {},
          f = e.style,
          h = e.nodeType && ee(e),
          g = V.get(e, "fxshow");
        for (n in (i.queue ||
          (null == (s = C._queueHooks(e, "fx")).unqueued &&
            ((s.unqueued = 0),
            (a = s.empty.fire),
            (s.empty.fire = function () {
              s.unqueued || a();
            })),
          s.unqueued++,
          u.always(function () {
            u.always(function () {
              s.unqueued--, C.queue(e, "fx").length || s.empty.fire();
            });
          })),
        t))
          if (((o = t[n]), at.test(o))) {
            if (
              (delete t[n],
              (r = r || "toggle" === o),
              o === (h ? "hide" : "show"))
            ) {
              if ("show" !== o || !g || void 0 === g[n]) continue;
              h = !0;
            }
            p[n] = (g && g[n]) || C.style(e, n);
          }
        if ((l = !C.isEmptyObject(t)) || !C.isEmptyObject(p))
          for (n in (d &&
            1 === e.nodeType &&
            ((i.overflow = [f.overflow, f.overflowX, f.overflowY]),
            null == (c = g && g.display) && (c = V.get(e, "display")),
            "none" === (d = C.css(e, "display")) &&
              (c
                ? (d = c)
                : (ae([e], !0),
                  (c = e.style.display || c),
                  (d = C.css(e, "display")),
                  ae([e]))),
            ("inline" === d || ("inline-block" === d && null != c)) &&
              "none" === C.css(e, "float") &&
              (l ||
                (u.done(function () {
                  f.display = c;
                }),
                null == c && ((d = f.display), (c = "none" === d ? "" : d))),
              (f.display = "inline-block"))),
          i.overflow &&
            ((f.overflow = "hidden"),
            u.always(function () {
              (f.overflow = i.overflow[0]),
                (f.overflowX = i.overflow[1]),
                (f.overflowY = i.overflow[2]);
            })),
          (l = !1),
          p))
            l ||
              (g
                ? "hidden" in g && (h = g.hidden)
                : (g = V.access(e, "fxshow", { display: c })),
              r && (g.hidden = !h),
              h && ae([e], !0),
              u.done(function () {
                for (n in (h || ae([e]), V.remove(e, "fxshow"), p))
                  C.style(e, n, p[n]);
              })),
              (l = pt(h ? g[n] : 0, n, u)),
              n in g ||
                ((g[n] = l.start), h && ((l.end = l.start), (l.start = 0)));
      },
    ],
    prefilter: function (e, t) {
      t ? ft.prefilters.unshift(e) : ft.prefilters.push(e);
    },
  })),
    (C.speed = function (e, t, i) {
      var n =
        e && "object" == typeof e
          ? C.extend({}, e)
          : {
              complete: i || (!i && t) || (g(e) && e),
              duration: e,
              easing: (i && t) || (t && !g(t) && t),
            };
      return (
        C.fx.off
          ? (n.duration = 0)
          : "number" != typeof n.duration &&
            (n.duration in C.fx.speeds
              ? (n.duration = C.fx.speeds[n.duration])
              : (n.duration = C.fx.speeds._default)),
        (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
        (n.old = n.complete),
        (n.complete = function () {
          g(n.old) && n.old.call(this), n.queue && C.dequeue(this, n.queue);
        }),
        n
      );
    }),
    C.fn.extend({
      fadeTo: function (e, t, i, n) {
        return this.filter(ee)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: t }, e, i, n);
      },
      animate: function (t, e, i, n) {
        var o = C.isEmptyObject(t),
          r = C.speed(e, i, n),
          n = function () {
            var e = ft(this, C.extend({}, t), r);
            (o || V.get(this, "finish")) && e.stop(!0);
          };
        return (
          (n.finish = n),
          o || !1 === r.queue ? this.each(n) : this.queue(r.queue, n)
        );
      },
      stop: function (o, e, r) {
        function s(e) {
          var t = e.stop;
          delete e.stop, t(r);
        }
        return (
          "string" != typeof o && ((r = e), (e = o), (o = void 0)),
          e && !1 !== o && this.queue(o || "fx", []),
          this.each(function () {
            var e = !0,
              t = null != o && o + "queueHooks",
              i = C.timers,
              n = V.get(this);
            if (t) n[t] && n[t].stop && s(n[t]);
            else for (t in n) n[t] && n[t].stop && lt.test(t) && s(n[t]);
            for (t = i.length; t--; )
              i[t].elem !== this ||
                (null != o && i[t].queue !== o) ||
                (i[t].anim.stop(r), (e = !1), i.splice(t, 1));
            (!e && r) || C.dequeue(this, o);
          })
        );
      },
      finish: function (s) {
        return (
          !1 !== s && (s = s || "fx"),
          this.each(function () {
            var e,
              t = V.get(this),
              i = t[s + "queue"],
              n = t[s + "queueHooks"],
              o = C.timers,
              r = i ? i.length : 0;
            for (
              t.finish = !0,
                C.queue(this, s, []),
                n && n.stop && n.stop.call(this, !0),
                e = o.length;
              e--;

            )
              o[e].elem === this &&
                o[e].queue === s &&
                (o[e].anim.stop(!0), o.splice(e, 1));
            for (e = 0; e < r; e++)
              i[e] && i[e].finish && i[e].finish.call(this);
            delete t.finish;
          })
        );
      },
    }),
    C.each(["toggle", "show", "hide"], function (e, n) {
      var o = C.fn[n];
      C.fn[n] = function (e, t, i) {
        return null == e || "boolean" == typeof e
          ? o.apply(this, arguments)
          : this.animate(ut(n, !0), e, t, i);
      };
    }),
    C.each(
      {
        slideDown: ut("show"),
        slideUp: ut("hide"),
        slideToggle: ut("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (e, n) {
        C.fn[e] = function (e, t, i) {
          return this.animate(n, e, t, i);
        };
      }
    ),
    (C.timers = []),
    (C.fx.tick = function () {
      var e,
        t = 0,
        i = C.timers;
      for (rt = Date.now(); t < i.length; t++)
        (e = i[t])() || i[t] !== e || i.splice(t--, 1);
      i.length || C.fx.stop(), (rt = void 0);
    }),
    (C.fx.timer = function (e) {
      C.timers.push(e), C.fx.start();
    }),
    (C.fx.interval = 13),
    (C.fx.start = function () {
      st || ((st = !0), ct());
    }),
    (C.fx.stop = function () {
      st = null;
    }),
    (C.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (C.fn.delay = function (n, e) {
      return (
        (n = (C.fx && C.fx.speeds[n]) || n),
        this.queue((e = e || "fx"), function (e, t) {
          var i = x.setTimeout(e, n);
          t.stop = function () {
            x.clearTimeout(i);
          };
        })
      );
    }),
    (t = T.createElement("input")),
    (ie = T.createElement("select").appendChild(T.createElement("option"))),
    (t.type = "checkbox"),
    (w.checkOn = "" !== t.value),
    (w.optSelected = ie.selected),
    ((t = T.createElement("input")).value = "t"),
    (t.type = "radio"),
    (w.radioValue = "t" === t.value);
  var ht,
    gt = C.expr.attrHandle;
  C.fn.extend({
    attr: function (e, t) {
      return F(this, C.attr, e, t, 1 < arguments.length);
    },
    removeAttr: function (e) {
      return this.each(function () {
        C.removeAttr(this, e);
      });
    },
  }),
    C.extend({
      attr: function (e, t, i) {
        var n,
          o,
          r = e.nodeType;
        if (3 !== r && 8 !== r && 2 !== r)
          return void 0 === e.getAttribute
            ? C.prop(e, t, i)
            : ((1 === r && C.isXMLDoc(e)) ||
                (o =
                  C.attrHooks[t.toLowerCase()] ||
                  (C.expr.match.bool.test(t) ? ht : void 0)),
              void 0 !== i
                ? null === i
                  ? void C.removeAttr(e, t)
                  : o && "set" in o && void 0 !== (n = o.set(e, i, t))
                  ? n
                  : (e.setAttribute(t, i + ""), i)
                : !(o && "get" in o && null !== (n = o.get(e, t))) &&
                  null == (n = C.find.attr(e, t))
                ? void 0
                : n);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!w.radioValue && "radio" === t && E(e, "input")) {
              var i = e.value;
              return e.setAttribute("type", t), i && (e.value = i), t;
            }
          },
        },
      },
      removeAttr: function (e, t) {
        var i,
          n = 0,
          o = t && t.match(O);
        if (o && 1 === e.nodeType) for (; (i = o[n++]); ) e.removeAttribute(i);
      },
    }),
    (ht = {
      set: function (e, t, i) {
        return !1 === t ? C.removeAttr(e, i) : e.setAttribute(i, i), i;
      },
    }),
    C.each(C.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var s = gt[t] || C.find.attr;
      gt[t] = function (e, t, i) {
        var n,
          o,
          r = t.toLowerCase();
        return (
          i ||
            ((o = gt[r]),
            (gt[r] = n),
            (n = null != s(e, t, i) ? r : null),
            (gt[r] = o)),
          n
        );
      };
    });
  var vt = /^(?:input|select|textarea|button)$/i,
    mt = /^(?:a|area)$/i;
  function yt(e) {
    return (e.match(O) || []).join(" ");
  }
  function wt(e) {
    return (e.getAttribute && e.getAttribute("class")) || "";
  }
  function bt(e) {
    return Array.isArray(e) ? e : ("string" == typeof e && e.match(O)) || [];
  }
  C.fn.extend({
    prop: function (e, t) {
      return F(this, C.prop, e, t, 1 < arguments.length);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[C.propFix[e] || e];
      });
    },
  }),
    C.extend({
      prop: function (e, t, i) {
        var n,
          o,
          r = e.nodeType;
        if (3 !== r && 8 !== r && 2 !== r)
          return (
            (1 === r && C.isXMLDoc(e)) ||
              ((t = C.propFix[t] || t), (o = C.propHooks[t])),
            void 0 !== i
              ? o && "set" in o && void 0 !== (n = o.set(e, i, t))
                ? n
                : (e[t] = i)
              : o && "get" in o && null !== (n = o.get(e, t))
              ? n
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = C.find.attr(e, "tabindex");
            return t
              ? parseInt(t, 10)
              : vt.test(e.nodeName) || (mt.test(e.nodeName) && e.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    w.optSelected ||
      (C.propHooks.selected = {
        get: function (e) {
          e = e.parentNode;
          return e && e.parentNode && e.parentNode.selectedIndex, null;
        },
        set: function (e) {
          e = e.parentNode;
          e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex);
        },
      }),
    C.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        C.propFix[this.toLowerCase()] = this;
      }
    ),
    C.fn.extend({
      addClass: function (t) {
        var e,
          i,
          n,
          o,
          r,
          s,
          a = 0;
        if (g(t))
          return this.each(function (e) {
            C(this).addClass(t.call(this, e, wt(this)));
          });
        if ((e = bt(t)).length)
          for (; (i = this[a++]); )
            if (((s = wt(i)), (n = 1 === i.nodeType && " " + yt(s) + " "))) {
              for (r = 0; (o = e[r++]); )
                n.indexOf(" " + o + " ") < 0 && (n += o + " ");
              s !== (s = yt(n)) && i.setAttribute("class", s);
            }
        return this;
      },
      removeClass: function (t) {
        var e,
          i,
          n,
          o,
          r,
          s,
          a = 0;
        if (g(t))
          return this.each(function (e) {
            C(this).removeClass(t.call(this, e, wt(this)));
          });
        if (!arguments.length) return this.attr("class", "");
        if ((e = bt(t)).length)
          for (; (i = this[a++]); )
            if (((s = wt(i)), (n = 1 === i.nodeType && " " + yt(s) + " "))) {
              for (r = 0; (o = e[r++]); )
                for (; -1 < n.indexOf(" " + o + " "); )
                  n = n.replace(" " + o + " ", " ");
              s !== (s = yt(n)) && i.setAttribute("class", s);
            }
        return this;
      },
      toggleClass: function (o, t) {
        var r = typeof o,
          s = "string" == r || Array.isArray(o);
        return "boolean" == typeof t && s
          ? t
            ? this.addClass(o)
            : this.removeClass(o)
          : g(o)
          ? this.each(function (e) {
              C(this).toggleClass(o.call(this, e, wt(this), t), t);
            })
          : this.each(function () {
              var e, t, i, n;
              if (s)
                for (t = 0, i = C(this), n = bt(o); (e = n[t++]); )
                  i.hasClass(e) ? i.removeClass(e) : i.addClass(e);
              else
                (void 0 !== o && "boolean" != r) ||
                  ((e = wt(this)) && V.set(this, "__className__", e),
                  this.setAttribute &&
                    this.setAttribute(
                      "class",
                      (!e && !1 !== o && V.get(this, "__className__")) || ""
                    ));
            });
      },
      hasClass: function (e) {
        for (var t, i = 0, n = " " + e + " "; (t = this[i++]); )
          if (1 === t.nodeType && -1 < (" " + yt(wt(t)) + " ").indexOf(n))
            return !0;
        return !1;
      },
    });
  var kt = /\r/g;
  C.fn.extend({
    val: function (t) {
      var i,
        e,
        n,
        o = this[0];
      return arguments.length
        ? ((n = g(t)),
          this.each(function (e) {
            1 === this.nodeType &&
              (null == (e = n ? t.call(this, e, C(this).val()) : t)
                ? (e = "")
                : "number" == typeof e
                ? (e += "")
                : Array.isArray(e) &&
                  (e = C.map(e, function (e) {
                    return null == e ? "" : e + "";
                  })),
              ((i =
                C.valHooks[this.type] ||
                C.valHooks[this.nodeName.toLowerCase()]) &&
                "set" in i &&
                void 0 !== i.set(this, e, "value")) ||
                (this.value = e));
          }))
        : o
        ? (i = C.valHooks[o.type] || C.valHooks[o.nodeName.toLowerCase()]) &&
          "get" in i &&
          void 0 !== (e = i.get(o, "value"))
          ? e
          : "string" == typeof (e = o.value)
          ? e.replace(kt, "")
          : null == e
          ? ""
          : e
        : void 0;
    },
  }),
    C.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = C.find.attr(e, "value");
            return null != t ? t : yt(C.text(e));
          },
        },
        select: {
          get: function (e) {
            for (
              var t,
                i = e.options,
                n = e.selectedIndex,
                o = "select-one" === e.type,
                r = o ? null : [],
                s = o ? n + 1 : i.length,
                a = n < 0 ? s : o ? n : 0;
              a < s;
              a++
            )
              if (
                ((t = i[a]).selected || a === n) &&
                !t.disabled &&
                (!t.parentNode.disabled || !E(t.parentNode, "optgroup"))
              ) {
                if (((t = C(t).val()), o)) return t;
                r.push(t);
              }
            return r;
          },
          set: function (e, t) {
            for (
              var i, n, o = e.options, r = C.makeArray(t), s = o.length;
              s--;

            )
              ((n = o[s]).selected =
                -1 < C.inArray(C.valHooks.option.get(n), r)) && (i = !0);
            return i || (e.selectedIndex = -1), r;
          },
        },
      },
    }),
    C.each(["radio", "checkbox"], function () {
      (C.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t))
            return (e.checked = -1 < C.inArray(C(e).val(), t));
        },
      }),
        w.checkOn ||
          (C.valHooks[this].get = function (e) {
            return null === e.getAttribute("value") ? "on" : e.value;
          });
    }),
    (w.focusin = "onfocusin" in x);
  function xt(e) {
    e.stopPropagation();
  }
  var Tt = /^(?:focusinfocus|focusoutblur)$/;
  C.extend(C.event, {
    trigger: function (e, t, i, n) {
      var o,
        r,
        s,
        a,
        l,
        c,
        d,
        u = [i || T],
        p = y.call(e, "type") ? e.type : e,
        f = y.call(e, "namespace") ? e.namespace.split(".") : [],
        h = (d = r = i = i || T);
      if (
        3 !== i.nodeType &&
        8 !== i.nodeType &&
        !Tt.test(p + C.event.triggered) &&
        (-1 < p.indexOf(".") && ((p = (f = p.split(".")).shift()), f.sort()),
        (a = p.indexOf(":") < 0 && "on" + p),
        ((e = e[C.expando]
          ? e
          : new C.Event(p, "object" == typeof e && e)).isTrigger = n ? 2 : 3),
        (e.namespace = f.join(".")),
        (e.rnamespace = e.namespace
          ? new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)")
          : null),
        (e.result = void 0),
        e.target || (e.target = i),
        (t = null == t ? [e] : C.makeArray(t, [e])),
        (c = C.event.special[p] || {}),
        n || !c.trigger || !1 !== c.trigger.apply(i, t))
      ) {
        if (!n && !c.noBubble && !v(i)) {
          for (
            s = c.delegateType || p, Tt.test(s + p) || (h = h.parentNode);
            h;
            h = h.parentNode
          )
            u.push(h), (r = h);
          r === (i.ownerDocument || T) &&
            u.push(r.defaultView || r.parentWindow || x);
        }
        for (o = 0; (h = u[o++]) && !e.isPropagationStopped(); )
          (d = h),
            (e.type = 1 < o ? s : c.bindType || p),
            (l = (V.get(h, "events") || {})[e.type] && V.get(h, "handle")) &&
              l.apply(h, t),
            (l = a && h[a]) &&
              l.apply &&
              Y(h) &&
              ((e.result = l.apply(h, t)),
              !1 === e.result && e.preventDefault());
        return (
          (e.type = p),
          n ||
            e.isDefaultPrevented() ||
            (c._default && !1 !== c._default.apply(u.pop(), t)) ||
            !Y(i) ||
            (a &&
              g(i[p]) &&
              !v(i) &&
              ((r = i[a]) && (i[a] = null),
              (C.event.triggered = p),
              e.isPropagationStopped() && d.addEventListener(p, xt),
              i[p](),
              e.isPropagationStopped() && d.removeEventListener(p, xt),
              (C.event.triggered = void 0),
              r && (i[a] = r))),
          e.result
        );
      }
    },
    simulate: function (e, t, i) {
      e = C.extend(new C.Event(), i, { type: e, isSimulated: !0 });
      C.event.trigger(e, null, t);
    },
  }),
    C.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          C.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var i = this[0];
        if (i) return C.event.trigger(e, t, i, !0);
      },
    }),
    w.focusin ||
      C.each({ focus: "focusin", blur: "focusout" }, function (i, n) {
        function o(e) {
          C.event.simulate(n, e.target, C.event.fix(e));
        }
        C.event.special[n] = {
          setup: function () {
            var e = this.ownerDocument || this,
              t = V.access(e, n);
            t || e.addEventListener(i, o, !0), V.access(e, n, (t || 0) + 1);
          },
          teardown: function () {
            var e = this.ownerDocument || this,
              t = V.access(e, n) - 1;
            t
              ? V.access(e, n, t)
              : (e.removeEventListener(i, o, !0), V.remove(e, n));
          },
        };
      });
  var Ct = x.location,
    St = Date.now(),
    At = /\?/;
  C.parseXML = function (e) {
    var t;
    if (!e || "string" != typeof e) return null;
    try {
      t = new x.DOMParser().parseFromString(e, "text/xml");
    } catch (e) {
      t = void 0;
    }
    return (
      (t && !t.getElementsByTagName("parsererror").length) ||
        C.error("Invalid XML: " + e),
      t
    );
  };
  var Et = /\[\]$/,
    $t = /\r?\n/g,
    zt = /^(?:submit|button|image|reset|file)$/i,
    Dt = /^(?:input|select|textarea|keygen)/i;
  (C.param = function (e, t) {
    function i(e, t) {
      (t = g(t) ? t() : t),
        (o[o.length] =
          encodeURIComponent(e) + "=" + encodeURIComponent(null == t ? "" : t));
    }
    var n,
      o = [];
    if (Array.isArray(e) || (e.jquery && !C.isPlainObject(e)))
      C.each(e, function () {
        i(this.name, this.value);
      });
    else
      for (n in e)
        !(function i(n, e, o, r) {
          if (Array.isArray(e))
            C.each(e, function (e, t) {
              o || Et.test(n)
                ? r(n, t)
                : i(
                    n +
                      "[" +
                      ("object" == typeof t && null != t ? e : "") +
                      "]",
                    t,
                    o,
                    r
                  );
            });
          else if (o || "object" !== h(e)) r(n, e);
          else for (var t in e) i(n + "[" + t + "]", e[t], o, r);
        })(n, e[n], t, i);
    return o.join("&");
  }),
    C.fn.extend({
      serialize: function () {
        return C.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = C.prop(this, "elements");
          return e ? C.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !C(this).is(":disabled") &&
              Dt.test(this.nodeName) &&
              !zt.test(e) &&
              (this.checked || !le.test(e))
            );
          })
          .map(function (e, t) {
            var i = C(this).val();
            return null == i
              ? null
              : Array.isArray(i)
              ? C.map(i, function (e) {
                  return { name: t.name, value: e.replace($t, "\r\n") };
                })
              : { name: t.name, value: i.replace($t, "\r\n") };
          })
          .get();
      },
    });
  var Lt = /%20/g,
    Nt = /#.*$/,
    jt = /([?&])_=[^&]*/,
    Ht = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Ot = /^(?:GET|HEAD)$/,
    Pt = /^\/\//,
    Mt = {},
    qt = {},
    Wt = "*/".concat("*"),
    It = T.createElement("a");
  function _t(r) {
    return function (e, t) {
      "string" != typeof e && ((t = e), (e = "*"));
      var i,
        n = 0,
        o = e.toLowerCase().match(O) || [];
      if (g(t))
        for (; (i = o[n++]); )
          "+" === i[0]
            ? ((i = i.slice(1) || "*"), (r[i] = r[i] || []).unshift(t))
            : (r[i] = r[i] || []).push(t);
    };
  }
  function Ft(t, n, o, r) {
    var s = {},
      a = t === qt;
    function l(e) {
      var i;
      return (
        (s[e] = !0),
        C.each(t[e] || [], function (e, t) {
          t = t(n, o, r);
          return "string" != typeof t || a || s[t]
            ? a
              ? !(i = t)
              : void 0
            : (n.dataTypes.unshift(t), l(t), !1);
        }),
        i
      );
    }
    return l(n.dataTypes[0]) || (!s["*"] && l("*"));
  }
  function Rt(e, t) {
    var i,
      n,
      o = C.ajaxSettings.flatOptions || {};
    for (i in t) void 0 !== t[i] && ((o[i] ? e : (n = n || {}))[i] = t[i]);
    return n && C.extend(!0, e, n), e;
  }
  (It.href = Ct.href),
    C.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Ct.href,
        type: "GET",
        isLocal:
          /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
            Ct.protocol
          ),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": Wt,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": JSON.parse,
          "text xml": C.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (e, t) {
        return t ? Rt(Rt(e, C.ajaxSettings), t) : Rt(C.ajaxSettings, e);
      },
      ajaxPrefilter: _t(Mt),
      ajaxTransport: _t(qt),
      ajax: function (e, t) {
        "object" == typeof e && ((t = e), (e = void 0));
        var l,
          c,
          d,
          i,
          u,
          p,
          f,
          n,
          o,
          h = C.ajaxSetup({}, (t = t || {})),
          g = h.context || h,
          v = h.context && (g.nodeType || g.jquery) ? C(g) : C.event,
          m = C.Deferred(),
          y = C.Callbacks("once memory"),
          w = h.statusCode || {},
          r = {},
          s = {},
          a = "canceled",
          b = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (p) {
                if (!i)
                  for (i = {}; (t = Ht.exec(d)); ) i[t[1].toLowerCase()] = t[2];
                t = i[e.toLowerCase()];
              }
              return null == t ? null : t;
            },
            getAllResponseHeaders: function () {
              return p ? d : null;
            },
            setRequestHeader: function (e, t) {
              return (
                null == p &&
                  ((e = s[e.toLowerCase()] = s[e.toLowerCase()] || e),
                  (r[e] = t)),
                this
              );
            },
            overrideMimeType: function (e) {
              return null == p && (h.mimeType = e), this;
            },
            statusCode: function (e) {
              if (e)
                if (p) b.always(e[b.status]);
                else for (var t in e) w[t] = [w[t], e[t]];
              return this;
            },
            abort: function (e) {
              e = e || a;
              return l && l.abort(e), k(0, e), this;
            },
          };
        if (
          (m.promise(b),
          (h.url = ((e || h.url || Ct.href) + "").replace(
            Pt,
            Ct.protocol + "//"
          )),
          (h.type = t.method || t.type || h.method || h.type),
          (h.dataTypes = (h.dataType || "*").toLowerCase().match(O) || [""]),
          null == h.crossDomain)
        ) {
          o = T.createElement("a");
          try {
            (o.href = h.url),
              (o.href = o.href),
              (h.crossDomain =
                It.protocol + "//" + It.host != o.protocol + "//" + o.host);
          } catch (e) {
            h.crossDomain = !0;
          }
        }
        if (
          (h.data &&
            h.processData &&
            "string" != typeof h.data &&
            (h.data = C.param(h.data, h.traditional)),
          Ft(Mt, h, t, b),
          p)
        )
          return b;
        for (n in ((f = C.event && h.global) &&
          0 == C.active++ &&
          C.event.trigger("ajaxStart"),
        (h.type = h.type.toUpperCase()),
        (h.hasContent = !Ot.test(h.type)),
        (c = h.url.replace(Nt, "")),
        h.hasContent
          ? h.data &&
            h.processData &&
            0 ===
              (h.contentType || "").indexOf(
                "application/x-www-form-urlencoded"
              ) &&
            (h.data = h.data.replace(Lt, "+"))
          : ((o = h.url.slice(c.length)),
            h.data &&
              (h.processData || "string" == typeof h.data) &&
              ((c += (At.test(c) ? "&" : "?") + h.data), delete h.data),
            !1 === h.cache &&
              ((c = c.replace(jt, "$1")),
              (o = (At.test(c) ? "&" : "?") + "_=" + St++ + o)),
            (h.url = c + o)),
        h.ifModified &&
          (C.lastModified[c] &&
            b.setRequestHeader("If-Modified-Since", C.lastModified[c]),
          C.etag[c] && b.setRequestHeader("If-None-Match", C.etag[c])),
        ((h.data && h.hasContent && !1 !== h.contentType) || t.contentType) &&
          b.setRequestHeader("Content-Type", h.contentType),
        b.setRequestHeader(
          "Accept",
          h.dataTypes[0] && h.accepts[h.dataTypes[0]]
            ? h.accepts[h.dataTypes[0]] +
                ("*" !== h.dataTypes[0] ? ", " + Wt + "; q=0.01" : "")
            : h.accepts["*"]
        ),
        h.headers))
          b.setRequestHeader(n, h.headers[n]);
        if (h.beforeSend && (!1 === h.beforeSend.call(g, b, h) || p))
          return b.abort();
        if (
          ((a = "abort"),
          y.add(h.complete),
          b.done(h.success),
          b.fail(h.error),
          (l = Ft(qt, h, t, b)))
        ) {
          if (((b.readyState = 1), f && v.trigger("ajaxSend", [b, h]), p))
            return b;
          h.async &&
            0 < h.timeout &&
            (u = x.setTimeout(function () {
              b.abort("timeout");
            }, h.timeout));
          try {
            (p = !1), l.send(r, k);
          } catch (e) {
            if (p) throw e;
            k(-1, e);
          }
        } else k(-1, "No Transport");
        function k(e, t, i, n) {
          var o,
            r,
            s,
            a = t;
          p ||
            ((p = !0),
            u && x.clearTimeout(u),
            (l = void 0),
            (d = n || ""),
            (b.readyState = 0 < e ? 4 : 0),
            (n = (200 <= e && e < 300) || 304 === e),
            i &&
              (s = (function (e, t, i) {
                for (
                  var n, o, r, s, a = e.contents, l = e.dataTypes;
                  "*" === l[0];

                )
                  l.shift(),
                    void 0 === n &&
                      (n = e.mimeType || t.getResponseHeader("Content-Type"));
                if (n)
                  for (o in a)
                    if (a[o] && a[o].test(n)) {
                      l.unshift(o);
                      break;
                    }
                if (l[0] in i) r = l[0];
                else {
                  for (o in i) {
                    if (!l[0] || e.converters[o + " " + l[0]]) {
                      r = o;
                      break;
                    }
                    s = s || o;
                  }
                  r = r || s;
                }
                if (r) return r !== l[0] && l.unshift(r), i[r];
              })(h, b, i)),
            (s = (function (e, t, i, n) {
              var o,
                r,
                s,
                a,
                l,
                c = {},
                d = e.dataTypes.slice();
              if (d[1])
                for (s in e.converters) c[s.toLowerCase()] = e.converters[s];
              for (r = d.shift(); r; )
                if (
                  (e.responseFields[r] && (i[e.responseFields[r]] = t),
                  !l && n && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                  (l = r),
                  (r = d.shift()))
                )
                  if ("*" === r) r = l;
                  else if ("*" !== l && l !== r) {
                    if (!(s = c[l + " " + r] || c["* " + r]))
                      for (o in c)
                        if (
                          (a = o.split(" "))[1] === r &&
                          (s = c[l + " " + a[0]] || c["* " + a[0]])
                        ) {
                          !0 === s
                            ? (s = c[o])
                            : !0 !== c[o] && ((r = a[0]), d.unshift(a[1]));
                          break;
                        }
                    if (!0 !== s)
                      if (s && e.throws) t = s(t);
                      else
                        try {
                          t = s(t);
                        } catch (e) {
                          return {
                            state: "parsererror",
                            error: s
                              ? e
                              : "No conversion from " + l + " to " + r,
                          };
                        }
                  }
              return { state: "success", data: t };
            })(h, s, b, n)),
            n
              ? (h.ifModified &&
                  ((i = b.getResponseHeader("Last-Modified")) &&
                    (C.lastModified[c] = i),
                  (i = b.getResponseHeader("etag")) && (C.etag[c] = i)),
                204 === e || "HEAD" === h.type
                  ? (a = "nocontent")
                  : 304 === e
                  ? (a = "notmodified")
                  : ((a = s.state), (o = s.data), (n = !(r = s.error))))
              : ((r = a), (!e && a) || ((a = "error"), e < 0 && (e = 0))),
            (b.status = e),
            (b.statusText = (t || a) + ""),
            n ? m.resolveWith(g, [o, a, b]) : m.rejectWith(g, [b, a, r]),
            b.statusCode(w),
            (w = void 0),
            f && v.trigger(n ? "ajaxSuccess" : "ajaxError", [b, h, n ? o : r]),
            y.fireWith(g, [b, a]),
            f &&
              (v.trigger("ajaxComplete", [b, h]),
              --C.active || C.event.trigger("ajaxStop")));
        }
        return b;
      },
      getJSON: function (e, t, i) {
        return C.get(e, t, i, "json");
      },
      getScript: function (e, t) {
        return C.get(e, void 0, t, "script");
      },
    }),
    C.each(["get", "post"], function (e, o) {
      C[o] = function (e, t, i, n) {
        return (
          g(t) && ((n = n || i), (i = t), (t = void 0)),
          C.ajax(
            C.extend(
              { url: e, type: o, dataType: n, data: t, success: i },
              C.isPlainObject(e) && e
            )
          )
        );
      };
    }),
    (C._evalUrl = function (e) {
      return C.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        throws: !0,
      });
    }),
    C.fn.extend({
      wrapAll: function (e) {
        return (
          this[0] &&
            (g(e) && (e = e.call(this[0])),
            (e = C(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && e.insertBefore(this[0]),
            e
              .map(function () {
                for (var e = this; e.firstElementChild; )
                  e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (i) {
        return g(i)
          ? this.each(function (e) {
              C(this).wrapInner(i.call(this, e));
            })
          : this.each(function () {
              var e = C(this),
                t = e.contents();
              t.length ? t.wrapAll(i) : e.append(i);
            });
      },
      wrap: function (t) {
        var i = g(t);
        return this.each(function (e) {
          C(this).wrapAll(i ? t.call(this, e) : t);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not("body")
            .each(function () {
              C(this).replaceWith(this.childNodes);
            }),
          this
        );
      },
    }),
    (C.expr.pseudos.hidden = function (e) {
      return !C.expr.pseudos.visible(e);
    }),
    (C.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (C.ajaxSettings.xhr = function () {
      try {
        return new x.XMLHttpRequest();
      } catch (e) {}
    });
  var Bt = { 0: 200, 1223: 204 },
    Ut = C.ajaxSettings.xhr();
  (w.cors = !!Ut && "withCredentials" in Ut),
    (w.ajax = Ut = !!Ut),
    C.ajaxTransport(function (o) {
      var r, s;
      if (w.cors || (Ut && !o.crossDomain))
        return {
          send: function (e, t) {
            var i,
              n = o.xhr();
            if (
              (n.open(o.type, o.url, o.async, o.username, o.password),
              o.xhrFields)
            )
              for (i in o.xhrFields) n[i] = o.xhrFields[i];
            for (i in (o.mimeType &&
              n.overrideMimeType &&
              n.overrideMimeType(o.mimeType),
            o.crossDomain ||
              e["X-Requested-With"] ||
              (e["X-Requested-With"] = "XMLHttpRequest"),
            e))
              n.setRequestHeader(i, e[i]);
            (r = function (e) {
              return function () {
                r &&
                  ((r =
                    s =
                    n.onload =
                    n.onerror =
                    n.onabort =
                    n.ontimeout =
                    n.onreadystatechange =
                      null),
                  "abort" === e
                    ? n.abort()
                    : "error" === e
                    ? "number" != typeof n.status
                      ? t(0, "error")
                      : t(n.status, n.statusText)
                    : t(
                        Bt[n.status] || n.status,
                        n.statusText,
                        "text" !== (n.responseType || "text") ||
                          "string" != typeof n.responseText
                          ? { binary: n.response }
                          : { text: n.responseText },
                        n.getAllResponseHeaders()
                      ));
              };
            }),
              (n.onload = r()),
              (s = n.onerror = n.ontimeout = r("error")),
              void 0 !== n.onabort
                ? (n.onabort = s)
                : (n.onreadystatechange = function () {
                    4 === n.readyState &&
                      x.setTimeout(function () {
                        r && s();
                      });
                  }),
              (r = r("abort"));
            try {
              n.send((o.hasContent && o.data) || null);
            } catch (e) {
              if (r) throw e;
            }
          },
          abort: function () {
            r && r();
          },
        };
    }),
    C.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    C.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function (e) {
          return C.globalEval(e), e;
        },
      },
    }),
    C.ajaxPrefilter("script", function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
    }),
    C.ajaxTransport("script", function (i) {
      var n, o;
      if (i.crossDomain)
        return {
          send: function (e, t) {
            (n = C("<script>")
              .prop({ charset: i.scriptCharset, src: i.url })
              .on(
                "load error",
                (o = function (e) {
                  n.remove(),
                    (o = null),
                    e && t("error" === e.type ? 404 : 200, e.type);
                })
              )),
              T.head.appendChild(n[0]);
          },
          abort: function () {
            o && o();
          },
        };
    });
  var Xt = [],
    Yt = /(=)\?(?=&|$)|\?\?/;
  C.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var e = Xt.pop() || C.expando + "_" + St++;
      return (this[e] = !0), e;
    },
  }),
    C.ajaxPrefilter("json jsonp", function (e, t, i) {
      var n,
        o,
        r,
        s =
          !1 !== e.jsonp &&
          (Yt.test(e.url)
            ? "url"
            : "string" == typeof e.data &&
              0 ===
                (e.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              Yt.test(e.data) &&
              "data");
      if (s || "jsonp" === e.dataTypes[0])
        return (
          (n = e.jsonpCallback =
            g(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
          s
            ? (e[s] = e[s].replace(Yt, "$1" + n))
            : !1 !== e.jsonp &&
              (e.url += (At.test(e.url) ? "&" : "?") + e.jsonp + "=" + n),
          (e.converters["script json"] = function () {
            return r || C.error(n + " was not called"), r[0];
          }),
          (e.dataTypes[0] = "json"),
          (o = x[n]),
          (x[n] = function () {
            r = arguments;
          }),
          i.always(function () {
            void 0 === o ? C(x).removeProp(n) : (x[n] = o),
              e[n] && ((e.jsonpCallback = t.jsonpCallback), Xt.push(n)),
              r && g(o) && o(r[0]),
              (r = o = void 0);
          }),
          "script"
        );
    }),
    (w.createHTMLDocument =
      (((t = T.implementation.createHTMLDocument("").body).innerHTML =
        "<form></form><form></form>"),
      2 === t.childNodes.length)),
    (C.parseHTML = function (e, t, i) {
      return "string" != typeof e
        ? []
        : ("boolean" == typeof t && ((i = t), (t = !1)),
          t ||
            (w.createHTMLDocument
              ? (((n = (t =
                  T.implementation.createHTMLDocument("")).createElement(
                  "base"
                )).href = T.location.href),
                t.head.appendChild(n))
              : (t = T)),
          (n = !i && []),
          (i = $.exec(e))
            ? [t.createElement(i[1])]
            : ((i = ge([e], t, n)),
              n && n.length && C(n).remove(),
              C.merge([], i.childNodes)));
      var n;
    }),
    (C.fn.load = function (e, t, i) {
      var n,
        o,
        r,
        s = this,
        a = e.indexOf(" ");
      return (
        -1 < a && ((n = yt(e.slice(a))), (e = e.slice(0, a))),
        g(t)
          ? ((i = t), (t = void 0))
          : t && "object" == typeof t && (o = "POST"),
        0 < s.length &&
          C.ajax({ url: e, type: o || "GET", dataType: "html", data: t })
            .done(function (e) {
              (r = arguments),
                s.html(n ? C("<div>").append(C.parseHTML(e)).find(n) : e);
            })
            .always(
              i &&
                function (e, t) {
                  s.each(function () {
                    i.apply(this, r || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    C.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (e, t) {
        C.fn[t] = function (e) {
          return this.on(t, e);
        };
      }
    ),
    (C.expr.pseudos.animated = function (t) {
      return C.grep(C.timers, function (e) {
        return t === e.elem;
      }).length;
    }),
    (C.offset = {
      setOffset: function (e, t, i) {
        var n,
          o,
          r,
          s,
          a = C.css(e, "position"),
          l = C(e),
          c = {};
        "static" === a && (e.style.position = "relative"),
          (r = l.offset()),
          (n = C.css(e, "top")),
          (s = C.css(e, "left")),
          (s =
            ("absolute" === a || "fixed" === a) && -1 < (n + s).indexOf("auto")
              ? ((o = (a = l.position()).top), a.left)
              : ((o = parseFloat(n) || 0), parseFloat(s) || 0)),
          null != (t = g(t) ? t.call(e, i, C.extend({}, r)) : t).top &&
            (c.top = t.top - r.top + o),
          null != t.left && (c.left = t.left - r.left + s),
          "using" in t ? t.using.call(e, c) : l.css(c);
      },
    }),
    C.fn.extend({
      offset: function (t) {
        if (arguments.length)
          return void 0 === t
            ? this
            : this.each(function (e) {
                C.offset.setOffset(this, t, e);
              });
        var e,
          i = this[0];
        return i
          ? i.getClientRects().length
            ? ((e = i.getBoundingClientRect()),
              (i = i.ownerDocument.defaultView),
              { top: e.top + i.pageYOffset, left: e.left + i.pageXOffset })
            : { top: 0, left: 0 }
          : void 0;
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            i,
            n = this[0],
            o = { top: 0, left: 0 };
          if ("fixed" === C.css(n, "position")) t = n.getBoundingClientRect();
          else {
            for (
              t = this.offset(),
                i = n.ownerDocument,
                e = n.offsetParent || i.documentElement;
              e &&
              (e === i.body || e === i.documentElement) &&
              "static" === C.css(e, "position");

            )
              e = e.parentNode;
            e &&
              e !== n &&
              1 === e.nodeType &&
              (((o = C(e).offset()).top += C.css(e, "borderTopWidth", !0)),
              (o.left += C.css(e, "borderLeftWidth", !0)));
          }
          return {
            top: t.top - o.top - C.css(n, "marginTop", !0),
            left: t.left - o.left - C.css(n, "marginLeft", !0),
          };
        }
      },
      offsetParent: function () {
        return this.map(function () {
          for (
            var e = this.offsetParent;
            e && "static" === C.css(e, "position");

          )
            e = e.offsetParent;
          return e || ve;
        });
      },
    }),
    C.each(
      { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
      function (t, o) {
        var r = "pageYOffset" === o;
        C.fn[t] = function (e) {
          return F(
            this,
            function (e, t, i) {
              var n;
              return (
                v(e) ? (n = e) : 9 === e.nodeType && (n = e.defaultView),
                void 0 === i
                  ? n
                    ? n[o]
                    : e[t]
                  : void (n
                      ? n.scrollTo(r ? n.pageXOffset : i, r ? i : n.pageYOffset)
                      : (e[t] = i))
              );
            },
            t,
            e,
            arguments.length
          );
        };
      }
    ),
    C.each(["top", "left"], function (e, i) {
      C.cssHooks[i] = Ye(w.pixelPosition, function (e, t) {
        if (t)
          return (t = Xe(e, i)), Fe.test(t) ? C(e).position()[i] + "px" : t;
      });
    }),
    C.each({ Height: "height", Width: "width" }, function (s, a) {
      C.each(
        { padding: "inner" + s, content: a, "": "outer" + s },
        function (n, r) {
          C.fn[r] = function (e, t) {
            var i = arguments.length && (n || "boolean" != typeof e),
              o = n || (!0 === e || !0 === t ? "margin" : "border");
            return F(
              this,
              function (e, t, i) {
                var n;
                return v(e)
                  ? 0 === r.indexOf("outer")
                    ? e["inner" + s]
                    : e.document.documentElement["client" + s]
                  : 9 === e.nodeType
                  ? ((n = e.documentElement),
                    Math.max(
                      e.body["scroll" + s],
                      n["scroll" + s],
                      e.body["offset" + s],
                      n["offset" + s],
                      n["client" + s]
                    ))
                  : void 0 === i
                  ? C.css(e, t, o)
                  : C.style(e, t, i, o);
              },
              a,
              i ? e : void 0,
              i
            );
          };
        }
      );
    }),
    C.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
        " "
      ),
      function (e, i) {
        C.fn[i] = function (e, t) {
          return 0 < arguments.length
            ? this.on(i, null, e, t)
            : this.trigger(i);
        };
      }
    ),
    C.fn.extend({
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      },
    }),
    C.fn.extend({
      bind: function (e, t, i) {
        return this.on(e, null, t, i);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, i, n) {
        return this.on(t, e, i, n);
      },
      undelegate: function (e, t, i) {
        return 1 === arguments.length
          ? this.off(e, "**")
          : this.off(t, e || "**", i);
      },
    }),
    (C.proxy = function (e, t) {
      var i, n;
      if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), g(e)))
        return (
          (i = a.call(arguments, 2)),
          ((n = function () {
            return e.apply(t || this, i.concat(a.call(arguments)));
          }).guid = e.guid =
            e.guid || C.guid++),
          n
        );
    }),
    (C.holdReady = function (e) {
      e ? C.readyWait++ : C.ready(!0);
    }),
    (C.isArray = Array.isArray),
    (C.parseJSON = JSON.parse),
    (C.nodeName = E),
    (C.isFunction = g),
    (C.isWindow = v),
    (C.camelCase = X),
    (C.type = h),
    (C.now = Date.now),
    (C.isNumeric = function (e) {
      var t = C.type(e);
      return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
    }),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function () {
        return C;
      });
  var Qt = x.jQuery,
    Vt = x.$;
  return (
    (C.noConflict = function (e) {
      return x.$ === C && (x.$ = Vt), e && x.jQuery === C && (x.jQuery = Qt), C;
    }),
    e || (x.jQuery = x.$ = C),
    C
  );
}),
  (function (e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery"], e)
      : "undefined" != typeof exports
      ? (module.exports = e(require("jquery")))
      : e(jQuery);
  })(function (c) {
    "use strict";
    var n,
      s = window.Slick || {};
    (n = 0),
      ((s = function (e, t) {
        var i = this;
        (i.defaults = {
          accessibility: !0,
          adaptiveHeight: !1,
          appendArrows: c(e),
          appendDots: c(e),
          arrows: !0,
          asNavFor: null,
          prevArrow:
            '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
          nextArrow:
            '<button class="slick-next" aria-label="Next" type="button">Next</button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: "50px",
          cssEase: "ease",
          customPaging: function (e, t) {
            return c('<button type="button" />').text(t + 1);
          },
          dots: !1,
          dotsClass: "slick-dots",
          draggable: !0,
          easing: "linear",
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          focusOnChange: !1,
          infinite: !0,
          initialSlide: 0,
          lazyLoad: "ondemand",
          mobileFirst: !1,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          respondTo: "window",
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3,
        }),
          (i.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            scrolling: !1,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            swiping: !1,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          c.extend(i, i.initials),
          (i.activeBreakpoint = null),
          (i.animType = null),
          (i.animProp = null),
          (i.breakpoints = []),
          (i.breakpointSettings = []),
          (i.cssTransitions = !1),
          (i.focussed = !1),
          (i.interrupted = !1),
          (i.hidden = "hidden"),
          (i.paused = !0),
          (i.positionProp = null),
          (i.respondTo = null),
          (i.rowCount = 1),
          (i.shouldClick = !0),
          (i.$slider = c(e)),
          (i.$slidesCache = null),
          (i.transformType = null),
          (i.transitionType = null),
          (i.visibilityChange = "visibilitychange"),
          (i.windowWidth = 0),
          (i.windowTimer = null),
          (e = c(e).data("slick") || {}),
          (i.options = c.extend({}, i.defaults, t, e)),
          (i.currentSlide = i.options.initialSlide),
          (i.originalSettings = i.options),
          void 0 !== document.mozHidden
            ? ((i.hidden = "mozHidden"),
              (i.visibilityChange = "mozvisibilitychange"))
            : void 0 !== document.webkitHidden &&
              ((i.hidden = "webkitHidden"),
              (i.visibilityChange = "webkitvisibilitychange")),
          (i.autoPlay = c.proxy(i.autoPlay, i)),
          (i.autoPlayClear = c.proxy(i.autoPlayClear, i)),
          (i.autoPlayIterator = c.proxy(i.autoPlayIterator, i)),
          (i.changeSlide = c.proxy(i.changeSlide, i)),
          (i.clickHandler = c.proxy(i.clickHandler, i)),
          (i.selectHandler = c.proxy(i.selectHandler, i)),
          (i.setPosition = c.proxy(i.setPosition, i)),
          (i.swipeHandler = c.proxy(i.swipeHandler, i)),
          (i.dragHandler = c.proxy(i.dragHandler, i)),
          (i.keyHandler = c.proxy(i.keyHandler, i)),
          (i.instanceUid = n++),
          (i.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          i.registerBreakpoints(),
          i.init(!0);
      }).prototype.activateADA = function () {
        this.$slideTrack
          .find(".slick-active")
          .attr({ "aria-hidden": "false" })
          .find("a, input, button, select")
          .attr({ tabindex: "0" });
      }),
      (s.prototype.addSlide = s.prototype.slickAdd =
        function (e, t, i) {
          var n = this;
          if ("boolean" == typeof t) (i = t), (t = null);
          else if (t < 0 || t >= n.slideCount) return !1;
          n.unload(),
            "number" == typeof t
              ? 0 === t && 0 === n.$slides.length
                ? c(e).appendTo(n.$slideTrack)
                : i
                ? c(e).insertBefore(n.$slides.eq(t))
                : c(e).insertAfter(n.$slides.eq(t))
              : !0 === i
              ? c(e).prependTo(n.$slideTrack)
              : c(e).appendTo(n.$slideTrack),
            (n.$slides = n.$slideTrack.children(this.options.slide)),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.append(n.$slides),
            n.$slides.each(function (e, t) {
              c(t).attr("data-slick-index", e);
            }),
            (n.$slidesCache = n.$slides),
            n.reinit();
        }),
      (s.prototype.animateHeight = function () {
        var e,
          t = this;
        1 === t.options.slidesToShow &&
          !0 === t.options.adaptiveHeight &&
          !1 === t.options.vertical &&
          ((e = t.$slides.eq(t.currentSlide).outerHeight(!0)),
          t.$list.animate({ height: e }, t.options.speed));
      }),
      (s.prototype.animateSlide = function (e, t) {
        var i = {},
          n = this;
        n.animateHeight(),
          !0 === n.options.rtl && !1 === n.options.vertical && (e = -e),
          !1 === n.transformsEnabled
            ? !1 === n.options.vertical
              ? n.$slideTrack.animate(
                  { left: e },
                  n.options.speed,
                  n.options.easing,
                  t
                )
              : n.$slideTrack.animate(
                  { top: e },
                  n.options.speed,
                  n.options.easing,
                  t
                )
            : !1 === n.cssTransitions
            ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
              c({ animStart: n.currentLeft }).animate(
                { animStart: e },
                {
                  duration: n.options.speed,
                  easing: n.options.easing,
                  step: function (e) {
                    (e = Math.ceil(e)),
                      !1 === n.options.vertical
                        ? (i[n.animType] = "translate(" + e + "px, 0px)")
                        : (i[n.animType] = "translate(0px," + e + "px)"),
                      n.$slideTrack.css(i);
                  },
                  complete: function () {
                    t && t.call();
                  },
                }
              ))
            : (n.applyTransition(),
              (e = Math.ceil(e)),
              !1 === n.options.vertical
                ? (i[n.animType] = "translate3d(" + e + "px, 0px, 0px)")
                : (i[n.animType] = "translate3d(0px," + e + "px, 0px)"),
              n.$slideTrack.css(i),
              t &&
                setTimeout(function () {
                  n.disableTransition(), t.call();
                }, n.options.speed));
      }),
      (s.prototype.getNavTarget = function () {
        var e = this.options.asNavFor;
        return (e = e && null !== e ? c(e).not(this.$slider) : e);
      }),
      (s.prototype.asNavFor = function (t) {
        var e = this.getNavTarget();
        null !== e &&
          "object" == typeof e &&
          e.each(function () {
            var e = c(this).slick("getSlick");
            e.unslicked || e.slideHandler(t, !0);
          });
      }),
      (s.prototype.applyTransition = function (e) {
        var t = this,
          i = {};
        !1 === t.options.fade
          ? (i[t.transitionType] =
              t.transformType +
              " " +
              t.options.speed +
              "ms " +
              t.options.cssEase)
          : (i[t.transitionType] =
              "opacity " + t.options.speed + "ms " + t.options.cssEase),
          (!1 === t.options.fade ? t.$slideTrack : t.$slides.eq(e)).css(i);
      }),
      (s.prototype.autoPlay = function () {
        var e = this;
        e.autoPlayClear(),
          e.slideCount > e.options.slidesToShow &&
            (e.autoPlayTimer = setInterval(
              e.autoPlayIterator,
              e.options.autoplaySpeed
            ));
      }),
      (s.prototype.autoPlayClear = function () {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer);
      }),
      (s.prototype.autoPlayIterator = function () {
        var e = this,
          t = e.currentSlide + e.options.slidesToScroll;
        e.paused ||
          e.interrupted ||
          e.focussed ||
          (!1 === e.options.infinite &&
            (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
              ? (e.direction = 0)
              : 0 === e.direction &&
                ((t = e.currentSlide - e.options.slidesToScroll),
                e.currentSlide - 1 == 0 && (e.direction = 1))),
          e.slideHandler(t));
      }),
      (s.prototype.buildArrows = function () {
        var e = this;
        !0 === e.options.arrows &&
          ((e.$prevArrow = c(e.options.prevArrow).addClass("slick-arrow")),
          (e.$nextArrow = c(e.options.nextArrow).addClass("slick-arrow")),
          e.slideCount > e.options.slidesToShow
            ? (e.$prevArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              e.$nextArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              e.htmlExpr.test(e.options.prevArrow) &&
                e.$prevArrow.prependTo(e.options.appendArrows),
              e.htmlExpr.test(e.options.nextArrow) &&
                e.$nextArrow.appendTo(e.options.appendArrows),
              !0 !== e.options.infinite &&
                e.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"))
            : e.$prevArrow
                .add(e.$nextArrow)
                .addClass("slick-hidden")
                .attr({ "aria-disabled": "true", tabindex: "-1" }));
      }),
      (s.prototype.buildDots = function () {
        var e,
          t,
          i = this;
        if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
          for (
            i.$slider.addClass("slick-dotted"),
              t = c("<ul />").addClass(i.options.dotsClass),
              e = 0;
            e <= i.getDotCount();
            e += 1
          )
            t.append(
              c("<li />").append(i.options.customPaging.call(this, i, e))
            );
          (i.$dots = t.appendTo(i.options.appendDots)),
            i.$dots.find("li").first().addClass("slick-active");
        }
      }),
      (s.prototype.buildOut = function () {
        var e = this;
        (e.$slides = e.$slider
          .children(e.options.slide + ":not(.slick-cloned)")
          .addClass("slick-slide")),
          (e.slideCount = e.$slides.length),
          e.$slides.each(function (e, t) {
            c(t)
              .attr("data-slick-index", e)
              .data("originalStyling", c(t).attr("style") || "");
          }),
          e.$slider.addClass("slick-slider"),
          (e.$slideTrack =
            0 === e.slideCount
              ? c('<div class="slick-track"/>').appendTo(e.$slider)
              : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
          e.$slideTrack.css("opacity", 0),
          (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
            (e.options.slidesToScroll = 1),
          c("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
          e.setupInfinite(),
          e.buildArrows(),
          e.buildDots(),
          e.updateDots(),
          e.setSlideClasses(
            "number" == typeof e.currentSlide ? e.currentSlide : 0
          ),
          !0 === e.options.draggable && e.$list.addClass("draggable");
      }),
      (s.prototype.buildRows = function () {
        var e,
          t,
          i,
          n = this,
          o = document.createDocumentFragment(),
          r = n.$slider.children();
        if (0 < n.options.rows) {
          for (
            i = n.options.slidesPerRow * n.options.rows,
              t = Math.ceil(r.length / i),
              e = 0;
            e < t;
            e++
          ) {
            for (
              var s = document.createElement("div"), a = 0;
              a < n.options.rows;
              a++
            ) {
              for (
                var l = document.createElement("div"), c = 0;
                c < n.options.slidesPerRow;
                c++
              ) {
                var d = e * i + (a * n.options.slidesPerRow + c);
                r.get(d) && l.appendChild(r.get(d));
              }
              s.appendChild(l);
            }
            o.appendChild(s);
          }
          n.$slider.empty().append(o),
            n.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / n.options.slidesPerRow + "%",
                display: "inline-block",
              });
        }
      }),
      (s.prototype.checkResponsive = function (e, t) {
        var i,
          n,
          o,
          r = this,
          s = !1,
          a = r.$slider.width(),
          l = window.innerWidth || c(window).width();
        if (
          ("window" === r.respondTo
            ? (o = l)
            : "slider" === r.respondTo
            ? (o = a)
            : "min" === r.respondTo && (o = Math.min(l, a)),
          r.options.responsive &&
            r.options.responsive.length &&
            null !== r.options.responsive)
        ) {
          for (i in ((n = null), r.breakpoints))
            r.breakpoints.hasOwnProperty(i) &&
              (!1 === r.originalSettings.mobileFirst
                ? o < r.breakpoints[i] && (n = r.breakpoints[i])
                : o > r.breakpoints[i] && (n = r.breakpoints[i]));
          null !== n
            ? (null !== r.activeBreakpoint && n === r.activeBreakpoint && !t) ||
              ((r.activeBreakpoint = n),
              "unslick" === r.breakpointSettings[n]
                ? r.unslick(n)
                : ((r.options = c.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[n]
                  )),
                  !0 === e && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e)),
              (s = n))
            : null !== r.activeBreakpoint &&
              ((r.activeBreakpoint = null),
              (r.options = r.originalSettings),
              !0 === e && (r.currentSlide = r.options.initialSlide),
              r.refresh(e),
              (s = n)),
            e || !1 === s || r.$slider.trigger("breakpoint", [r, s]);
        }
      }),
      (s.prototype.changeSlide = function (e, t) {
        var i,
          n = this,
          o = c(e.currentTarget);
        switch (
          (o.is("a") && e.preventDefault(),
          o.is("li") || (o = o.closest("li")),
          (i =
            n.slideCount % n.options.slidesToScroll != 0
              ? 0
              : (n.slideCount - n.currentSlide) % n.options.slidesToScroll),
          e.data.message)
        ) {
          case "previous":
            (r =
              0 == i ? n.options.slidesToScroll : n.options.slidesToShow - i),
              n.slideCount > n.options.slidesToShow &&
                n.slideHandler(n.currentSlide - r, !1, t);
            break;
          case "next":
            (r = 0 == i ? n.options.slidesToScroll : i),
              n.slideCount > n.options.slidesToShow &&
                n.slideHandler(n.currentSlide + r, !1, t);
            break;
          case "index":
            var r =
              0 === e.data.index
                ? 0
                : e.data.index || o.index() * n.options.slidesToScroll;
            n.slideHandler(n.checkNavigable(r), !1, t),
              o.children().trigger("focus");
            break;
          default:
            return;
        }
      }),
      (s.prototype.checkNavigable = function (e) {
        var t = this.getNavigableIndexes(),
          i = 0;
        if (e > t[t.length - 1]) e = t[t.length - 1];
        else
          for (var n in t) {
            if (e < t[n]) {
              e = i;
              break;
            }
            i = t[n];
          }
        return e;
      }),
      (s.prototype.cleanUpEvents = function () {
        var e = this;
        e.options.dots &&
          null !== e.$dots &&
          (c("li", e.$dots)
            .off("click.slick", e.changeSlide)
            .off("mouseenter.slick", c.proxy(e.interrupt, e, !0))
            .off("mouseleave.slick", c.proxy(e.interrupt, e, !1)),
          !0 === e.options.accessibility &&
            e.$dots.off("keydown.slick", e.keyHandler)),
          e.$slider.off("focus.slick blur.slick"),
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
            e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
            !0 === e.options.accessibility &&
              (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler),
              e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
          e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
          e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
          e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
          e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
          e.$list.off("click.slick", e.clickHandler),
          c(document).off(e.visibilityChange, e.visibility),
          e.cleanUpSlideEvents(),
          !0 === e.options.accessibility &&
            e.$list.off("keydown.slick", e.keyHandler),
          !0 === e.options.focusOnSelect &&
            c(e.$slideTrack).children().off("click.slick", e.selectHandler),
          c(window).off(
            "orientationchange.slick.slick-" + e.instanceUid,
            e.orientationChange
          ),
          c(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
          c("[draggable!=true]", e.$slideTrack).off(
            "dragstart",
            e.preventDefault
          ),
          c(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
      }),
      (s.prototype.cleanUpSlideEvents = function () {
        var e = this;
        e.$list.off("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
          e.$list.off("mouseleave.slick", c.proxy(e.interrupt, e, !1));
      }),
      (s.prototype.cleanUpRows = function () {
        var e;
        0 < this.options.rows &&
          ((e = this.$slides.children().children()).removeAttr("style"),
          this.$slider.empty().append(e));
      }),
      (s.prototype.clickHandler = function (e) {
        !1 === this.shouldClick &&
          (e.stopImmediatePropagation(),
          e.stopPropagation(),
          e.preventDefault());
      }),
      (s.prototype.destroy = function (e) {
        var t = this;
        t.autoPlayClear(),
          (t.touchObject = {}),
          t.cleanUpEvents(),
          c(".slick-cloned", t.$slider).detach(),
          t.$dots && t.$dots.remove(),
          t.$prevArrow &&
            t.$prevArrow.length &&
            (t.$prevArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
          t.$nextArrow &&
            t.$nextArrow.length &&
            (t.$nextArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
          t.$slides &&
            (t.$slides
              .removeClass(
                "slick-slide slick-active slick-center slick-visible slick-current"
              )
              .removeAttr("aria-hidden")
              .removeAttr("data-slick-index")
              .each(function () {
                c(this).attr("style", c(this).data("originalStyling"));
              }),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slideTrack.detach(),
            t.$list.detach(),
            t.$slider.append(t.$slides)),
          t.cleanUpRows(),
          t.$slider.removeClass("slick-slider"),
          t.$slider.removeClass("slick-initialized"),
          t.$slider.removeClass("slick-dotted"),
          (t.unslicked = !0),
          e || t.$slider.trigger("destroy", [t]);
      }),
      (s.prototype.disableTransition = function (e) {
        var t = {};
        (t[this.transitionType] = ""),
          (!1 === this.options.fade
            ? this.$slideTrack
            : this.$slides.eq(e)
          ).css(t);
      }),
      (s.prototype.fadeSlide = function (e, t) {
        var i = this;
        !1 === i.cssTransitions
          ? (i.$slides.eq(e).css({ zIndex: i.options.zIndex }),
            i.$slides
              .eq(e)
              .animate({ opacity: 1 }, i.options.speed, i.options.easing, t))
          : (i.applyTransition(e),
            i.$slides.eq(e).css({ opacity: 1, zIndex: i.options.zIndex }),
            t &&
              setTimeout(function () {
                i.disableTransition(e), t.call();
              }, i.options.speed));
      }),
      (s.prototype.fadeSlideOut = function (e) {
        var t = this;
        !1 === t.cssTransitions
          ? t.$slides
              .eq(e)
              .animate(
                { opacity: 0, zIndex: t.options.zIndex - 2 },
                t.options.speed,
                t.options.easing
              )
          : (t.applyTransition(e),
            t.$slides.eq(e).css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
      }),
      (s.prototype.filterSlides = s.prototype.slickFilter =
        function (e) {
          var t = this;
          null !== e &&
            ((t.$slidesCache = t.$slides),
            t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.filter(e).appendTo(t.$slideTrack),
            t.reinit());
        }),
      (s.prototype.focusHandler = function () {
        var i = this;
        i.$slider
          .off("focus.slick blur.slick")
          .on("focus.slick", "*", function (e) {
            var t = c(this);
            setTimeout(function () {
              i.options.pauseOnFocus &&
                t.is(":focus") &&
                ((i.focussed = !0), i.autoPlay());
            }, 0);
          })
          .on("blur.slick", "*", function (e) {
            c(this);
            i.options.pauseOnFocus && ((i.focussed = !1), i.autoPlay());
          });
      }),
      (s.prototype.getCurrent = s.prototype.slickCurrentSlide =
        function () {
          return this.currentSlide;
        }),
      (s.prototype.getDotCount = function () {
        var e = this,
          t = 0,
          i = 0,
          n = 0;
        if (!0 === e.options.infinite)
          if (e.slideCount <= e.options.slidesToShow) ++n;
          else
            for (; t < e.slideCount; )
              ++n,
                (t = i + e.options.slidesToScroll),
                (i +=
                  e.options.slidesToScroll <= e.options.slidesToShow
                    ? e.options.slidesToScroll
                    : e.options.slidesToShow);
        else if (!0 === e.options.centerMode) n = e.slideCount;
        else if (e.options.asNavFor)
          for (; t < e.slideCount; )
            ++n,
              (t = i + e.options.slidesToScroll),
              (i +=
                e.options.slidesToScroll <= e.options.slidesToShow
                  ? e.options.slidesToScroll
                  : e.options.slidesToShow);
        else
          n =
            1 +
            Math.ceil(
              (e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll
            );
        return n - 1;
      }),
      (s.prototype.getLeft = function (e) {
        var t,
          i,
          n = this,
          o = 0;
        return (
          (n.slideOffset = 0),
          (t = n.$slides.first().outerHeight(!0)),
          !0 === n.options.infinite
            ? (n.slideCount > n.options.slidesToShow &&
                ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
                (i = -1),
                !0 === n.options.vertical &&
                  !0 === n.options.centerMode &&
                  (2 === n.options.slidesToShow
                    ? (i = -1.5)
                    : 1 === n.options.slidesToShow && (i = -2)),
                (o = t * n.options.slidesToShow * i)),
              n.slideCount % n.options.slidesToScroll != 0 &&
                e + n.options.slidesToScroll > n.slideCount &&
                n.slideCount > n.options.slidesToShow &&
                (o =
                  e > n.slideCount
                    ? ((n.slideOffset =
                        (n.options.slidesToShow - (e - n.slideCount)) *
                        n.slideWidth *
                        -1),
                      (n.options.slidesToShow - (e - n.slideCount)) * t * -1)
                    : ((n.slideOffset =
                        (n.slideCount % n.options.slidesToScroll) *
                        n.slideWidth *
                        -1),
                      (n.slideCount % n.options.slidesToScroll) * t * -1)))
            : e + n.options.slidesToShow > n.slideCount &&
              ((n.slideOffset =
                (e + n.options.slidesToShow - n.slideCount) * n.slideWidth),
              (o = (e + n.options.slidesToShow - n.slideCount) * t)),
          n.slideCount <= n.options.slidesToShow && (o = n.slideOffset = 0),
          !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow
            ? (n.slideOffset =
                (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 -
                (n.slideWidth * n.slideCount) / 2)
            : !0 === n.options.centerMode && !0 === n.options.infinite
            ? (n.slideOffset +=
                n.slideWidth * Math.floor(n.options.slidesToShow / 2) -
                n.slideWidth)
            : !0 === n.options.centerMode &&
              ((n.slideOffset = 0),
              (n.slideOffset +=
                n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
          (t =
            !1 === n.options.vertical
              ? e * n.slideWidth * -1 + n.slideOffset
              : e * t * -1 + o),
          !0 === n.options.variableWidth &&
            ((o =
              n.slideCount <= n.options.slidesToShow ||
              !1 === n.options.infinite
                ? n.$slideTrack.children(".slick-slide").eq(e)
                : n.$slideTrack
                    .children(".slick-slide")
                    .eq(e + n.options.slidesToShow)),
            (t =
              !0 === n.options.rtl
                ? o[0]
                  ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                  : 0
                : o[0]
                ? -1 * o[0].offsetLeft
                : 0),
            !0 === n.options.centerMode &&
              ((o =
                n.slideCount <= n.options.slidesToShow ||
                !1 === n.options.infinite
                  ? n.$slideTrack.children(".slick-slide").eq(e)
                  : n.$slideTrack
                      .children(".slick-slide")
                      .eq(e + n.options.slidesToShow + 1)),
              (t =
                !0 === n.options.rtl
                  ? o[0]
                    ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                    : 0
                  : o[0]
                  ? -1 * o[0].offsetLeft
                  : 0),
              (t += (n.$list.width() - o.outerWidth()) / 2))),
          t
        );
      }),
      (s.prototype.getOption = s.prototype.slickGetOption =
        function (e) {
          return this.options[e];
        }),
      (s.prototype.getNavigableIndexes = function () {
        for (
          var e = this,
            t = 0,
            i = 0,
            n = [],
            o =
              !1 === e.options.infinite
                ? e.slideCount
                : ((t = -1 * e.options.slidesToScroll),
                  (i = -1 * e.options.slidesToScroll),
                  2 * e.slideCount);
          t < o;

        )
          n.push(t),
            (t = i + e.options.slidesToScroll),
            (i +=
              e.options.slidesToScroll <= e.options.slidesToShow
                ? e.options.slidesToScroll
                : e.options.slidesToShow);
        return n;
      }),
      (s.prototype.getSlick = function () {
        return this;
      }),
      (s.prototype.getSlideCount = function () {
        var o,
          r = this,
          e = !0 === r.options.centerMode ? Math.floor(r.$list.width() / 2) : 0,
          s = -1 * r.swipeLeft + e;
        return !0 === r.options.swipeToSlide
          ? (r.$slideTrack.find(".slick-slide").each(function (e, t) {
              var i = c(t).outerWidth(),
                n = t.offsetLeft;
              if ((!0 !== r.options.centerMode && (n += i / 2), s < n + i))
                return (o = t), !1;
            }),
            Math.abs(c(o).attr("data-slick-index") - r.currentSlide) || 1)
          : r.options.slidesToScroll;
      }),
      (s.prototype.goTo = s.prototype.slickGoTo =
        function (e, t) {
          this.changeSlide(
            { data: { message: "index", index: parseInt(e) } },
            t
          );
        }),
      (s.prototype.init = function (e) {
        var t = this;
        c(t.$slider).hasClass("slick-initialized") ||
          (c(t.$slider).addClass("slick-initialized"),
          t.buildRows(),
          t.buildOut(),
          t.setProps(),
          t.startLoad(),
          t.loadSlider(),
          t.initializeEvents(),
          t.updateArrows(),
          t.updateDots(),
          t.checkResponsive(!0),
          t.focusHandler()),
          e && t.$slider.trigger("init", [t]),
          !0 === t.options.accessibility && t.initADA(),
          t.options.autoplay && ((t.paused = !1), t.autoPlay());
      }),
      (s.prototype.initADA = function () {
        var i = this,
          n = Math.ceil(i.slideCount / i.options.slidesToShow),
          o = i.getNavigableIndexes().filter(function (e) {
            return 0 <= e && e < i.slideCount;
          });
        i.$slides
          .add(i.$slideTrack.find(".slick-cloned"))
          .attr({ "aria-hidden": "true", tabindex: "-1" })
          .find("a, input, button, select")
          .attr({ tabindex: "-1" }),
          null !== i.$dots &&
            (i.$slides
              .not(i.$slideTrack.find(".slick-cloned"))
              .each(function (e) {
                var t = o.indexOf(e);
                c(this).attr({
                  role: "tabpanel",
                  id: "slick-slide" + i.instanceUid + e,
                  tabindex: -1,
                }),
                  -1 !== t &&
                    ((t = "slick-slide-control" + i.instanceUid + t),
                    c("#" + t).length &&
                      c(this).attr({ "aria-describedby": t }));
              }),
            i.$dots
              .attr("role", "tablist")
              .find("li")
              .each(function (e) {
                var t = o[e];
                c(this).attr({ role: "presentation" }),
                  c(this)
                    .find("button")
                    .first()
                    .attr({
                      role: "tab",
                      id: "slick-slide-control" + i.instanceUid + e,
                      "aria-controls": "slick-slide" + i.instanceUid + t,
                      "aria-label": e + 1 + " of " + n,
                      "aria-selected": null,
                      tabindex: "-1",
                    });
              })
              .eq(i.currentSlide)
              .find("button")
              .attr({ "aria-selected": "true", tabindex: "0" })
              .end());
        for (var e = i.currentSlide, t = e + i.options.slidesToShow; e < t; e++)
          i.options.focusOnChange
            ? i.$slides.eq(e).attr({ tabindex: "0" })
            : i.$slides.eq(e).removeAttr("tabindex");
        i.activateADA();
      }),
      (s.prototype.initArrowEvents = function () {
        var e = this;
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow
            .off("click.slick")
            .on("click.slick", { message: "previous" }, e.changeSlide),
          e.$nextArrow
            .off("click.slick")
            .on("click.slick", { message: "next" }, e.changeSlide),
          !0 === e.options.accessibility &&
            (e.$prevArrow.on("keydown.slick", e.keyHandler),
            e.$nextArrow.on("keydown.slick", e.keyHandler)));
      }),
      (s.prototype.initDotEvents = function () {
        var e = this;
        !0 === e.options.dots &&
          e.slideCount > e.options.slidesToShow &&
          (c("li", e.$dots).on(
            "click.slick",
            { message: "index" },
            e.changeSlide
          ),
          !0 === e.options.accessibility &&
            e.$dots.on("keydown.slick", e.keyHandler)),
          !0 === e.options.dots &&
            !0 === e.options.pauseOnDotsHover &&
            e.slideCount > e.options.slidesToShow &&
            c("li", e.$dots)
              .on("mouseenter.slick", c.proxy(e.interrupt, e, !0))
              .on("mouseleave.slick", c.proxy(e.interrupt, e, !1));
      }),
      (s.prototype.initSlideEvents = function () {
        var e = this;
        e.options.pauseOnHover &&
          (e.$list.on("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
          e.$list.on("mouseleave.slick", c.proxy(e.interrupt, e, !1)));
      }),
      (s.prototype.initializeEvents = function () {
        var e = this;
        e.initArrowEvents(),
          e.initDotEvents(),
          e.initSlideEvents(),
          e.$list.on(
            "touchstart.slick mousedown.slick",
            { action: "start" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchmove.slick mousemove.slick",
            { action: "move" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchend.slick mouseup.slick",
            { action: "end" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchcancel.slick mouseleave.slick",
            { action: "end" },
            e.swipeHandler
          ),
          e.$list.on("click.slick", e.clickHandler),
          c(document).on(e.visibilityChange, c.proxy(e.visibility, e)),
          !0 === e.options.accessibility &&
            e.$list.on("keydown.slick", e.keyHandler),
          !0 === e.options.focusOnSelect &&
            c(e.$slideTrack).children().on("click.slick", e.selectHandler),
          c(window).on(
            "orientationchange.slick.slick-" + e.instanceUid,
            c.proxy(e.orientationChange, e)
          ),
          c(window).on(
            "resize.slick.slick-" + e.instanceUid,
            c.proxy(e.resize, e)
          ),
          c("[draggable!=true]", e.$slideTrack).on(
            "dragstart",
            e.preventDefault
          ),
          c(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
          c(e.setPosition);
      }),
      (s.prototype.initUI = function () {
        var e = this;
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.show(), e.$nextArrow.show()),
          !0 === e.options.dots &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.show();
      }),
      (s.prototype.keyHandler = function (e) {
        var t = this;
        e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
          (37 === e.keyCode && !0 === t.options.accessibility
            ? t.changeSlide({
                data: { message: !0 === t.options.rtl ? "next" : "previous" },
              })
            : 39 === e.keyCode &&
              !0 === t.options.accessibility &&
              t.changeSlide({
                data: { message: !0 === t.options.rtl ? "previous" : "next" },
              }));
      }),
      (s.prototype.lazyLoad = function () {
        var e,
          t,
          i,
          r = this;
        function n(e) {
          c("img[data-lazy]", e).each(function () {
            var e = c(this),
              t = c(this).attr("data-lazy"),
              i = c(this).attr("data-srcset"),
              n = c(this).attr("data-sizes") || r.$slider.attr("data-sizes"),
              o = document.createElement("img");
            (o.onload = function () {
              e.animate({ opacity: 0 }, 100, function () {
                i && (e.attr("srcset", i), n && e.attr("sizes", n)),
                  e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                    e.removeAttr(
                      "data-lazy data-srcset data-sizes"
                    ).removeClass("slick-loading");
                  }),
                  r.$slider.trigger("lazyLoaded", [r, e, t]);
              });
            }),
              (o.onerror = function () {
                e
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                  r.$slider.trigger("lazyLoadError", [r, e, t]);
              }),
              (o.src = t);
          });
        }
        if (
          (!0 === r.options.centerMode
            ? (i =
                !0 === r.options.infinite
                  ? (t = r.currentSlide + (r.options.slidesToShow / 2 + 1)) +
                    r.options.slidesToShow +
                    2
                  : ((t = Math.max(
                      0,
                      r.currentSlide - (r.options.slidesToShow / 2 + 1)
                    )),
                    r.options.slidesToShow / 2 + 1 + 2 + r.currentSlide))
            : ((t = r.options.infinite
                ? r.options.slidesToShow + r.currentSlide
                : r.currentSlide),
              (i = Math.ceil(t + r.options.slidesToShow)),
              !0 === r.options.fade &&
                (0 < t && t--, i <= r.slideCount && i++)),
          (e = r.$slider.find(".slick-slide").slice(t, i)),
          "anticipated" === r.options.lazyLoad)
        )
          for (
            var o = t - 1, s = i, a = r.$slider.find(".slick-slide"), l = 0;
            l < r.options.slidesToScroll;
            l++
          )
            o < 0 && (o = r.slideCount - 1),
              (e = (e = e.add(a.eq(o))).add(a.eq(s))),
              o--,
              s++;
        n(e),
          r.slideCount <= r.options.slidesToShow
            ? n(r.$slider.find(".slick-slide"))
            : r.currentSlide >= r.slideCount - r.options.slidesToShow
            ? n(
                r.$slider.find(".slick-cloned").slice(0, r.options.slidesToShow)
              )
            : 0 === r.currentSlide &&
              n(
                r.$slider
                  .find(".slick-cloned")
                  .slice(-1 * r.options.slidesToShow)
              );
      }),
      (s.prototype.loadSlider = function () {
        var e = this;
        e.setPosition(),
          e.$slideTrack.css({ opacity: 1 }),
          e.$slider.removeClass("slick-loading"),
          e.initUI(),
          "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
      }),
      (s.prototype.next = s.prototype.slickNext =
        function () {
          this.changeSlide({ data: { message: "next" } });
        }),
      (s.prototype.orientationChange = function () {
        this.checkResponsive(), this.setPosition();
      }),
      (s.prototype.pause = s.prototype.slickPause =
        function () {
          this.autoPlayClear(), (this.paused = !0);
        }),
      (s.prototype.play = s.prototype.slickPlay =
        function () {
          var e = this;
          e.autoPlay(),
            (e.options.autoplay = !0),
            (e.paused = !1),
            (e.focussed = !1),
            (e.interrupted = !1);
        }),
      (s.prototype.postSlide = function (e) {
        var t = this;
        t.unslicked ||
          (t.$slider.trigger("afterChange", [t, e]),
          (t.animating = !1),
          t.slideCount > t.options.slidesToShow && t.setPosition(),
          (t.swipeLeft = null),
          t.options.autoplay && t.autoPlay(),
          !0 === t.options.accessibility &&
            (t.initADA(),
            t.options.focusOnChange &&
              c(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
      }),
      (s.prototype.prev = s.prototype.slickPrev =
        function () {
          this.changeSlide({ data: { message: "previous" } });
        }),
      (s.prototype.preventDefault = function (e) {
        e.preventDefault();
      }),
      (s.prototype.progressiveLazyLoad = function (e) {
        e = e || 1;
        var t,
          i,
          n,
          o,
          r = this,
          s = c("img[data-lazy]", r.$slider);
        s.length
          ? ((t = s.first()),
            (i = t.attr("data-lazy")),
            (n = t.attr("data-srcset")),
            (o = t.attr("data-sizes") || r.$slider.attr("data-sizes")),
            ((s = document.createElement("img")).onload = function () {
              n && (t.attr("srcset", n), o && t.attr("sizes", o)),
                t
                  .attr("src", i)
                  .removeAttr("data-lazy data-srcset data-sizes")
                  .removeClass("slick-loading"),
                !0 === r.options.adaptiveHeight && r.setPosition(),
                r.$slider.trigger("lazyLoaded", [r, t, i]),
                r.progressiveLazyLoad();
            }),
            (s.onerror = function () {
              e < 3
                ? setTimeout(function () {
                    r.progressiveLazyLoad(e + 1);
                  }, 500)
                : (t
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading")
                    .addClass("slick-lazyload-error"),
                  r.$slider.trigger("lazyLoadError", [r, t, i]),
                  r.progressiveLazyLoad());
            }),
            (s.src = i))
          : r.$slider.trigger("allImagesLoaded", [r]);
      }),
      (s.prototype.refresh = function (e) {
        var t = this,
          i = t.slideCount - t.options.slidesToShow;
        !t.options.infinite && t.currentSlide > i && (t.currentSlide = i),
          t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
          (i = t.currentSlide),
          t.destroy(!0),
          c.extend(t, t.initials, { currentSlide: i }),
          t.init(),
          e || t.changeSlide({ data: { message: "index", index: i } }, !1);
      }),
      (s.prototype.registerBreakpoints = function () {
        var e,
          t,
          i,
          n = this,
          o = n.options.responsive || null;
        if ("array" === c.type(o) && o.length) {
          for (e in ((n.respondTo = n.options.respondTo || "window"), o))
            if (((i = n.breakpoints.length - 1), o.hasOwnProperty(e))) {
              for (t = o[e].breakpoint; 0 <= i; )
                n.breakpoints[i] &&
                  n.breakpoints[i] === t &&
                  n.breakpoints.splice(i, 1),
                  i--;
              n.breakpoints.push(t), (n.breakpointSettings[t] = o[e].settings);
            }
          n.breakpoints.sort(function (e, t) {
            return n.options.mobileFirst ? e - t : t - e;
          });
        }
      }),
      (s.prototype.reinit = function () {
        var e = this;
        (e.$slides = e.$slideTrack
          .children(e.options.slide)
          .addClass("slick-slide")),
          (e.slideCount = e.$slides.length),
          e.currentSlide >= e.slideCount &&
            0 !== e.currentSlide &&
            (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
          e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
          e.registerBreakpoints(),
          e.setProps(),
          e.setupInfinite(),
          e.buildArrows(),
          e.updateArrows(),
          e.initArrowEvents(),
          e.buildDots(),
          e.updateDots(),
          e.initDotEvents(),
          e.cleanUpSlideEvents(),
          e.initSlideEvents(),
          e.checkResponsive(!1, !0),
          !0 === e.options.focusOnSelect &&
            c(e.$slideTrack).children().on("click.slick", e.selectHandler),
          e.setSlideClasses(
            "number" == typeof e.currentSlide ? e.currentSlide : 0
          ),
          e.setPosition(),
          e.focusHandler(),
          (e.paused = !e.options.autoplay),
          e.autoPlay(),
          e.$slider.trigger("reInit", [e]);
      }),
      (s.prototype.resize = function () {
        var e = this;
        c(window).width() !== e.windowWidth &&
          (clearTimeout(e.windowDelay),
          (e.windowDelay = window.setTimeout(function () {
            (e.windowWidth = c(window).width()),
              e.checkResponsive(),
              e.unslicked || e.setPosition();
          }, 50)));
      }),
      (s.prototype.removeSlide = s.prototype.slickRemove =
        function (e, t, i) {
          var n = this;
          if (
            ((e =
              "boolean" == typeof e
                ? !0 === (t = e)
                  ? 0
                  : n.slideCount - 1
                : !0 === t
                ? --e
                : e),
            n.slideCount < 1 || e < 0 || e > n.slideCount - 1)
          )
            return !1;
          n.unload(),
            (!0 === i
              ? n.$slideTrack.children()
              : n.$slideTrack.children(this.options.slide).eq(e)
            ).remove(),
            (n.$slides = n.$slideTrack.children(this.options.slide)),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.append(n.$slides),
            (n.$slidesCache = n.$slides),
            n.reinit();
        }),
      (s.prototype.setCSS = function (e) {
        var t,
          i,
          n = this,
          o = {};
        !0 === n.options.rtl && (e = -e),
          (t = "left" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
          (i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
          (o[n.positionProp] = e),
          !1 === n.transformsEnabled ||
            (!(o = {}) === n.cssTransitions
              ? (o[n.animType] = "translate(" + t + ", " + i + ")")
              : (o[n.animType] = "translate3d(" + t + ", " + i + ", 0px)")),
          n.$slideTrack.css(o);
      }),
      (s.prototype.setDimensions = function () {
        var e = this;
        !1 === e.options.vertical
          ? !0 === e.options.centerMode &&
            e.$list.css({ padding: "0px " + e.options.centerPadding })
          : (e.$list.height(
              e.$slides.first().outerHeight(!0) * e.options.slidesToShow
            ),
            !0 === e.options.centerMode &&
              e.$list.css({ padding: e.options.centerPadding + " 0px" })),
          (e.listWidth = e.$list.width()),
          (e.listHeight = e.$list.height()),
          !1 === e.options.vertical && !1 === e.options.variableWidth
            ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)),
              e.$slideTrack.width(
                Math.ceil(
                  e.slideWidth * e.$slideTrack.children(".slick-slide").length
                )
              ))
            : !0 === e.options.variableWidth
            ? e.$slideTrack.width(5e3 * e.slideCount)
            : ((e.slideWidth = Math.ceil(e.listWidth)),
              e.$slideTrack.height(
                Math.ceil(
                  e.$slides.first().outerHeight(!0) *
                    e.$slideTrack.children(".slick-slide").length
                )
              ));
        var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
        !1 === e.options.variableWidth &&
          e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
      }),
      (s.prototype.setFade = function () {
        var i,
          n = this;
        n.$slides.each(function (e, t) {
          (i = n.slideWidth * e * -1),
            !0 === n.options.rtl
              ? c(t).css({
                  position: "relative",
                  right: i,
                  top: 0,
                  zIndex: n.options.zIndex - 2,
                  opacity: 0,
                })
              : c(t).css({
                  position: "relative",
                  left: i,
                  top: 0,
                  zIndex: n.options.zIndex - 2,
                  opacity: 0,
                });
        }),
          n.$slides
            .eq(n.currentSlide)
            .css({ zIndex: n.options.zIndex - 1, opacity: 1 });
      }),
      (s.prototype.setHeight = function () {
        var e,
          t = this;
        1 === t.options.slidesToShow &&
          !0 === t.options.adaptiveHeight &&
          !1 === t.options.vertical &&
          ((e = t.$slides.eq(t.currentSlide).outerHeight(!0)),
          t.$list.css("height", e));
      }),
      (s.prototype.setOption = s.prototype.slickSetOption =
        function () {
          var e,
            t,
            i,
            n,
            o,
            r = this,
            s = !1;
          if (
            ("object" === c.type(arguments[0])
              ? ((i = arguments[0]), (s = arguments[1]), (o = "multiple"))
              : "string" === c.type(arguments[0]) &&
                ((i = arguments[0]),
                (n = arguments[1]),
                (s = arguments[2]),
                "responsive" === arguments[0] &&
                "array" === c.type(arguments[1])
                  ? (o = "responsive")
                  : void 0 !== arguments[1] && (o = "single")),
            "single" === o)
          )
            r.options[i] = n;
          else if ("multiple" === o)
            c.each(i, function (e, t) {
              r.options[e] = t;
            });
          else if ("responsive" === o)
            for (t in n)
              if ("array" !== c.type(r.options.responsive))
                r.options.responsive = [n[t]];
              else {
                for (e = r.options.responsive.length - 1; 0 <= e; )
                  r.options.responsive[e].breakpoint === n[t].breakpoint &&
                    r.options.responsive.splice(e, 1),
                    e--;
                r.options.responsive.push(n[t]);
              }
          s && (r.unload(), r.reinit());
        }),
      (s.prototype.setPosition = function () {
        var e = this;
        e.setDimensions(),
          e.setHeight(),
          !1 === e.options.fade
            ? e.setCSS(e.getLeft(e.currentSlide))
            : e.setFade(),
          e.$slider.trigger("setPosition", [e]);
      }),
      (s.prototype.setProps = function () {
        var e = this,
          t = document.body.style;
        (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
          "top" === e.positionProp
            ? e.$slider.addClass("slick-vertical")
            : e.$slider.removeClass("slick-vertical"),
          (void 0 === t.WebkitTransition &&
            void 0 === t.MozTransition &&
            void 0 === t.msTransition) ||
            (!0 === e.options.useCSS && (e.cssTransitions = !0)),
          e.options.fade &&
            ("number" == typeof e.options.zIndex
              ? e.options.zIndex < 3 && (e.options.zIndex = 3)
              : (e.options.zIndex = e.defaults.zIndex)),
          void 0 !== t.OTransform &&
            ((e.animType = "OTransform"),
            (e.transformType = "-o-transform"),
            (e.transitionType = "OTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.MozTransform &&
            ((e.animType = "MozTransform"),
            (e.transformType = "-moz-transform"),
            (e.transitionType = "MozTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.MozPerspective &&
              (e.animType = !1)),
          void 0 !== t.webkitTransform &&
            ((e.animType = "webkitTransform"),
            (e.transformType = "-webkit-transform"),
            (e.transitionType = "webkitTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.msTransform &&
            ((e.animType = "msTransform"),
            (e.transformType = "-ms-transform"),
            (e.transitionType = "msTransition"),
            void 0 === t.msTransform && (e.animType = !1)),
          void 0 !== t.transform &&
            !1 !== e.animType &&
            ((e.animType = "transform"),
            (e.transformType = "transform"),
            (e.transitionType = "transition")),
          (e.transformsEnabled =
            e.options.useTransform && null !== e.animType && !1 !== e.animType);
      }),
      (s.prototype.setSlideClasses = function (e) {
        var t,
          i,
          n,
          o = this,
          r = o.$slider
            .find(".slick-slide")
            .removeClass("slick-active slick-center slick-current")
            .attr("aria-hidden", "true");
        o.$slides.eq(e).addClass("slick-current"),
          !0 === o.options.centerMode
            ? ((i = o.options.slidesToShow % 2 == 0 ? 1 : 0),
              (n = Math.floor(o.options.slidesToShow / 2)),
              !0 === o.options.infinite &&
                (n <= e && e <= o.slideCount - 1 - n
                  ? o.$slides
                      .slice(e - n + i, e + n + 1)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : ((t = o.options.slidesToShow + e),
                    r
                      .slice(t - n + 1 + i, t + n + 2)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")),
                0 === e
                  ? r
                      .eq(r.length - 1 - o.options.slidesToShow)
                      .addClass("slick-center")
                  : e === o.slideCount - 1 &&
                    r.eq(o.options.slidesToShow).addClass("slick-center")),
              o.$slides.eq(e).addClass("slick-center"))
            : 0 <= e && e <= o.slideCount - o.options.slidesToShow
            ? o.$slides
                .slice(e, e + o.options.slidesToShow)
                .addClass("slick-active")
                .attr("aria-hidden", "false")
            : r.length <= o.options.slidesToShow
            ? r.addClass("slick-active").attr("aria-hidden", "false")
            : ((n = o.slideCount % o.options.slidesToShow),
              (t = !0 === o.options.infinite ? o.options.slidesToShow + e : e),
              (o.options.slidesToShow == o.options.slidesToScroll &&
              o.slideCount - e < o.options.slidesToShow
                ? r.slice(t - (o.options.slidesToShow - n), t + n)
                : r.slice(t, t + o.options.slidesToShow)
              )
                .addClass("slick-active")
                .attr("aria-hidden", "false")),
          ("ondemand" !== o.options.lazyLoad &&
            "anticipated" !== o.options.lazyLoad) ||
            o.lazyLoad();
      }),
      (s.prototype.setupInfinite = function () {
        var e,
          t,
          i,
          n = this;
        if (
          (!0 === n.options.fade && (n.options.centerMode = !1),
          !0 === n.options.infinite &&
            !1 === n.options.fade &&
            ((t = null), n.slideCount > n.options.slidesToShow))
        ) {
          for (
            i =
              !0 === n.options.centerMode
                ? n.options.slidesToShow + 1
                : n.options.slidesToShow,
              e = n.slideCount;
            e > n.slideCount - i;
            --e
          )
            c(n.$slides[(t = e - 1)])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t - n.slideCount)
              .prependTo(n.$slideTrack)
              .addClass("slick-cloned");
          for (e = 0; e < i + n.slideCount; e += 1)
            (t = e),
              c(n.$slides[t])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", t + n.slideCount)
                .appendTo(n.$slideTrack)
                .addClass("slick-cloned");
          n.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              c(this).attr("id", "");
            });
        }
      }),
      (s.prototype.interrupt = function (e) {
        e || this.autoPlay(), (this.interrupted = e);
      }),
      (s.prototype.selectHandler = function (e) {
        (e = c(e.target).is(".slick-slide")
          ? c(e.target)
          : c(e.target).parents(".slick-slide")),
          (e = parseInt(e.attr("data-slick-index")) || 0);
        this.slideCount <= this.options.slidesToShow
          ? this.slideHandler(e, !1, !0)
          : this.slideHandler(e);
      }),
      (s.prototype.slideHandler = function (e, t, i) {
        var n,
          o,
          r,
          s,
          a = this;
        if (
          ((t = t || !1),
          !(
            (!0 === a.animating && !0 === a.options.waitForAnimate) ||
            (!0 === a.options.fade && a.currentSlide === e)
          ))
        )
          if (
            (!1 === t && a.asNavFor(e),
            (n = e),
            (r = a.getLeft(n)),
            (t = a.getLeft(a.currentSlide)),
            (a.currentLeft = null === a.swipeLeft ? t : a.swipeLeft),
            !1 === a.options.infinite &&
              !1 === a.options.centerMode &&
              (e < 0 || e > a.getDotCount() * a.options.slidesToScroll))
          )
            !1 === a.options.fade &&
              ((n = a.currentSlide),
              !0 !== i && a.slideCount > a.options.slidesToShow
                ? a.animateSlide(t, function () {
                    a.postSlide(n);
                  })
                : a.postSlide(n));
          else if (
            !1 === a.options.infinite &&
            !0 === a.options.centerMode &&
            (e < 0 || e > a.slideCount - a.options.slidesToScroll)
          )
            !1 === a.options.fade &&
              ((n = a.currentSlide),
              !0 !== i && a.slideCount > a.options.slidesToShow
                ? a.animateSlide(t, function () {
                    a.postSlide(n);
                  })
                : a.postSlide(n));
          else {
            if (
              (a.options.autoplay && clearInterval(a.autoPlayTimer),
              (o =
                n < 0
                  ? a.slideCount % a.options.slidesToScroll != 0
                    ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                    : a.slideCount + n
                  : n >= a.slideCount
                  ? a.slideCount % a.options.slidesToScroll != 0
                    ? 0
                    : n - a.slideCount
                  : n),
              (a.animating = !0),
              a.$slider.trigger("beforeChange", [a, a.currentSlide, o]),
              (t = a.currentSlide),
              (a.currentSlide = o),
              a.setSlideClasses(a.currentSlide),
              a.options.asNavFor &&
                (s = (s = a.getNavTarget()).slick("getSlick")).slideCount <=
                  s.options.slidesToShow &&
                s.setSlideClasses(a.currentSlide),
              a.updateDots(),
              a.updateArrows(),
              !0 === a.options.fade)
            )
              return (
                !0 !== i
                  ? (a.fadeSlideOut(t),
                    a.fadeSlide(o, function () {
                      a.postSlide(o);
                    }))
                  : a.postSlide(o),
                void a.animateHeight()
              );
            !0 !== i && a.slideCount > a.options.slidesToShow
              ? a.animateSlide(r, function () {
                  a.postSlide(o);
                })
              : a.postSlide(o);
          }
      }),
      (s.prototype.startLoad = function () {
        var e = this;
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.hide(), e.$nextArrow.hide()),
          !0 === e.options.dots &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.hide(),
          e.$slider.addClass("slick-loading");
      }),
      (s.prototype.swipeDirection = function () {
        var e = this,
          t = e.touchObject.startX - e.touchObject.curX,
          i = e.touchObject.startY - e.touchObject.curY,
          t = Math.atan2(i, t),
          t = Math.round((180 * t) / Math.PI);
        return ((t = t < 0 ? 360 - Math.abs(t) : t) <= 45 && 0 <= t) ||
          (t <= 360 && 315 <= t)
          ? !1 === e.options.rtl
            ? "left"
            : "right"
          : 135 <= t && t <= 225
          ? !1 === e.options.rtl
            ? "right"
            : "left"
          : !0 === e.options.verticalSwiping
          ? 35 <= t && t <= 135
            ? "down"
            : "up"
          : "vertical";
      }),
      (s.prototype.swipeEnd = function (e) {
        var t,
          i,
          n = this;
        if (((n.dragging = !1), (n.swiping = !1), n.scrolling))
          return (n.scrolling = !1);
        if (
          ((n.interrupted = !1),
          (n.shouldClick = !(10 < n.touchObject.swipeLength)),
          void 0 === n.touchObject.curX)
        )
          return !1;
        if (
          (!0 === n.touchObject.edgeHit &&
            n.$slider.trigger("edge", [n, n.swipeDirection()]),
          n.touchObject.swipeLength >= n.touchObject.minSwipe)
        ) {
          switch ((i = n.swipeDirection())) {
            case "left":
            case "down":
              (t = n.options.swipeToSlide
                ? n.checkNavigable(n.currentSlide + n.getSlideCount())
                : n.currentSlide + n.getSlideCount()),
                (n.currentDirection = 0);
              break;
            case "right":
            case "up":
              (t = n.options.swipeToSlide
                ? n.checkNavigable(n.currentSlide - n.getSlideCount())
                : n.currentSlide - n.getSlideCount()),
                (n.currentDirection = 1);
          }
          "vertical" != i &&
            (n.slideHandler(t),
            (n.touchObject = {}),
            n.$slider.trigger("swipe", [n, i]));
        } else
          n.touchObject.startX !== n.touchObject.curX &&
            (n.slideHandler(n.currentSlide), (n.touchObject = {}));
      }),
      (s.prototype.swipeHandler = function (e) {
        var t = this;
        if (
          !(
            !1 === t.options.swipe ||
            ("ontouchend" in document && !1 === t.options.swipe) ||
            (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))
          )
        )
          switch (
            ((t.touchObject.fingerCount =
              e.originalEvent && void 0 !== e.originalEvent.touches
                ? e.originalEvent.touches.length
                : 1),
            (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
            !0 === t.options.verticalSwiping &&
              (t.touchObject.minSwipe =
                t.listHeight / t.options.touchThreshold),
            e.data.action)
          ) {
            case "start":
              t.swipeStart(e);
              break;
            case "move":
              t.swipeMove(e);
              break;
            case "end":
              t.swipeEnd(e);
          }
      }),
      (s.prototype.swipeMove = function (e) {
        var t,
          i,
          n = this,
          o = void 0 !== e.originalEvent ? e.originalEvent.touches : null;
        return (
          !(!n.dragging || n.scrolling || (o && 1 !== o.length)) &&
          ((t = n.getLeft(n.currentSlide)),
          (n.touchObject.curX = void 0 !== o ? o[0].pageX : e.clientX),
          (n.touchObject.curY = void 0 !== o ? o[0].pageY : e.clientY),
          (n.touchObject.swipeLength = Math.round(
            Math.sqrt(Math.pow(n.touchObject.curX - n.touchObject.startX, 2))
          )),
          (i = Math.round(
            Math.sqrt(Math.pow(n.touchObject.curY - n.touchObject.startY, 2))
          )),
          !n.options.verticalSwiping && !n.swiping && 4 < i
            ? !(n.scrolling = !0)
            : (!0 === n.options.verticalSwiping &&
                (n.touchObject.swipeLength = i),
              (o = n.swipeDirection()),
              void 0 !== e.originalEvent &&
                4 < n.touchObject.swipeLength &&
                ((n.swiping = !0), e.preventDefault()),
              (i =
                (!1 === n.options.rtl ? 1 : -1) *
                (n.touchObject.curX > n.touchObject.startX ? 1 : -1)),
              !0 === n.options.verticalSwiping &&
                (i = n.touchObject.curY > n.touchObject.startY ? 1 : -1),
              (e = n.touchObject.swipeLength),
              (n.touchObject.edgeHit = !1) === n.options.infinite &&
                ((0 === n.currentSlide && "right" === o) ||
                  (n.currentSlide >= n.getDotCount() && "left" === o)) &&
                ((e = n.touchObject.swipeLength * n.options.edgeFriction),
                (n.touchObject.edgeHit = !0)),
              !1 === n.options.vertical
                ? (n.swipeLeft = t + e * i)
                : (n.swipeLeft = t + e * (n.$list.height() / n.listWidth) * i),
              !0 === n.options.verticalSwiping && (n.swipeLeft = t + e * i),
              !0 !== n.options.fade &&
                !1 !== n.options.touchMove &&
                (!0 === n.animating
                  ? ((n.swipeLeft = null), !1)
                  : void n.setCSS(n.swipeLeft))))
        );
      }),
      (s.prototype.swipeStart = function (e) {
        var t,
          i = this;
        if (
          ((i.interrupted = !0),
          1 !== i.touchObject.fingerCount ||
            i.slideCount <= i.options.slidesToShow)
        )
          return !(i.touchObject = {});
        void 0 !== e.originalEvent &&
          void 0 !== e.originalEvent.touches &&
          (t = e.originalEvent.touches[0]),
          (i.touchObject.startX = i.touchObject.curX =
            void 0 !== t ? t.pageX : e.clientX),
          (i.touchObject.startY = i.touchObject.curY =
            void 0 !== t ? t.pageY : e.clientY),
          (i.dragging = !0);
      }),
      (s.prototype.unfilterSlides = s.prototype.slickUnfilter =
        function () {
          var e = this;
          null !== e.$slidesCache &&
            (e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.appendTo(e.$slideTrack),
            e.reinit());
        }),
      (s.prototype.unload = function () {
        var e = this;
        c(".slick-cloned", e.$slider).remove(),
          e.$dots && e.$dots.remove(),
          e.$prevArrow &&
            e.htmlExpr.test(e.options.prevArrow) &&
            e.$prevArrow.remove(),
          e.$nextArrow &&
            e.htmlExpr.test(e.options.nextArrow) &&
            e.$nextArrow.remove(),
          e.$slides
            .removeClass("slick-slide slick-active slick-visible slick-current")
            .attr("aria-hidden", "true")
            .css("width", "");
      }),
      (s.prototype.unslick = function (e) {
        this.$slider.trigger("unslick", [this, e]), this.destroy();
      }),
      (s.prototype.updateArrows = function () {
        var e = this;
        Math.floor(e.options.slidesToShow / 2);
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          !e.options.infinite &&
          (e.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          e.$nextArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          0 === e.currentSlide
            ? (e.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              e.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : ((e.currentSlide >= e.slideCount - e.options.slidesToShow &&
                !1 === e.options.centerMode) ||
                (e.currentSlide >= e.slideCount - 1 &&
                  !0 === e.options.centerMode)) &&
              (e.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              e.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false")));
      }),
      (s.prototype.updateDots = function () {
        var e = this;
        null !== e.$dots &&
          (e.$dots.find("li").removeClass("slick-active").end(),
          e.$dots
            .find("li")
            .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
            .addClass("slick-active"));
      }),
      (s.prototype.visibility = function () {
        this.options.autoplay &&
          (document[this.hidden]
            ? (this.interrupted = !0)
            : (this.interrupted = !1));
      }),
      (c.fn.slick = function () {
        for (
          var e,
            t = this,
            i = arguments[0],
            n = Array.prototype.slice.call(arguments, 1),
            o = t.length,
            r = 0;
          r < o;
          r++
        )
          if (
            ("object" == typeof i || void 0 === i
              ? (t[r].slick = new s(t[r], i))
              : (e = t[r].slick[i].apply(t[r].slick, n)),
            void 0 !== e)
          )
            return e;
        return t;
      });
  }),
  (function (e) {
    "function" == typeof define && define.amd
      ? define(["jquery"], e)
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("jquery")))
      : e(jQuery);
  })(function (d) {
    function e() {
      for (
        var e = u.scrollTop(),
          t = p.height(),
          i = t - h,
          n = i < e ? i - e : 0,
          o = 0,
          r = f.length;
        o < r;
        o++
      ) {
        var s,
          a,
          l = f[o],
          c = l.stickyWrapper.offset().top - l.topSpacing - n;
        l.stickyWrapper.css("height", l.stickyElement.outerHeight()),
          e <= c
            ? null !== l.currentTop &&
              (l.stickyElement.css({
                width: "",
                position: "",
                top: "",
                "z-index": "",
              }),
              l.stickyElement.parent().removeClass(l.className),
              l.stickyElement.trigger("sticky-end", [l]),
              (l.currentTop = null))
            : ((s =
                t -
                l.stickyElement.outerHeight() -
                l.topSpacing -
                l.bottomSpacing -
                e -
                n) < 0
                ? (s += l.topSpacing)
                : (s = l.topSpacing),
              l.currentTop !== s &&
                (l.getWidthFrom
                  ? (a = d(l.getWidthFrom).width() || null)
                  : l.widthFromWrapper && (a = l.stickyWrapper.width()),
                null == a && (a = l.stickyElement.width()),
                l.stickyElement
                  .css("width", a)
                  .css("position", "fixed")
                  .css("top", s)
                  .css("z-index", l.zIndex),
                l.stickyElement.parent().addClass(l.className),
                null === l.currentTop
                  ? l.stickyElement.trigger("sticky-start", [l])
                  : l.stickyElement.trigger("sticky-update", [l]),
                (l.currentTop === l.topSpacing && l.currentTop > s) ||
                (null === l.currentTop && s < l.topSpacing)
                  ? l.stickyElement.trigger("sticky-bottom-reached", [l])
                  : null !== l.currentTop &&
                    s === l.topSpacing &&
                    l.currentTop < s &&
                    l.stickyElement.trigger("sticky-bottom-unreached", [l]),
                (l.currentTop = s)),
              (c = l.stickyWrapper.parent()),
              l.stickyElement.offset().top + l.stickyElement.outerHeight() >=
                c.offset().top + c.outerHeight() &&
              l.stickyElement.offset().top <= l.topSpacing
                ? l.stickyElement
                    .css("position", "absolute")
                    .css("top", "")
                    .css("bottom", 0)
                    .css("z-index", "")
                : l.stickyElement
                    .css("position", "fixed")
                    .css("top", s)
                    .css("bottom", "")
                    .css("z-index", l.zIndex));
      }
    }
    function t() {
      h = u.height();
      for (var e = 0, t = f.length; e < t; e++) {
        var i = f[e],
          n = null;
        i.getWidthFrom
          ? i.responsiveWidth && (n = d(i.getWidthFrom).width())
          : i.widthFromWrapper && (n = i.stickyWrapper.width()),
          null != n && i.stickyElement.css("width", n);
      }
    }
    var i = Array.prototype.slice,
      n = Array.prototype.splice,
      s = {
        topSpacing: 0,
        bottomSpacing: 0,
        className: "is-sticky",
        wrapperClassName: "sticky-wrapper",
        center: !1,
        getWidthFrom: "",
        widthFromWrapper: !0,
        responsiveWidth: !1,
        zIndex: "auto",
      },
      u = d(window),
      p = d(document),
      f = [],
      h = u.height(),
      a = {
        init: function (r) {
          return this.each(function () {
            var e = d.extend({}, s, r),
              t = d(this),
              i = t.attr("id"),
              n = i ? i + "-" + s.wrapperClassName : s.wrapperClassName,
              o = d("<div></div>").attr("id", n).addClass(e.wrapperClassName);
            t.wrapAll(function () {
              if (0 == d(this).parent("#" + n).length) return o;
            });
            i = t.parent();
            e.center &&
              i.css({
                width: t.outerWidth(),
                marginLeft: "auto",
                marginRight: "auto",
              }),
              "right" === t.css("float") &&
                t.css({ float: "none" }).parent().css({ float: "right" }),
              (e.stickyElement = t),
              (e.stickyWrapper = i),
              (e.currentTop = null),
              f.push(e),
              a.setWrapperHeight(this),
              a.setupChangeListeners(this);
          });
        },
        setWrapperHeight: function (e) {
          var t = d(e),
            e = t.parent();
          e && e.css("height", t.outerHeight());
        },
        setupChangeListeners: function (t) {
          window.MutationObserver
            ? new window.MutationObserver(function (e) {
                (e[0].addedNodes.length || e[0].removedNodes.length) &&
                  a.setWrapperHeight(t);
              }).observe(t, { subtree: !0, childList: !0 })
            : window.addEventListener
            ? (t.addEventListener(
                "DOMNodeInserted",
                function () {
                  a.setWrapperHeight(t);
                },
                !1
              ),
              t.addEventListener(
                "DOMNodeRemoved",
                function () {
                  a.setWrapperHeight(t);
                },
                !1
              ))
            : window.attachEvent &&
              (t.attachEvent("onDOMNodeInserted", function () {
                a.setWrapperHeight(t);
              }),
              t.attachEvent("onDOMNodeRemoved", function () {
                a.setWrapperHeight(t);
              }));
        },
        update: e,
        unstick: function (e) {
          return this.each(function () {
            for (var e = d(this), t = -1, i = f.length; 0 < i--; )
              f[i].stickyElement.get(0) === this && (n.call(f, i, 1), (t = i));
            -1 !== t &&
              (e.unwrap(),
              e.css({
                width: "",
                position: "",
                top: "",
                float: "",
                "z-index": "",
              }));
          });
        },
      };
    window.addEventListener
      ? (window.addEventListener("scroll", e, !1),
        window.addEventListener("resize", t, !1))
      : window.attachEvent &&
        (window.attachEvent("onscroll", e), window.attachEvent("onresize", t)),
      (d.fn.sticky = function (e) {
        return a[e]
          ? a[e].apply(this, i.call(arguments, 1))
          : "object" != typeof e && e
          ? void d.error("Method " + e + " does not exist on jQuery.sticky")
          : a.init.apply(this, arguments);
      }),
      (d.fn.unstick = function (e) {
        return a[e]
          ? a[e].apply(this, i.call(arguments, 1))
          : "object" != typeof e && e
          ? void d.error("Method " + e + " does not exist on jQuery.sticky")
          : a.unstick.apply(this, arguments);
      }),
      d(function () {
        setTimeout(e, 0);
      });
  }),
  function () {
    var z = this.jQuery || window.jQuery,
      D = z(window);
    z.fn.stick_in_parent = function (e) {
      var k,
        t,
        i,
        n,
        x = (e = null == e ? {} : e).sticky_class,
        T = e.inner_scrolling,
        C = e.recalc_every,
        S = e.parent,
        A = e.offset_top,
        E = e.spacer,
        $ = e.bottoming;
      for (
        null == A && (A = 0),
          null == S && (S = void 0),
          null == T && (T = !0),
          null == x && (x = "is_stuck"),
          k = z(document),
          null == $ && ($ = !0),
          t = function (o, r, s, a, l, c, d, u) {
            var p, e, f, h, g, v, m, y, t, w, b, n;
            if (!o.data("sticky_kit")) {
              if (
                (o.data("sticky_kit", !0),
                (g = k.height()),
                (m = o.parent()),
                !(m = null != S ? m.closest(S) : m).length)
              )
                throw "failed to find stick parent";
              if (
                ((p = f = !1),
                (b = null != E ? E && o.closest(E) : z("<div />")) &&
                  b.css("position", o.css("position")),
                (y = function () {
                  var e, t, i;
                  if (
                    !u &&
                    ((g = k.height()),
                    (e = parseInt(m.css("border-top-width"), 10)),
                    (t = parseInt(m.css("padding-top"), 10)),
                    (r = parseInt(m.css("padding-bottom"), 10)),
                    (s = m.offset().top + e + t),
                    (a = m.height()),
                    f &&
                      ((p = f = !1),
                      null == E && (o.insertAfter(b), b.detach()),
                      o
                        .css({ position: "", top: "", width: "", bottom: "" })
                        .removeClass(x),
                      (i = !0)),
                    (l =
                      o.offset().top -
                      (parseInt(o.css("margin-top"), 10) || 0) -
                      A),
                    (c = o.outerHeight(!0)),
                    (d = o.css("float")),
                    b &&
                      b.css({
                        width: o.outerWidth(!0),
                        height: c,
                        display: o.css("display"),
                        "vertical-align": o.css("vertical-align"),
                        float: d,
                      }),
                    i)
                  )
                    return n();
                })(),
                c !== a)
              )
                return (
                  (h = void 0),
                  (v = A),
                  (w = C),
                  (n = function () {
                    var e, t, i, n;
                    if (
                      !u &&
                      ((i = !1),
                      null != w && --w <= 0 && ((w = C), y(), (i = !0)),
                      i || k.height() === g || y(),
                      (i = D.scrollTop()),
                      null != h && (t = i - h),
                      (h = i),
                      f
                        ? ($ &&
                            ((n = a + s < i + c + v),
                            p &&
                              !n &&
                              ((p = !1),
                              o
                                .css({ position: "fixed", bottom: "", top: v })
                                .trigger("sticky_kit:unbottom"))),
                          i < l &&
                            ((f = !1),
                            (v = A),
                            null == E &&
                              (("left" !== d && "right" !== d) ||
                                o.insertAfter(b),
                              b.detach()),
                            o
                              .css((e = { position: "", width: "", top: "" }))
                              .removeClass(x)
                              .trigger("sticky_kit:unstick")),
                          T &&
                            (e = D.height()) < c + A &&
                            !p &&
                            ((v -= t),
                            (v = Math.max(e - c, v)),
                            (v = Math.min(A, v)),
                            f && o.css({ top: v + "px" })))
                        : l < i &&
                          ((f = !0),
                          ((e = { position: "fixed", top: v }).width =
                            "border-box" === o.css("box-sizing")
                              ? o.outerWidth() + "px"
                              : o.width() + "px"),
                          o.css(e).addClass(x),
                          null == E &&
                            (o.after(b),
                            ("left" !== d && "right" !== d) || b.append(o)),
                          o.trigger("sticky_kit:stick")),
                      f && $ && (null == n && (n = a + s < i + c + v), !p && n))
                    )
                      return (
                        (p = !0),
                        "static" === m.css("position") &&
                          m.css({ position: "relative" }),
                        o
                          .css({ position: "absolute", bottom: r, top: "auto" })
                          .trigger("sticky_kit:bottom")
                      );
                  }),
                  (t = function () {
                    return y(), n();
                  }),
                  (e = function () {
                    if (
                      ((u = !0),
                      D.off("touchmove", n),
                      D.off("scroll", n),
                      D.off("resize", t),
                      z(document.body).off("sticky_kit:recalc", t),
                      o.off("sticky_kit:detach", e),
                      o.removeData("sticky_kit"),
                      o.css({ position: "", bottom: "", top: "", width: "" }),
                      m.position("position", ""),
                      f)
                    )
                      return (
                        null == E &&
                          (("left" !== d && "right" !== d) || o.insertAfter(b),
                          b.remove()),
                        o.removeClass(x)
                      );
                  }),
                  D.on("touchmove", n),
                  D.on("scroll", n),
                  D.on("resize", t),
                  z(document.body).on("sticky_kit:recalc", t),
                  o.on("sticky_kit:detach", e),
                  setTimeout(n, 0)
                );
            }
          },
          i = 0,
          n = this.length;
        i < n;
        i++
      )
        (e = this[i]), t(z(e));
      return this;
    };
  }.call(this),
  (Shopify.money_format = "{{amount}} €"),
  (Shopify.formatMoney = function (e, t) {
    "string" == typeof e && (e = e.replace(".", ""));
    var i = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      t = t || this.money_format;
    function o(e, t) {
      return void 0 === e ? t : e;
    }
    function r(e, t, i, n) {
      if (
        ((t = o(t, 2)), (i = o(i, ".")), (n = o(n, ",")), isNaN(e) || null == e)
      )
        return 0;
      e = (e = (e / 100).toFixed(t)).split(".");
      return (
        e[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
        (e[1] ? n + e[1] : "")
      );
    }
    switch (t.match(n)[1]) {
      case "amount":
        i = r(e, 2);
        break;
      case "amount_no_decimals":
        i = r(e, 0);
        break;
      case "amount_with_comma_separator":
        i = r(e, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        i = r(e, 0, ".", ",");
    }
    return t.replace(n, i);
  }),
  (function (c) {
    var i;
    function d() {
      50 <= c(window).scrollTop()
        ? (c("header,#SBTrustedShopsMobile").addClass("scrolled"),
          c("#fade-it-on-scroll").slideUp(550))
        : (c("header,#SBTrustedShopsMobile").removeClass("scrolled"),
          c("#fade-it-on-scroll").slideDown(550)),
        c(window).width();
    }
    function u(e, t, i) {
      var n = new Date();
      n.setTime(n.getTime() + 24 * i * 60 * 60 * 1e3);
      n = "expires=" + n.toUTCString();
      document.cookie = e + "=" + t + ";" + n + ";path=/";
    }
    function p() {
      c('input[type="checkbox"]:not(.hide)').each(function () {
        if (c(this).hasClass("hide")) return !0;
        var e = c('<div class="checkbox"></div>');
        c(this).before(e),
          c(this).is(":checked") && c(e).addClass("active"),
          c(this).addClass("hide");
      }),
        c(".checkbox")
          .off("click")
          .click(function (e) {

            0 === c(this).parent("label").length
              ? (e.stopPropagation(),
                c(this).parent().toggleClass("active"),

                c(this).toggleClass("active"),
                c(this).hasClass("active")
                  ? c(this).next().prop("checked", !0)
                  : c(this).next().prop("checked", !1))
              : c(this).next().trigger("change");
            c(this).parent().trigger('change');
          });
    }
    ((i = jQuery).fn.onSwipe = function (a, l, e, t) {
      var c, d, u, p, f, h;
      return (
        jQuery.isFunction(a)
          ? (null == l && (l = 100),
            null == e && (e = 30),
            null == t && (t = 30),
            (h = 0),
            i(this).on("touchstart", function (e) {
              (c = e.touches[0].clientX),
                (d = e.touches[0].clientY),
                (f = setInterval(function () {
                  h += 10;
                }, 10));
            }),
            i(this).on("touchend", function (e) {
              var t, i, n, o, r, s;
              (u = e.changedTouches[0].clientX),
                (p = e.changedTouches[0].clientY),
                clearInterval(f),
                l <= h &&
                  a(
                    ((t = d),
                    (n = p),
                    (s = { up: !(r = o = 30), right: !1, down: !1, left: !1 }),
                    (i = u) < (e = c) && o <= e - i
                      ? (s.left = !0)
                      : e < i && o <= i - e && (s.right = !0),
                    t < n && r <= n - t
                      ? (s.down = !0)
                      : n < t && r <= t - n && (s.up = !0),
                    s)
                  ),
                (h = 0);
            }))
          : console.error(
              "You need to pass a function in order to process swipe data."
            ),
        i(this)
      );
    }),
      c(window).on("scroll", function () {
        d();
      }),
      c(document).ready(function () {
        0 < c("#single-article-content").length &&
          (c("#toc-blog").html("<p>Inhaltsverzeichnis</p><ol></ol>"),
          c("#single-article-content")
            .find("h2,h3")
            .each(function (e, t) {
              var i = c(
                '<a class="the-anchor" id="section-' + (e + 1) + '"></a>'
              );
              c(t).before(i),
                "" !== c(t).text().trim() &&
                  c("#toc-blog ol").append(
                    c(
                      '<li><a href="#section-' +
                        (e + 1) +
                        '">' +
                        c(t).text() +
                        "</a></li>"
                    )
                  );
            }),
          4 < c("#toc-blog ol li").length &&
            (c("#toc-blog").append(
              c(
                '<p class="text-center" id="read-more-toc-p"><a href="#" id="read-more-toc">Mehr anzeigen</a></p>'
              )
            ),
            c("#toc-blog ol li").addClass("hidden-toc"),
            c("#toc-blog ol li").slice(0, 4).removeClass("hidden-toc"),
            c("#read-more-toc").click(function (e) {
              e.preventDefault(),
                c(".hidden-toc").removeClass("hidden-toc"),
                c(this).parent().remove();
            })),
          c("#toc-blog ol li").length < 3 && c("#toc-blog").remove()),
          c(".additional-team-members").each(function () {
            var e = c(this).find(".col-sm-3");
            c("#about-page-team .row-spaced").append(e),
              c(this).closest(".shopify-section").remove();
          }),
          4 < c("#about-page-team .col-sm-3").length &&
            c("#about-page-team .row-center").removeClass("row-center"),
          c(".product-testimonials-2")
            .parent()
            .next()
            .find("#details")
            .addClass("after-testimonials"),
          c(".thumbnails a").click(function (e) {
            e.preventDefault();
            e = c(this).closest(".slick-slide").attr("data-slick-index");
            c("#main-image").slick("slickGoTo", e);
          }),
          c(".thumbnails").slick({ arrows: !1, dots: !1, slidesToShow: 6 }),
          c('.trast-slider-slick').slick({
            arrows: true,
            dots: !1,
            slidesToShow:4,
            responsive:[
            {
              breakpoint: 991,
              settings:{
                slidesToShow: 2,
                arrows: true,
                dots: !1
              }
            }
          ]
          }),
          c("#main-image").slick({
            prevArrow: '<a href="#" class="slick-prev"><svg id="Pfeil" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">\n' +
                '  <rect id="Hintergrund" width="40" height="40" rx="5" transform="translate(40 40) rotate(180)" fill="#f8f8f8"/>\n' +
                '  <g id="Icon_feather-arrow-down-left" data-name="Icon feather-arrow-down-left" transform="translate(23.154 13.846) rotate(45)">\n' +
                '    <path id="Path_9" data-name="Path 9" d="M8.7,8.7H0V0" fill="none" stroke="#797a8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>\n' +
                '  </g>\n' +
                '</svg></a>\n',
            nextArrow: '<a href="#" class="slick-next"><svg id="Pfeil" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">\n' +
                '  <rect id="Hintergrund" width="40" height="40" rx="5" transform="translate(40 40) rotate(180)" fill="#f8f8f8"/>\n' +
                '  <g id="Icon_feather-arrow-down-left" data-name="Icon feather-arrow-down-left" transform="translate(23.154 13.846) rotate(45)">\n' +
                '    <path id="Path_9" data-name="Path 9" d="M8.7,8.7H0V0" fill="none" stroke="#797a8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>\n' +
                '  </g>\n' +
                '</svg></a>\n',
          }),
          c("#main-image").on("beforeChange", function (e, t, i, n) {
            c(".thumbnails").slick("slickGoTo", n);
          }),
          setTimeout(function () {
            c(".home-newsletter .the-home-newsleeter").addClass("load-picture");
          }, 2e3),
          c("header a").mouseenter(function () {}),
          c(".open-app").click(function (e) {
            e.preventDefault(), c(".si-reset").trigger("click");
          }),
          d(),
          p(),
          setTimeout(function () {
            p();
          }, 3e3),
          setTimeout(function () {
            p();
          }, 1e3),
          c('input[type="checkbox"]').on("change", function () {
            c(this).is(":checked")
              ? c(this).prev().addClass("active")
              : c(this).prev().removeClass("active");
          }),
          c(".template-page-about .home-page-hero-floating a").click(function (
            e
          ) {
            e.preventDefault();
            e = 60;
            1024 < c(window).width() && (e = 100),
              c("body,html").animate(
                { scrollTop: c("#about-page-nav-above").offset().top - e },
                1e3
              );
          }),
          c(".so-accordion-wrapper").each(function (e, t) {
            var r = c('<div class="product-faq"></div>');
            c(this)
              .find(".so-tab")
              .each(function (e, t) {
                var i = c(this).clone();
                c(i).find(".so-tab-content").remove();
                var i = c(i)[0].innerText.trim(),
                  n = c(this).find(".so-tab-content").html(),
                  o = c(".faq-source").html(),
                  n = c(
                    '<div class="one-product-faq"><div class="one-product-question">' +
                      i +
                      o +
                      '</div><div class="one-product-answer">' +
                      n +
                      "</div></div>"
                  );
                c(r).append(n);
              }),
              c(t).after(r),
              c(t).remove();
          });
        var e, t, i, n;
        window.location.hash;
        function r() {
          0 === c(".one-cart-item").length
            ? c("body").addClass("empty-cart")
            : c("body").removeClass("empty-cart");
        }
        function s(e) {
          c(e).css("min-height", "0px"), c(e).css("box-sizing", "border-box");
          var i = 0;
          c("#mobile-categories select").on("change", function () {
            window.location = c(this).val();
          }),
            c(e).each(function (e, t) {
              t = c(t).outerHeight();
              i < t && (i = t);
            }),
            c(e).css("min-height", i);
        }
        function o() {
          var e,
            t,
            i,
            n = c(".one-product-slide"),
            o = 3;
          for (
            c(window).width() <= 1024 && (o = 2),
              c(window).width() <= 768 && (o = 2),
              e = 0,
              t = n.length;
            e < t;
            e += o
          )
            (i = n.slice(e, e + o)), s(c(i).find(".op-description"));
          setTimeout(function () {
            s(".the-products-slider .op-description");
          }, 200);
        }
        // Fix 2026-05-19 (Bug 1/2/7/13/15): zentraler Warenkorb-Update.
        var cartUpdateTimer = null,
          cartUpdateXHR = null,
          pendingCartUpdates = {};
        function applyCartUpdate(data) {
          c(".one-cart-item").css("opacity", "1");
          c(".items_subtotal_price").html(Shopify.formatMoney(data.items_subtotal_price));
          c(".total_price").html(Shopify.formatMoney(data.total_price));
          // Bug 15: Rabatt-Zeile (Order-Rabatt = items_subtotal - total).
          var orderDiscount = data.items_subtotal_price - data.total_price;
          if (orderDiscount > 0) {
            c(".cart-order-discount").html("-" + Shopify.formatMoney(orderDiscount));
            c(".cart-discount-row").css("display", "");
          } else {
            c(".cart-discount-row").css("display", "none");
          }
          var totalCount = 0;
          c(data.items).each(function (idx, li) {
            totalCount += li.quantity;
            // Bug 13: Zeile ueber den Line-Item-Key adressieren.
            var sel = '.one-cart-item[data-id="' + li.key + '"]';
            c(sel + " input").val(li.quantity);
            // Bug 1: Zeilenpreis in .cart-line-price schreiben — das Markup
            // (.current-price / .was-price / .theme-money) bleibt erhalten.
            c(sel + " .cart-line-price").each(function () {
              c(this).text(
                0 === li.final_line_price
                  ? "Geschenk"
                  : Shopify.formatMoney(li.final_line_price)
              );
            });
            // Streichpreis = Vergleichs-Stueckpreis (data-unit-old) x Menge.
            c(sel + " .cart-old-price").each(function () {
              var unitOld = parseInt(c(this).attr("data-unit-old"), 10);
              if (unitOld > 0) {
                c(this)
                  .text(Shopify.formatMoney(unitOld * li.quantity))
                  .css("display", "");
              } else {
                c(this).css("display", "none");
              }
            });
            li.quantity <= 0 && c(sel).remove();
          });
          c("#header-icons a span").html(totalCount);
          r();
        }
        function performCartUpdate() {
          var updates = pendingCartUpdates;
          pendingCartUpdates = {};
          // Bug 7: laufenden Request abbrechen, damit bei schnellen Klicks
          // keine veraltete Antwort zuletzt gewinnt.
          cartUpdateXHR && cartUpdateXHR.abort();
          cartUpdateXHR = jQuery
            .post(
              "/cart/update.js",
              { updates: updates },
              function (data) {
                cartUpdateXHR = null;
                applyCartUpdate(data);
              },
              "json"
            )
            .fail(function (xhr, status) {
              // Bug 2: Fehler-Handling. "abort" = vom naechsten Request
              // abgeloest -> ignorieren. Sonst Grund (z.B. Lagerlimit) zeigen
              // und den echten Serverstand neu laden.
              cartUpdateXHR = null;
              if ("abort" === status) return;
              c(".one-cart-item").css("opacity", "1");
              var msg =
                (xhr && xhr.responseJSON && xhr.responseJSON.description) ||
                (window.cartStrings && window.cartStrings.error) ||
                "";
              if (msg) window.alert(msg);
              window.location.reload();
            });
        }
        c("#arrow-down-mobile").click(function (e) {
          e.preventDefault();
          e = c(this).closest(".shopify-section").next().offset().top - 50;
          c("body,html").animate({ scrollTop: e }, 1e3);
        }),
          c(".oci-remove-and-price a").click(function (e) {
            e.preventDefault(),
              c(this).closest(".one-cart-item").find("input").val(0),
              c(this).closest(".one-cart-item").find("input").trigger("change");
            e = c(this).closest(".one-cart-item").attr("data-id");
            c('.one-cart-item[data-id="' + e + '"]').remove();
          }),
          c(".product-form").submit(function (e) {
            e.preventDefault();
            var f = c(this);
            c(".top-right-product .product-form").css("opacity", 0.5);
            jQuery
              .post(
                "/cart/add.js",
                f.serialize(),
                function (e) {
                  u("show_cart", "true", 1), window.location.reload(!0);
                },
                "json"
              )
              .fail(function (xhr) {
                // Bug 6: Fehler-Handling fuer Add-to-Cart (z.B. ausverkaufte
                // oder nicht verfuegbare Variante) — sonst keine Rueckmeldung.
                c(".top-right-product .product-form").css("opacity", 1);
                var msg =
                  (xhr && xhr.responseJSON && xhr.responseJSON.description) ||
                  (window.cartStrings && window.cartStrings.error) ||
                  "Der Artikel konnte nicht in den Warenkorb gelegt werden.";
                window.alert(msg);
              });
          }),
          r(),
          c(".one-cart-item input").on("change", function () {
            c(".one-cart-item").css("opacity", "0.5");
            // Aktuelle DOM-Mengen ins pending-Set mergen. Schluessel werden
            // nie entfernt -> eine optimistisch entfernte Position geht nicht
            // verloren, falls vor dem Debounce eine weitere Aenderung kommt.
            c(this)
              .closest(".one-cart-item")
              .parent()
              .find(".one-cart-item")
              .each(function () {
                // Bug 4: ungueltige Eingaben normalisieren, bevor sie an
                // /cart/update.js gehen (sonst 422 + eingefrorener Warenkorb).
                var key = c(this).attr("data-id"),
                  input = c(this).find("input"),
                  qty = parseInt(input.val(), 10);
                isNaN(qty) && (qty = 1);
                qty < 0 && (qty = 0);
                input.val(qty);
                void 0 !== key && (pendingCartUpdates[key] = qty);
              });
            // Bug 7: Mengen-Updates entprellen — schnelle +/- -Klicks loesen
            // sonst ein Rennen paralleler /cart/update.js-Requests aus.
            cartUpdateTimer && clearTimeout(cartUpdateTimer);
            cartUpdateTimer = setTimeout(performCartUpdate, 400);
          }),
          c(window).width() < 575 &&
            (c(".product-section-1,.product-section-2").each(function (e, t) {
              750 < c(t).height() &&
                (c(this).addClass("show-more"),
                c(this).append(
                  c(
                    '<div class="show-more-floating"><a href="#"><span>+</span><span>Mehr anzeigen</span></a></div>'
                  )
                ));
            }),
            c(".show-more-floating a").click(function (e) {
              e.preventDefault(),
                c(this).closest(".show-more").removeClass("show-more"),
                c(this).parent().remove();
            })),
          c("#mobile-menu ul li.has-submenu > a").click(function (e) {
            e.preventDefault();
          }),
          c("#back-to-top").click(function (e) {
            e.preventDefault(), c("body,html").animate({ scrollTop: 0 }, 1e3);
          }),
          c("#scollable li:not(.has-submenu) > a").click(function () {}),
          c("#mobile-menu ul li.has-submenu").click(function (e) {
            e.preventDefault(),
              c(this).toggleClass("active"),
              c(this).find("ul").slideToggle(550);
          }),
          c("#mobile-menu ul li.has-submenu li a").click(function (e) {
            e.stopPropagation();
          }),
          c('.customer.login a[href="#recover"]').click(function (e) {
            e.preventDefault(),
              c("#login-wrapper").css("display", "none"),
              c("#recover-wrapper").css("display", "block");
          }),
          c('.customer.login a[href="#login"]').click(function (e) {
            e.preventDefault(),
              c("#login-wrapper").css("display", "block"),
              c("#recover-wrapper").css("display", "none");
          }),
          0 < c(".customer.login").length &&
            ((e = c("h1#recover")),
            (t = c("h1#recover + div")),
            (i = c("h1#login")),
            (n = c("h1#login + div")),
            c(".customer.login").append(
              c(
                '<div class="row row-spaced"><div id="login-wrapper" class="col-sm-12"></div><div id="recover-wrapper"  class="col-sm-12"></div></div>'
              )
            ),
            c("#login-wrapper").append(i),
            c("#login-wrapper").append(n),
            c("#recover-wrapper").append(e),
            c("#recover-wrapper").append(t)),
          c(".customer").css("display", "block"),
          c(".mobile-trigger-wrapper").click(function (e) {
            e.preventDefault();
            e = c(this).closest("#sort-wrapper,.sort-wrapper");
            c("#sort-wrapper,.sort-wrapper").not(e).removeClass("active"),
              c(e).toggleClass("active");
            e = c(e).find(".dropdown-expanded");
            c(".dropdown-expanded").not(e).slideUp(550), c(e).slideToggle(550);
          }),
          c(".dropdown-expanded a").click(function (e) {
            e.preventDefault();
            e = c(this).attr("href");
            c(this)
              .closest("#sort-wrapper,.sort-wrapper")
              .find("select")
              .val(e)
              .trigger("change"),
              c(this).closest(".dropdown-expanded").slideUp(550),
              c("#sort-wrapper,.sort-wrapper").removeClass("active");
          }),
          0 === c(".one-art-cat.active").length &&
            c(".one-art-cat:first-child").addClass("active"),
          c(".one-variation-selection").click(function (e) {
            e.preventDefault();
            e = c(this).attr("data-value");
            c(".one-variation-selection").removeClass("active"),
              c(this).addClass("active"),
              c('select[name="id"]').val(e);
            e = c(this).find("div:last-child").find("p:last-child").html();
            c(".current-price b").html(e);
          }),
          c(".op-picture").each(function (e, t) {
            0 < c(this).find(".discount-badge").length &&
              0 < c(this).find(".one-tag").length &&
              c(this).addClass("has-both-badges");
          }),
          c(window).width() < 575 /* Fix 2026-05-19 (Bug 12): war < 5 (toter Code) */ &&
            (c(".payment-and-quantity .oci-quantity").html(
              '<select name="quantity"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option></select>'
            ),
            c(".oci-quantity select").wrap(
              c('<span class="select-wrapper"></span>')
            )),
          c(".home-inspirations .one-inspiration").click(function () {
            window.location = c(this).find("a").attr("href");
          }),
          c(".home-newsletter").parent().addClass("overflow-visible"),
          c("#shopify-section-header").addClass("overflow-visible"),
          c("#search-icon").click(function (e) {
            e.preventDefault(),
              c("header").hasClass("show-search") ||
                c("header").addClass("show-search");
          }),
          c("#close-search").click(function (e) {
            e.preventDefault(), c("header").removeClass("show-search");
          }),
          c(".product-nav a").each(function () {
            var e = c(this).attr("href");
            0 === c(e).length && c(this).remove();
          }),
          c("#sort-form select").on("change", function () {
            var e = c(this).val(),
              t = c("#collection-products > div"),
              i = t.children("div");
            "default" === e
              ? i.detach().sort(function (e, t) {
                  (e = parseInt(c(e).data("key"))),
                    (t = parseInt(c(t).data("key")));
                  return t < e ? 1 : -1;
                })
              : "price-asc" === e
              ? i.detach().sort(function (e, t) {
                  (e = parseInt(c(e).data("price"))),
                    (t = parseInt(c(t).data("price")));
                  return t < e ? 1 : -1;
                })
              : i.detach().sort(function (e, t) {
                  (e = parseInt(c(e).data("price"))),
                    (t = parseInt(c(t).data("price")));
                  return t < e ? -1 : 1;
                }),
              t.append(i),
              o();
          }),
          o(),
          c(".oci-plus").click(function (e) {
            e.preventDefault();
            e = parseInt(c(this).parent().find("input").val());
            e++,
              c(this).parent().find("input").val(e),
              c(this).parent().find("input").trigger("change");
          }),
          c(".oci-minus").click(function (e) {
            e.preventDefault();
            e = parseInt(c(this).parent().find("input").val());
            --e < 1 && (e = 1),
              c(this).parent().find("input").val(e),
              c(this).parent().find("input").trigger("change");
          });
        var a = [];
        function l(e) {
          var al = '<svg id="Pfeil" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">\n' +
              '  <rect id="Hintergrund" width="40" height="40" rx="5" transform="translate(40 40) rotate(180)" fill="#f8f8f8"/>\n' +
              '  <g id="Icon_feather-arrow-down-left" data-name="Icon feather-arrow-down-left" transform="translate(23.154 13.846) rotate(45)">\n' +
              '    <path id="Path_9" data-name="Path 9" d="M8.7,8.7H0V0" fill="none" stroke="#797a8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>\n' +
              '  </g>\n' +
              '</svg>\n';

          c(e).slick({
            slidesToShow: 4,
            prevArrow:'<div class="arrow-left">'+al+'</div>',
            nextArrow:'<div class="arrow-right">'+al+'</div>',
            responsive: [
              { breakpoint: 1025, settings: { slidesToShow: 2 } },
              {
                breakpoint: 575,
                settings: {
                  slidesToShow: 1,
                  centerPadding: "20px",
                  centerMode: true,
                  dots: !0,
                },
              },
            ],
          });
        }
        0 < c(".products-slider-section").length &&
          (c(".the-products-slider").each(function (e, t) {
            a.push(c(t).clone());
          }),
          c(".products-slider-section").each(function (e, t) {
            c(this).attr("data-key", e);
          }),
          c(".the-products-slider").each(function () {
            c(this).find(".one-product-slide").slice(8).remove();
          })),
          "true" ===
            (function (e) {
              for (
                var t = e + "=", i = document.cookie.split(";"), n = 0;
                n < i.length;
                n++
              ) {
                for (var o = i[n]; " " == o.charAt(0); ) o = o.substring(1);
                if (0 == o.indexOf(t)) return o.substring(t.length, o.length);
              }
              return "";
            })("show_cart") &&
            (c("#sliding-cart").addClass("active"),
            c("body").addClass("menu-opened"),
            u("show_cart", "false", "1")),
          c("#open-sliding-cart").click(function (e) {
            e.preventDefault(),
              c("#sliding-cart").addClass("active"),
              c("body").addClass("menu-opened");
          }),
          c("#sliding-cart").click(function () {
            c("#sliding-cart").removeClass("active"),
              c("body").removeClass("menu-opened");
          }),
          c("#sliding-cart form").click(function (e) {
            e.stopPropagation();
          }),
          c("#close-sc").click(function (e) {
            // e.preventDefault(),
              c("#sliding-cart").removeClass("active"),
              c("body").removeClass("menu-opened");
          }),
          c("#close-menu, .mobile-menu__overlay").click(function (e) {
            e.preventDefault(),
              c("#mobile-menu").removeClass("active"),
              c("body").removeClass("menu-opened");
          }),
          c(document).on('click', function(e) {
              if (!c(e.target).closest('.menge-text').length && !c(e.target).closest('.info-options').length) {
                  c('.info-options').removeClass('active');
              }
          }),
          c(".menge-text span, .info-options").click(function (e) {
            e.preventDefault();
            if (c(document).width() < 1024) {
              c(this).closest('.menge-text').find('.info-options').toggleClass('active');
            }
          }),
          c("#menu-open").click(function (e) {
            e.preventDefault(),
              c("#mobile-menu").addClass("active"),
              c("body").addClass("menu-opened");
          }),
          c(".products-slider-top a").click(function (e) {
            e.preventDefault();
            var t = c(this).attr("data-key"),
              i = c(this).closest(".products-slider-section");
            c(i).find(".products-slider-top a").removeClass("active"),
              c(i)
                .find('.products-slider-top a[data-key="' + t + '"]')
                .addClass("active");
            (e = c(this).closest(".products-slider-section").attr("data-key")),
              (e = c(a[parseInt(e)]).clone());
            c(i).find(".the-products-slider").after(e),
              c(i).find(".the-products-slider").first().remove(),
              "all" !== t &&
                c(e)
                  .find(".one-product-slide")
                  .not(".collection-" + t)
                  .remove(),
              c(e).find(".one-product-slide").slice(8).remove(),
              l(e);
          }),
          0 === c("#team").length && c("#about-nav-1").remove(),
          0 === c("#production").length && c("#about-nav-2").remove(),
          0 === c("#quality").length && c("#about-nav-3").remove(),
          0 === c("#ap-last").length && c("#about-nav-4").remove(),
          1024 < c(window).width()
            ? (c("#about-page-nav").sticky({ topSpacing: 0 }),
              c("#filters-wrapper-2:not(.articles-categories)").stick_in_parent({
                offset_top: 150,
              }))
            : c("#about-page-nav").sticky({ topSpacing: 0 }),
          c("#about-page-nav").on("sticky-start", function () {
            c("header").fadeOut(550);
          }),
          c("#about-page-nav").on("sticky-end", function () {
            c("header").fadeIn(550);
          }),
          c("#about-page-nav a,.product-nav a").click(function (e) {
            e.preventDefault();
            var t = c(this).attr("href"),
              e = 60;
            1024 < c(window).width() && (e = 150),
              c(t) &&
                c("body,html").animate({ scrollTop: c(t).offset().top - e });
          }),
          l(".the-products-slider"),
          c(".one-product-question").click(function (e) {
            e.preventDefault();
            var t = c(this).parent(),
              e = c(this)
                .closest(".product-faq")
                .find(".one-product-faq")
                .not(t);
            c(t).addClass("active"),
              c(e).removeClass("active"),
              c(t).find(".one-product-answer").slideDown(550),
              c(e).find(".one-product-answer").slideUp(550);
          }),
          0 < c(".one-product-question").length &&
            c(".one-product-faq")
              .find(".one-product-question")
              .first()
              .trigger("dontclick"),
          c(".home-testimonials-slider").slick({
            slidesToShow: 2,
            responsive: [
              {
                breakpoint: 575,
                settings: { slidesToShow: 1, dots: !0, arrows: !1 },
              },
            ],
          }),

          c(".p-test-2-slider").slick({
            slidesToShow: 3,
            responsive: [
              {
                breakpoint: 991,
                settings: { slidesToShow: 2, arrows: !1, dots: !0 },
              },
              {
                breakpoint: 575,
                settings: { slidesToShow: 1, arrows: !1, dots: !0 },
              },
            ],
          }),
          c(".home-quotes .row,.home-features .row").slick({
            responsive: [
              { breakpoint: 1e5, settings: "unslick" },
              {
                breakpoint: 0,
                settings: { adaptiveHeight: !0, arrows: !0, dots: !0 },
              },
            ],
          });
      });
  })(jQuery),
  (function (e) {
    var t = (function (n, p, r) {
      "use strict";
      var f, h;
      if (
        ((function () {
          var e,
            t = {
              lazyClass: "lazyload",
              loadedClass: "lazyloaded",
              loadingClass: "lazyloading",
              preloadClass: "lazypreload",
              errorClass: "lazyerror",
              autosizesClass: "lazyautosizes",
              fastLoadedClass: "ls-is-cached",
              iframeLoadMode: 0,
              srcAttr: "data-src",
              srcsetAttr: "data-srcset",
              sizesAttr: "data-sizes",
              minSize: 40,
              customMedia: {},
              init: !0,
              expFactor: 1.5,
              hFac: 0.8,
              loadMode: 2,
              loadHidden: !0,
              ricTimeout: 0,
              throttleDelay: 125,
            };
          for (e in ((h = n.lazySizesConfig || n.lazysizesConfig || {}), t))
            e in h || (h[e] = t[e]);
        })(),
        !p || !p.getElementsByClassName)
      )
        return { init: function () {}, cfg: h, noSupport: !0 };
      function d(e, t) {
        le(e, t) ||
          e.setAttribute("class", (e[Z]("class") || "").trim() + " " + t);
      }
      function u(e, t) {
        (t = le(e, t)) &&
          e.setAttribute("class", (e[Z]("class") || "").replace(t, " "));
      }
      function g(e, t) {
        var i;
        !J && (i = n.picturefill || h.pf)
          ? (t && t.src && !e[Z]("srcset") && e.setAttribute("srcset", t.src),
            i({ reevaluate: !0, elements: [e] }))
          : t && t.src && (e.src = t.src);
      }
      function e(i, e) {
        return e
          ? function () {
              fe(i);
            }
          : function () {
              var e = this,
                t = arguments;
              fe(function () {
                i.apply(e, t);
              });
            };
      }
      function t(e) {
        function t() {
          var e = r.now() - n;
          e < 99 ? te(t, 99 - e) : (ne || o)(o);
        }
        var i,
          n,
          o = function () {
            (i = null), e();
          };
        return function () {
          (n = r.now()), (i = i || te(t, 99));
        };
      }
      function i() {
        !i.i && p.getElementsByClassName && ((i.i = !0), ge._(), he._());
      }
      var o,
        s,
        a,
        v,
        m,
        y,
        w,
        l,
        b,
        k,
        x,
        T,
        C,
        S,
        A,
        c,
        E,
        $,
        z,
        D,
        L,
        N,
        j,
        H,
        O,
        P,
        M,
        q,
        W,
        I,
        _,
        F,
        R,
        B,
        U,
        X,
        Y,
        Q,
        V,
        G = p.documentElement,
        J = n.HTMLPictureElement,
        K = "addEventListener",
        Z = "getAttribute",
        ee = n[K].bind(n),
        te = n.setTimeout,
        ie = n.requestAnimationFrame || te,
        ne = n.requestIdleCallback,
        oe = /^picture$/i,
        re = ["load", "error", "lazyincluded", "_lazyloaded"],
        se = {},
        ae = Array.prototype.forEach,
        le = function (e, t) {
          return (
            se[t] || (se[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")),
            se[t].test(e[Z]("class") || "") && se[t]
          );
        },
        ce = function (t, i, e) {
          var n = e ? K : "removeEventListener";
          e && ce(t, i),
            re.forEach(function (e) {
              t[n](e, i);
            });
        },
        de = function (e, t, i, n, o) {
          var r = p.createEvent("Event");
          return (
            ((i = i || {}).instance = f),
            r.initEvent(t, !n, !o),
            (r.detail = i),
            e.dispatchEvent(r),
            r
          );
        },
        ue = function (e, t) {
          return (getComputedStyle(e, null) || {})[t];
        },
        pe = function (e, t, i) {
          for (
            i = i || e.offsetWidth;
            i < h.minSize && t && !e._lazysizesWidth;

          )
            (i = t.offsetWidth), (t = t.parentNode);
          return i;
        },
        fe = ((Q = []), (V = Y = []), (Se._lsFlush = Ce), Se),
        he =
          ((N = /^img$/i),
          (j = /^iframe$/i),
          (H = "onscroll" in n && !/(gle|ing)bot/.test(navigator.userAgent)),
          (M = -1),
          (q = function (e) {
            return (
              (A = null == A ? "hidden" == ue(p.body, "visibility") : A) ||
              !(
                "hidden" == ue(e.parentNode, "visibility") &&
                "hidden" == ue(e, "visibility")
              )
            );
          }),
          (c = ye),
          ($ = P = O = 0),
          (z = h.throttleDelay),
          (D = h.ricTimeout),
          (L =
            ne && 49 < D
              ? function () {
                  ne(we, { timeout: D }),
                    D !== h.ricTimeout && (D = h.ricTimeout);
                }
              : e(function () {
                  te(we);
                }, !0)),
          (I = e(be)),
          (_ = function (e) {
            I({ target: e.target });
          }),
          (F = e(function (t, e, i, n, o) {
            var r, s, a, l, c;
            (a = de(t, "lazybeforeunveil", e)).defaultPrevented ||
              (n && (i ? d(t, h.autosizesClass) : t.setAttribute("sizes", n)),
              (r = t[Z](h.srcsetAttr)),
              (i = t[Z](h.srcAttr)),
              o && (s = (c = t.parentNode) && oe.test(c.nodeName || "")),
              (l = e.firesLoad || ("src" in t && (r || i || s))),
              (a = { target: t }),
              d(t, h.loadingClass),
              l && (clearTimeout(y), (y = te(me, 2500)), ce(t, _, !0)),
              s && ae.call(c.getElementsByTagName("source"), ke),
              r
                ? t.setAttribute("srcset", r)
                : i &&
                  !s &&
                  (j.test(t.nodeName)
                    ? ((n = i),
                      0 ==
                      (c =
                        (e = t).getAttribute("data-load-mode") ||
                        h.iframeLoadMode)
                        ? e.contentWindow.location.replace(n)
                        : 1 == c && (e.src = n))
                    : (t.src = i)),
              o && (r || s) && g(t, { src: i })),
              t._lazyRace && delete t._lazyRace,
              u(t, h.lazyClass),
              fe(function () {
                var e = t.complete && 1 < t.naturalWidth;
                (l && !e) ||
                  (e && d(t, h.fastLoadedClass),
                  be(a),
                  (t._lazyCache = !0),
                  te(function () {
                    "_lazyCache" in t && delete t._lazyCache;
                  }, 9)),
                  "lazy" == t.loading && P--;
              }, !0);
          })),
          (B = t(function () {
            (h.loadMode = 3), W();
          })),
          {
            _: function () {
              (l = r.now()),
                (f.elements = p.getElementsByClassName(h.lazyClass)),
                (v = p.getElementsByClassName(
                  h.lazyClass + " " + h.preloadClass
                )),
                ee("scroll", W, !0),
                ee("resize", W, !0),
                ee("pageshow", function (e) {
                  var t;
                  !e.persisted ||
                    ((t = p.querySelectorAll("." + h.loadingClass)).length &&
                      t.forEach &&
                      ie(function () {
                        t.forEach(function (e) {
                          e.complete && R(e);
                        });
                      }));
                }),
                n.MutationObserver
                  ? new MutationObserver(W).observe(G, {
                      childList: !0,
                      subtree: !0,
                      attributes: !0,
                    })
                  : (G[K]("DOMNodeInserted", W, !0),
                    G[K]("DOMAttrModified", W, !0),
                    setInterval(W, 999)),
                ee("hashchange", W, !0),
                [
                  "focus",
                  "mouseover",
                  "click",
                  "load",
                  "transitionend",
                  "animationend",
                ].forEach(function (e) {
                  p[K](e, W, !0);
                }),
                /d$|^c/.test(p.readyState)
                  ? Te()
                  : (ee("load", Te), p[K]("DOMContentLoaded", W), te(Te, 2e4)),
                f.elements.length ? (ye(), fe._lsFlush()) : W();
            },
            checkElems: (W = function (e) {
              var t;
              (e = !0 === e) && (D = 33),
                E ||
                  ((E = !0),
                  (t = z - (r.now() - $)) < 0 && (t = 0),
                  e || t < 9 ? L() : te(L, t));
            }),
            unveil: (R = function (e) {
              var t, i, n, o;
              e._lazyRace ||
                (((!(o =
                  "auto" ==
                  (n =
                    (i = N.test(e.nodeName)) &&
                    (e[Z](h.sizesAttr) || e[Z]("sizes")))) &&
                  m) ||
                  !i ||
                  (!e[Z]("src") && !e.srcset) ||
                  e.complete ||
                  le(e, h.errorClass) ||
                  !le(e, h.lazyClass)) &&
                  ((t = de(e, "lazyunveilread").detail),
                  o && ge.updateElem(e, !0, e.offsetWidth),
                  (e._lazyRace = !0),
                  P++,
                  F(e, t, o, n, i)));
            }),
            _aLSL: xe,
          }),
        ge =
          ((s = e(function (e, t, i, n) {
            var o, r, s;
            if (
              ((e._lazysizesWidth = n),
              e.setAttribute("sizes", (n += "px")),
              oe.test(t.nodeName || ""))
            )
              for (
                r = 0, s = (o = t.getElementsByTagName("source")).length;
                r < s;
                r++
              )
                o[r].setAttribute("sizes", n);
            i.detail.dataAttr || g(e, i.detail);
          })),
          {
            _: function () {
              (o = p.getElementsByClassName(h.autosizesClass)), ee("resize", a);
            },
            checkElems: (a = t(function () {
              var e,
                t = o.length;
              if (t) for (e = 0; e < t; e++) ve(o[e]);
            })),
            updateElem: ve,
          });
      function ve(e, t, i) {
        var n = e.parentNode;
        n &&
          ((i = pe(e, n, i)),
          (t = de(e, "lazybeforesizes", { width: i, dataAttr: !!t }))
            .defaultPrevented ||
            ((i = t.detail.width) && i !== e._lazysizesWidth && s(e, n, t, i)));
      }
      function me(e) {
        P--, (e && !(P < 0) && e.target) || (P = 0);
      }
      function ye() {
        var e,
          t,
          i,
          n,
          o,
          r,
          s,
          a,
          l,
          c,
          d,
          u = f.elements;
        if ((w = h.loadMode) && P < 8 && (e = u.length)) {
          for (t = 0, M++; t < e; t++)
            if (u[t] && !u[t]._lazyRace)
              if (!H || (f.prematureUnveil && f.prematureUnveil(u[t]))) R(u[t]);
              else if (
                (((s = u[t][Z]("data-expand")) && (o = +s)) || (o = O),
                l ||
                  ((l =
                    !h.expand || h.expand < 1
                      ? 500 < G.clientHeight && 500 < G.clientWidth
                        ? 500
                        : 370
                      : h.expand),
                  (c = (f._defEx = l) * h.expFactor),
                  (d = h.hFac),
                  (A = null),
                  O < c && P < 1 && 2 < M && 2 < w && !p.hidden
                    ? ((O = c), (M = 0))
                    : (O = 1 < w && 1 < M && P < 6 ? l : 0)),
                a !== o &&
                  ((b = innerWidth + o * d),
                  (k = innerHeight + o),
                  (r = -1 * o),
                  (a = o)),
                (c = u[t].getBoundingClientRect()),
                (S = c.bottom) >= r &&
                  (x = c.top) <= k &&
                  (C = c.right) >= r * d &&
                  (T = c.left) <= b &&
                  (S || C || T || x) &&
                  (h.loadHidden || q(u[t])) &&
                  ((m && P < 3 && !s && (w < 3 || M < 4)) ||
                    (function (e, t) {
                      var i,
                        n = e,
                        o = q(e);
                      for (
                        x -= t, S += t, T -= t, C += t;
                        o && (n = n.offsetParent) && n != p.body && n != G;

                      )
                        (o = 0 < (ue(n, "opacity") || 1)) &&
                          "visible" != ue(n, "overflow") &&
                          ((i = n.getBoundingClientRect()),
                          (o =
                            C > i.left &&
                            T < i.right &&
                            S > i.top - 1 &&
                            x < i.bottom + 1));
                      return o;
                    })(u[t], o)))
              ) {
                if ((R(u[t]), (n = !0), 9 < P)) break;
              } else
                !n &&
                  m &&
                  !i &&
                  P < 4 &&
                  M < 4 &&
                  2 < w &&
                  (v[0] || h.preloadAfterLoad) &&
                  (v[0] ||
                    (!s &&
                      (S || C || T || x || "auto" != u[t][Z](h.sizesAttr)))) &&
                  (i = v[0] || u[t]);
          i && !n && R(i);
        }
      }
      function we() {
        (E = !1), ($ = r.now()), c();
      }
      function be(e) {
        var t = e.target;
        t._lazyCache
          ? delete t._lazyCache
          : (me(e),
            d(t, h.loadedClass),
            u(t, h.loadingClass),
            ce(t, _),
            de(t, "lazyloaded"));
      }
      function ke(e) {
        var t,
          i = e[Z](h.srcsetAttr);
        (t = h.customMedia[e[Z]("data-media") || e[Z]("media")]) &&
          e.setAttribute("media", t),
          i && e.setAttribute("srcset", i);
      }
      function xe() {
        3 == h.loadMode && (h.loadMode = 2), B();
      }
      function Te() {
        m ||
          (r.now() - l < 999
            ? te(Te, 999)
            : ((m = !0), (h.loadMode = 3), W(), ee("scroll", xe, !0)));
      }
      function Ce() {
        var e = V;
        for (V = Y.length ? Q : Y, X = !(U = !0); e.length; ) e.shift()();
        U = !1;
      }
      function Se(e, t) {
        U && !t
          ? e.apply(this, arguments)
          : (V.push(e), X || ((X = !0), (p.hidden ? te : ie)(Ce)));
      }
      return (
        te(function () {
          h.init && i();
        }),
        (f = {
          cfg: h,
          autoSizer: ge,
          loader: he,
          init: i,
          uP: g,
          aC: d,
          rC: u,
          hC: le,
          fire: de,
          gW: pe,
          rAF: fe,
        })
      );
    })(e, e.document, Date);
    (e.lazySizes = t),
      "object" == typeof module && module.exports && (module.exports = t);
  })("undefined" != typeof window ? window : {}),
  (function (e, t) {
    function i() {
      t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
    }
    (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"))
        : "function" == typeof define && define.amd
        ? define(["lazysizes"], t)
        : e.lazySizes
        ? i()
        : e.addEventListener("lazyunveilread", i, !0);
  })(window, function (f, c, h) {
    "use strict";
    var g,
      v,
      n = h.cfg,
      d = { string: 1, number: 1 },
      m = /^\-*\+*\d+\.*\d*$/,
      y = /^picture$/i,
      w = /\s*\{\s*width\s*\}\s*/i,
      u = /\s*\{\s*height\s*\}\s*/i,
      b = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
      k = /^\[.*\]|\{.*\}$/,
      x = /^(?:auto|\d+(px)?)$/,
      p = c.createElement("a"),
      e = c.createElement("img"),
      T = "srcset" in e && !("sizes" in e),
      C = !!f.HTMLPictureElement && !T;
    function S(e, t, i) {
      var o,
        r,
        s,
        n = 0,
        a = 0,
        l = i;
      if (e) {
        if ("container" === t.ratio) {
          for (n = l.scrollWidth, a = l.scrollHeight; !((n && a) || l === c); )
            (n = (l = l.parentNode).scrollWidth), (a = l.scrollHeight);
          n && a && (t.ratio = t.traditionalRatio ? a / n : n / a);
        }
        (o = e),
          (r = t),
          ((s = []).srcset = []),
          r.absUrl && (p.setAttribute("href", o), (o = p.href)),
          (o = ((r.prefix || "") + o + (r.postfix || "")).replace(
            b,
            function (e, t) {
              return d[typeof r[t]] ? r[t] : e;
            }
          )),
          r.widths.forEach(function (e) {
            var t = r.widthmap[e] || e,
              i = r.aspectratio || r.ratio,
              n = !r.aspectratio && v.traditionalRatio,
              i = {
                u: o
                  .replace(w, t)
                  .replace(
                    u,
                    i ? (n ? Math.round(e * i) : Math.round(e / i)) : ""
                  ),
                w: e,
              };
            s.push(i), s.srcset.push((i.c = i.u + " " + e + "w"));
          }),
          ((e = s).isPicture = t.isPicture),
          T && "IMG" == i.nodeName.toUpperCase()
            ? i.removeAttribute(g.srcsetAttr)
            : i.setAttribute(g.srcsetAttr, e.srcset.join(", ")),
          Object.defineProperty(i, "_lazyrias", { value: e, writable: !0 });
      }
    }
    function A(e) {
      return (
        e.getAttribute(e.getAttribute("data-srcattr") || v.srcAttr) ||
        e.getAttribute(g.srcsetAttr) ||
        e.getAttribute(g.srcAttr) ||
        e.getAttribute("data-pfsrcset") ||
        ""
      );
    }
    !(function () {
      var e,
        t = {
          prefix: "",
          postfix: "",
          srcAttr: "data-src",
          absUrl: !1,
          modifyOptions: function () {},
          widthmap: {},
          ratio: !1,
          traditionalRatio: !1,
          aspectratio: !1,
        };
      for (e in ((g = h && h.cfg).supportsType ||
        (g.supportsType = function (e) {
          return !e;
        }),
      g.rias || (g.rias = {}),
      "widths" in (v = g.rias) ||
        ((v.widths = []),
        (function (e) {
          for (var t, i = 0; !t || t < 3e3; )
            30 < (i += 5) && (i += 1), e.push((t = 36 * i));
        })(v.widths)),
      t))
        e in v || (v[e] = t[e]);
    })(),
      addEventListener(
        "lazybeforesizes",
        function (e) {
          if (e.detail.instance == h) {
            var t,
              i,
              n,
              o,
              r,
              s,
              a,
              l,
              c,
              d = e.target;
            if (
              e.detail.dataAttr &&
              !e.defaultPrevented &&
              !v.disabled &&
              (a = d.getAttribute(g.sizesAttr) || d.getAttribute("sizes")) &&
              x.test(a)
            ) {
              var u,
                p = A(d),
                e = (function (o, e) {
                  function i(e, t) {
                    var i,
                      n = o.getAttribute("data-" + e);
                    if (
                      (n ||
                        ((i = r.getPropertyValue("--ls-" + e)) &&
                          (n = i.trim())),
                      n)
                    ) {
                      if ("true" == n) n = !0;
                      else if ("false" == n) n = !1;
                      else if (m.test(n)) n = parseFloat(n);
                      else if ("function" == typeof v[e]) n = v[e](o, n);
                      else if (k.test(n))
                        try {
                          n = JSON.parse(n);
                        } catch (e) {}
                      s[e] = n;
                    } else
                      e in v && "function" != typeof v[e]
                        ? (s[e] = v[e])
                        : t && "function" == typeof v[e] && (s[e] = v[e](o, n));
                  }
                  var t,
                    r = f.getComputedStyle(o),
                    n = o.parentNode,
                    s = { isPicture: !(!n || !y.test(n.nodeName || "")) };
                  for (t in v) i(t);
                  return (
                    e.replace(b, function (e, t) {
                      t in s || i(t, !0);
                    }),
                    s
                  );
                })((u = d), p);
              if (
                (v.modifyOptions.call(u, { target: u, details: e, detail: e }),
                h.fire(u, "lazyriasmodifyoptions", e),
                (l = w.test((t = e).prefix) || w.test(t.postfix)),
                t.isPicture && (i = d.parentNode))
              )
                for (
                  o = 0, r = (n = i.getElementsByTagName("source")).length;
                  o < r;
                  o++
                )
                  (l || w.test((s = A(n[o])))) && (S(s, t, n[o]), (c = !0));
              l || w.test(p)
                ? (S(p, t, d), (c = !0))
                : c &&
                  (((p = []).srcset = []),
                  (p.isPicture = !0),
                  Object.defineProperty(d, "_lazyrias", {
                    value: p,
                    writable: !0,
                  })),
                c &&
                  (C
                    ? d.removeAttribute(g.srcAttr)
                    : "auto" != a &&
                      ((a = { width: parseInt(a, 10) }),
                      E({ target: d, detail: a })));
            }
          }
        },
        !0
      );
    var o,
      E =
        ((o = function (e) {
          var t, i;
          e.detail.instance == h &&
            ((i = e.target),
            T || !(f.respimage || f.picturefill || n.pf)
              ? ("_lazyrias" in i || (e.detail.dataAttr && $(i, !0))) &&
                (t = (function (e, t) {
                  var i,
                    n,
                    o,
                    r,
                    s,
                    a = e._lazyrias;
                  if (a.isPicture && f.matchMedia)
                    for (
                      n = 0,
                        o = (i = e.parentNode.getElementsByTagName("source"))
                          .length;
                      n < o;
                      n++
                    )
                      if (
                        $(i[n]) &&
                        !i[n].getAttribute("type") &&
                        (!(r = i[n].getAttribute("media")) ||
                          (matchMedia(r) || {}).matches)
                      ) {
                        a = i[n]._lazyrias;
                        break;
                      }
                  return (
                    (!a.w || a.w < t) &&
                      ((a.w = t),
                      (a.d =
                        ((e = e),
                        (s = f.devicePixelRatio || 1),
                        (e = h.getX && h.getX(e)),
                        Math.min(e || s, 2.4, s))),
                      (s = (function (e) {
                        for (
                          var t, i, n = e.length, o = e[n - 1], r = 0;
                          r < n;
                          r++
                        )
                          if ((((o = e[r]).d = o.w / e.w), o.d >= e.d)) {
                            !o.cached &&
                              (t = e[r - 1]) &&
                              t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
                              ((i = Math.pow(t.d - 0.6, 1.6)),
                              t.cached && (t.d += 0.15 * i),
                              t.d + (o.d - e.d) * i > e.d && (o = t));
                            break;
                          }
                        return o;
                      })(a.sort(l)))),
                    s
                  );
                })(i, e.detail.width)) &&
                t.u &&
                i._lazyrias.cur != t.u &&
                ((i._lazyrias.cur = t.u),
                (t.cached = !0),
                h.rAF(function () {
                  i.setAttribute(g.srcAttr, t.u), i.setAttribute("src", t.u);
                }))
              : c.removeEventListener("lazybeforesizes", o));
        }),
        C ? (o = function () {}) : addEventListener("lazybeforesizes", o),
        o);
    function l(e, t) {
      return e.w - t.w;
    }
    function $(e, t) {
      var i;
      return (
        !e._lazyrias &&
          h.pWS &&
          (i = h.pWS(e.getAttribute(g.srcsetAttr || ""))).length &&
          (Object.defineProperty(e, "_lazyrias", { value: i, writable: !0 }),
          t &&
            e.parentNode &&
            (i.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
        e._lazyrias
      );
    }
  }),
  (function (e, t) {
    function i() {
      t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
    }
    (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"))
        : "function" == typeof define && define.amd
        ? define(["lazysizes"], t)
        : e.lazySizes
        ? i()
        : e.addEventListener("lazyunveilread", i, !0);
  })(window, function (e, l, c) {
    "use strict";
    var d, u, p, f, n, o, r, h, g;
    e.addEventListener &&
      ((d = c.cfg),
      (u = /\s+/g),
      (p = /\s*\|\s+|\s+\|\s*/g),
      (f = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/),
      (n = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/),
      (o = /\(|\)|'/),
      (r = { contain: 1, cover: 1 }),
      (h = function (e, t) {
        var i;
        t &&
          ((i = t.match(n)) && i[1]
            ? e.setAttribute("type", i[1])
            : e.setAttribute("media", d.customMedia[t] || t));
      }),
      (g = function (e) {
        var t, i;
        e.target._lazybgset &&
          ((i = (t = e.target)._lazybgset),
          (e = t.currentSrc || t.src) &&
            ((e = c.fire(i, "bgsetproxy", {
              src: e,
              useSrc: o.test(e) ? JSON.stringify(e) : e,
            })).defaultPrevented ||
              (i.style.backgroundImage = "url(" + e.detail.useSrc + ")")),
          t._lazybgsetLoading &&
            (c.fire(i, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading));
      }),
      addEventListener("lazybeforeunveil", function (e) {
        var t, i, n, o, r, s, a;
        !e.defaultPrevented &&
          (r = e.target.getAttribute("data-bgset")) &&
          ((s = e.target),
          ((a = l.createElement("img")).alt = ""),
          (a._lazybgsetLoading = !0),
          (e.detail.firesLoad = !0),
          (t = r),
          (i = s),
          (e = a),
          (n = l.createElement("picture")),
          (o = i.getAttribute(d.sizesAttr)),
          (r = i.getAttribute("data-ratio")),
          (s = i.getAttribute("data-optimumx")),
          i._lazybgset &&
            i._lazybgset.parentNode == i &&
            i.removeChild(i._lazybgset),
          Object.defineProperty(e, "_lazybgset", { value: i, writable: !0 }),
          Object.defineProperty(i, "_lazybgset", { value: n, writable: !0 }),
          (t = t.replace(u, " ").split(p)),
          (n.style.display = "none"),
          (e.className = d.lazyClass),
          1 != t.length || o || (o = "auto"),
          t.forEach(function (e) {
            var t,
              i = l.createElement("source");
            o && "auto" != o && i.setAttribute("sizes", o),
              (t = e.match(f))
                ? (i.setAttribute(d.srcsetAttr, t[1]), h(i, t[2]), h(i, t[3]))
                : i.setAttribute(d.srcsetAttr, e),
              n.appendChild(i);
          }),
          o &&
            (e.setAttribute(d.sizesAttr, o),
            i.removeAttribute(d.sizesAttr),
            i.removeAttribute("sizes")),
          s && e.setAttribute("data-optimumx", s),
          r && e.setAttribute("data-ratio", r),
          n.appendChild(e),
          i.appendChild(n),
          setTimeout(function () {
            c.loader.unveil(a),
              c.rAF(function () {
                c.fire(a, "_lazyloaded", {}, !0, !0),
                  a.complete && g({ target: a });
              });
          }));
      }),
      l.addEventListener("load", g, !0),
      e.addEventListener(
        "lazybeforesizes",
        function (e) {
          var t, i, n;
          e.detail.instance == c &&
            e.target._lazybgset &&
            e.detail.dataAttr &&
            ((i = e.target._lazybgset),
            (n = (
              getComputedStyle(i) || { getPropertyValue: function () {} }
            ).getPropertyValue("background-size")),
            !r[n] && r[i.style.backgroundSize] && (n = i.style.backgroundSize),
            r[(t = n)] &&
              ((e.target._lazysizesParentFit = t),
              c.rAF(function () {
                e.target.setAttribute("data-parent-fit", t),
                  e.target._lazysizesParentFit &&
                    delete e.target._lazysizesParentFit;
              })));
        },
        !0
      ),
      l.documentElement.addEventListener("lazybeforesizes", function (e) {
        var t;
        !e.defaultPrevented &&
          e.target._lazybgset &&
          e.detail.instance == c &&
          (e.detail.width =
            ((t = e.target._lazybgset),
            (e = c.gW(t, t.parentNode)),
            (!t._lazysizesWidth || e > t._lazysizesWidth) &&
              (t._lazysizesWidth = e),
            t._lazysizesWidth));
      }));
  }),
  (function (e, t) {
    var i;
    e &&
      ((i = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
      }),
      (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"))
        : "function" == typeof define && define.amd
        ? define(["lazysizes"], t)
        : e.lazySizes
        ? i()
        : e.addEventListener("lazyunveilread", i, !0));
  })("undefined" != typeof window ? window : 0, function (o, g, v) {
    "use strict";
    function r(e, t, i, n) {
      function o() {
        a &&
          v.rAF(function () {
            v.rC(t, "ls-blur-up-is-loading");
            try {
              a.parentNode.removeChild(a);
            } catch (e) {}
            a = null;
          });
      }
      function r(e) {
        p++, (d = e || d), e ? o() : 1 < p && setTimeout(o, 5e3);
      }
      function s() {
        t.removeEventListener("load", s),
          t.removeEventListener("error", s),
          a &&
            v.rAF(function () {
              a && v.aC(a, "ls-original-loaded");
            }),
          "always" != n && (!c || Date.now() - u < 66) ? r(!0) : r();
      }
      var a,
        l,
        c = !1,
        d = !1,
        u = "always" == n ? 0 : Date.now(),
        p = 0,
        f = (e || t).parentNode;
      i &&
        ((l = function (e) {
          (c = !0),
            (a = a || e.target),
            v.rAF(function () {
              v.rC(t, "ls-blur-up-is-loading"),
                a && v.aC(a, "ls-blur-up-loaded");
            }),
            a &&
              (a.removeEventListener("load", l),
              a.removeEventListener("error", l));
        }),
        (a = g.createElement("img")).addEventListener("load", l),
        a.addEventListener("error", l),
        (a.className = "ls-blur-up-img"),
        (a.cssText = t.cssText),
        (a.src = i),
        (a.alt = ""),
        a.setAttribute("aria-hidden", "true"),
        f.insertBefore(a, (e || t).nextSibling),
        "always" != n &&
          ((a.style.visibility = "hidden"),
          v.rAF(function () {
            a &&
              setTimeout(function () {
                a &&
                  v.rAF(function () {
                    !d && a && (a.style.visibility = "");
                  });
              }, v.cfg.blurupCacheDelay || 33);
          }))),
        t.addEventListener("load", s),
        t.addEventListener("error", s),
        v.aC(t, "ls-blur-up-is-loading");
      function h(e) {
        f == e.target &&
          (v.aC(a || t, "ls-inview"),
          r(),
          f.removeEventListener("lazybeforeunveil", h));
      }
      f.getAttribute("data-expand") || f.setAttribute("data-expand", -1),
        f.addEventListener("lazybeforeunveil", h),
        v.aC(f, v.cfg.lazyClass);
    }
    var s = [].slice,
      n = /blur-up["']*\s*:\s*["']*(always|auto)/,
      a = /image\/(jpeg|png|gif|svg\+xml)/;
    o.addEventListener("lazybeforeunveil", function (e) {
      var t,
        n,
        i = e.detail;
      i.instance == v &&
        i.blurUp &&
        r(
          (e =
            "PICTURE" != (e = (t = e.target).parentNode).nodeName ? null : e),
          t,
          ((t = t),
          ((e = e) ? s.call(e.querySelectorAll("source, img")) : [t]).forEach(
            function (e) {
              var t, i;
              n ||
                !(t = e.getAttribute("data-lowsrc")) ||
                ((e =
                  (i = e).getAttribute("data-media") ||
                  i.getAttribute("media")),
                ((i = i.getAttribute("type")) && !a.test(i)) ||
                  (e && !o.matchMedia(v.cfg.customMedia[e] || e).matches)) ||
                (n = t);
            }
          ),
          n ||
            "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),
          i.blurUp
        );
    }),
      o.addEventListener("lazyunveilread", function (e) {
        var t,
          i = e.detail;
        i.instance == v &&
          ((t = e.target),
          ((e = (
            getComputedStyle(t, null) || { fontFamily: "" }
          ).fontFamily.match(n)) ||
            t.getAttribute("data-lowsrc")) &&
            (i.blurUp = (e && e[1]) || v.cfg.blurupMode || "always"));
      });
  });

